/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type RemoteUnlockInput = {
  accessPointId: number,
  siteId: number,
  userId: number,
};

export type IssueGymKeyAccessCardInput = {
  memberId: number,
  siteLocationId: number,
  userId: number,
  accessCardUID: string,
};

export type ItemInput = {
  type?: string | null,
  price?: number | null,
};

export type Item = {
  __typename: "Item",
  id: string,
  type: string,
  price?: number | null,
};

export type UserInput = {
  username?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  isActive?: boolean | null,
  language?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
  appVersion?: string | null,
  profilePicturePath?: string | null,
  isProfilePicVerified?: boolean | null,
  isMobileAppUser?: boolean | null,
  isAdministrator?: boolean | null,
  isDeleted?: boolean | null,
  isSystemUser?: boolean | null,
  defaultLocationDetectionMethod?: string | null,
  id?: number | null,
};

export type User = {
  __typename: "User",
  id: number,
  username: string,
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  isActive?: boolean | null,
  language?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  appVersion?: string | null,
  profilePicturePath?: string | null,
  isProfilePicVerified?: boolean | null,
  isMobileAppUser?: boolean | null,
  isAdministrator?: boolean | null,
  isDeleted?: boolean | null,
  isSystemUser?: boolean | null,
  isMobileAppDisabled?: boolean | null,
  isJustTapRevoked?: boolean | null,
  defaultLocationDetectionMethod: string,
  isMoreInfoRequested?: boolean | null,
  memberId?: number | null,
};

export type DeviceHistoryInput = {
  userId: number,
  appVersion: string,
  macAddress: string,
  uniqueId: string,
  model?: string | null,
  manufacturer?: string | null,
  isCameraPresent?: boolean | null,
  locale?: string | null,
  type?: string | null,
  timeZone?: string | null,
  signedUpStatus?: boolean | null,
  country?: string | null,
  baseOs?: string | null,
  lastModifiedBy?: number | null,
};

export type DeviceHistory = {
  __typename: "DeviceHistory",
  id: number,
  userId: number,
  appVersion: string,
  macAddress: string,
  uniqueId: string,
  model?: string | null,
  manufacturer?: string | null,
  isActive?: boolean | null,
  isCameraPresent?: boolean | null,
  locale?: string | null,
  type?: string | null,
  timeZone?: string | null,
  signedUpStatus?: boolean | null,
  country?: string | null,
  baseOs?: string | null,
  createdDate?: string | null,
  lastModifiedBy: number,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type WebGymChain = {
  __typename: "WebGymChain",
  id?: number | null,
  providerId?: number | null,
  customerSiteId?: string | null,
  customerName?: string | null,
  customerContactPerson?: string | null,
  customerPhone?: string | null,
  supportPhone?: string | null,
  maximumNegativeBalance?: number | null,
  customerEmail?: string | null,
  customerAddress?: string | null,
  status?: string | null,
  membershipsImported?: boolean | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
  createdDate?: string | null,
  lastModifiedDate?: string | null,
  lastImportedDate?: string | null,
  imageUrl?: string | null,
  isDeleted?: boolean | null,
  arxReferenceId?: string | null,
  providerConnected?: boolean | null,
  isSodvinCompany?: boolean | null,
  gymCount?: number | null,
  allowConvertingAccessCards?: boolean | null,
  createMindbodyClientAccessCards?: boolean | null,
  processBookings?: boolean | null,
  processSales?: boolean | null,
  processAppointments?: boolean | null,
  fetchAccountBalance?: boolean | null,
  kisiApiKey?: string | null,
  kisiNightlySyncApiKey?: string | null,
  gymKeyChainId?: string | null,
  hardwareProvider?: HardwareProvider | null,
};

export enum HardwareProvider {
  gymkey = "gymkey",
  kisi = "kisi",
  arx = "arx",
}


export type WebGymChainInput = {
  id?: number | null,
  providerId: number,
  customerSiteId: string,
  customerName: string,
  customerContactPerson: string,
  customerPhone: string,
  supportPhone: string,
  maximumNegativeBalance: number,
  customerEmail: string,
  customerAddress: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  imageUrl?: string | null,
  lastImportedDate?: string | null,
  isDeleted?: boolean | null,
  arxReferenceId: string,
  providerConnected: boolean,
  isSodvinCompany?: boolean | null,
  allowConvertingAccessCards?: boolean | null,
  createMindbodyClientAccessCards?: boolean | null,
  processBookings?: boolean | null,
  processSales?: boolean | null,
  processAppointments?: boolean | null,
  fetchAccountBalance?: boolean | null,
  kisiApiKey?: string | null,
  kisiNightlySyncApiKey?: string | null,
  gymKeyChainId?: string | null,
  hardwareProvider?: HardwareProvider | null,
};

export type SiteLocation = {
  __typename: "SiteLocation",
  id: number,
  siteId: number,
  siteLocationIdApi: number,
  locationName: string,
  locationContactPerson?: string | null,
  locationPhone?: string | null,
  locationEmail?: string | null,
  locationAddress?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  freePassId?: number | null,
  trailMembershipId?: number | null,
  staffAccessMembershipId?: string | null,
  handbackTime?: number | null,
  defaultLocationDetectionMethod?: string | null,
  primaryAccessMethod?: string | null,
  externalBookingsLink?: string | null,
  facebookLink?: string | null,
  twitterLink?: string | null,
  instagramLink?: string | null,
  gracePeriodWhenDeclined?: number | null,
  accessPerDayWhenDeclined?: number | null,
  gracePeriodWhenExpired?: number | null,
  accessPerDayWhenExpired?: number | null,
  gracePeriodWhenSuspended?: number | null,
  accessPerDayWhenSuspended?: number | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
  isLockerEnabled?: boolean | null,
  allowAppointmentCompletion?: boolean | null,
};

export type KisiDoor = {
  __typename: "KisiDoor",
  id: number,
  siteId: number,
  siteLocationId: number,
  kisiDoorId: number,
  kisiDoorName: string,
  kisiPlaceId: number,
  kisiPlaceName: string,
  createdBy: number,
  createdDate?: string | null,
  lastModifiedBy: number,
  lastModifiedDate?: string | null,
};

export type MembershipInput = {
  id?: number | null,
  siteId: number,
  membershipName: string,
  membershipTypeId: number,
  isImported: boolean,
  importedId?: number | null,
  validityPeriod: number,
  isMinusCreditBalanceApplied: boolean,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type Membership = {
  __typename: "Membership",
  id?: number | null,
  siteId?: number | null,
  importedId?: number | null,
  membershipName?: string | null,
  membershipTypeId?: number | null,
  isImported?: boolean | null,
  validityPeriod?: number | null,
  isMinusCreditBalanceApplied?: boolean | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type GymChainAccessCategoryInput = {
  id?: number | null,
  siteId?: number | null,
  name?: string | null,
  gender?: string | null,
  age?: number | null,
  schedulesOnly?: boolean | null,
  status?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
};

export type GymChainAccessCategory = {
  __typename: "GymChainAccessCategory",
  id?: number | null,
  siteId?: number | null,
  name?: string | null,
  gender?: string | null,
  age?: number | null,
  schedulesOnly?: boolean | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type GymInput = {
  id?: number | null,
  gymIdApi: number,
  gymChainId: number,
  gymName: string,
  arxReferenceId?: string | null,
  contactPerson?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  address?: string | null,
  latitude: number,
  longitude: number,
  trialMembershipId?: number | null,
  staffMembershipId?: number | null,
  handbackTime?: number | null,
  defaultLocationDetectionMethod?: string | null,
  primaryAccessMethod?: string | null,
  externalBookingsLink?: string | null,
  signUpUrl?: string | null,
  facebookLink?: string | null,
  twitterLink?: string | null,
  instagramLink?: string | null,
  websiteLink?: string | null,
  gracePeriodWhenDeclined?: number | null,
  accessPerDayWhenDeclined?: number | null,
  gracePeriodWhenExpired?: number | null,
  accessPerDayWhenExpired?: number | null,
  gracePeriodWhenSuspended?: number | null,
  accessPerDayWhenSuspended?: number | null,
  isMobileCredentialAllowed?: boolean | null,
  createdBy: number,
  lastModifiedBy: number,
  lastImportedDate?: string | null,
  status: string,
  city?: string | null,
  imageUrl?: string | null,
  membershipOnSignup?: number | null,
  membershipForVisits?: number | null,
  syncAllVisitsWithGenericSubscription?: boolean | null,
  sodvinCompanyId?: string | null,
  allowConvertingAccessCards?: boolean | null,
  cardType?: string | null,
  addArrivalAuto?: boolean | null,
  addVisitAuto?: boolean | null,
  sessionCheckTimeLimit?: number | null,
  sessionCheckTimeLimitUpper?: number | null,
  excludeBookingTime?: boolean | null,
  timeZone?: string | null,
  prioratizeClasses?: boolean | null,
  blockTime?: number | null,
  markArrivalFirst?: boolean | null,
  openWithoutArrivalMarked?: boolean | null,
  markMultipleAttendanceAuto?: boolean | null,
  markArrivalsWhenThereAreVisits?: boolean | null,
  allowAppointmentCompletion?: boolean | null,
  isClassPortalEnabled?: boolean | null,
  isEmployeeDashboardEnabled?: boolean | null,
};

export type Gym = {
  __typename: "Gym",
  gymChainName?: string | null,
  gymChainId: number,
  gymId: number,
  gymIdApi?: number | null,
  gymName?: string | null,
  contactPerson?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  address?: string | null,
  status?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastImportedDate?: string | null,
  lastModifiedBy?: number | null,
  imageUrl?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  trialMembershipId?: number | null,
  staffMembershipId?: number | null,
  freePassId?: number | null,
  handbackTime?: number | null,
  defaultLocationDetectionMethod?: string | null,
  primaryAccessMethod?: string | null,
  externalBookingsLink?: string | null,
  facebookLink?: string | null,
  twitterLink?: string | null,
  instagramLink?: string | null,
  gracePeriodWhenDeclined?: number | null,
  accessPerDayWhenDeclined?: number | null,
  gracePeriodWhenExpired?: number | null,
  accessPerDayWhenExpired?: number | null,
  gracePeriodWhenSuspended?: number | null,
  accessPerDayWhenSuspended?: number | null,
  isMobileCredentialAllowed?: boolean | null,
  websiteLink?: string | null,
  city?: string | null,
  membershipOnSignup?: number | null,
  membershipForVisits?: number | null,
  syncAllVisitsWithGenericSubscription?: boolean | null,
  isDeleted?: boolean | null,
  signUpUrl?: string | null,
  arxReferenceId?: string | null,
  sodvinCompanyId?: string | null,
  providerId?: number | null,
  allowConvertingAccessCards?: boolean | null,
  cardType?: string | null,
  addArrivalAuto?: boolean | null,
  addVisitAuto?: boolean | null,
  sessionCheckTimeLimit?: number | null,
  sessionCheckTimeLimitUpper?: number | null,
  excludeBookingTime?: boolean | null,
  timeZone?: string | null,
  prioratizeClasses?: boolean | null,
  blockTime?: number | null,
  markArrivalFirst?: boolean | null,
  openWithoutArrivalMarked?: boolean | null,
  markMultipleAttendanceAuto?: boolean | null,
  markArrivalsWhenThereAreVisits?: boolean | null,
  allowAppointmentCompletion?: boolean | null,
  isClassPortalEnabled?: boolean | null,
  isEmployeeDashboardEnabled?: boolean | null,
};

export type KisiDoorInput = {
  id?: number | null,
  siteId?: number | null,
  siteLocationId?: number | null,
  kisiDoorId?: number | null,
  kisiDoorName?: string | null,
  kisiPlaceId?: number | null,
  kisiPlaceName?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
};

export type SiteLocationMembershipInput = {
  id?: number | null,
  siteLocationId: number,
  membershipId: number,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type SiteLocationMembership = {
  __typename: "SiteLocationMembership",
  id?: number | null,
  siteLocationId?: number | null,
  membershipId?: number | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type SubscriptionSelection = {
  selection: string,
};

export type SelectionStatus = {
  __typename: "SelectionStatus",
  id: number,
  isSelected: boolean,
};

export type SubscriptionRejection = {
  selection: string,
};

export type RejectionStatus = {
  __typename: "RejectionStatus",
  id: number,
  isRejected: boolean,
};

export type LocationOpeningHourInput = {
  id?: number | null,
  locationId: number,
  name: string,
  isHoliday?: boolean | null,
  isGeneral?: boolean | null,
  validFromDateTime: string,
  validToDateTime: string,
  createdBy: number,
  lastModifiedBy?: number | null,
  status: string,
};

export type LocationOpeningHour = {
  __typename: "LocationOpeningHour",
  id: number,
  locationId: number,
  name: string,
  isHoliday?: boolean | null,
  isGeneral?: boolean | null,
  validFromDateTime: string,
  validToDateTime: string,
  createdBy: number,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  status: string,
  isDeleted?: boolean | null,
};

export type LocationOpeningHourDetailInput = {
  openingHourId: number,
  startDateTime: string,
  endDateTime: string,
  dayOfWeek: string,
  createdBy: number,
  lastModifiedBy?: number | null,
};

export type Site = {
  __typename: "Site",
  id?: number | null,
  providerId?: number | null,
  customerSiteId?: string | null,
  customerName?: string | null,
  customerContactPerson?: string | null,
  customerPhone?: string | null,
  customerEmail?: string | null,
  customerAddress?: string | null,
  membershipsImported?: boolean | null,
  createMindbodyClientAccessCards?: boolean | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type LocationOpeningHourDetail = {
  __typename: "LocationOpeningHourDetail",
  id?: number | null,
  openingHourId?: number | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  dayOfWeek?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type LocationMembershipOpeningHourInput = {
  openingHourId?: number | null,
  membershipId?: number | null,
  name?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type LocationMembershipOpeningHour = {
  __typename: "LocationMembershipOpeningHour",
  id?: number | null,
  openingHourId?: number | null,
  membershipId?: number | null,
  name?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
};

export type ChangeMemberLocationIsLockedResponse = {
  __typename: "ChangeMemberLocationIsLockedResponse",
  memberId?: number | null,
  gymId?: number | null,
  isLocked?: boolean | null,
};

export type ChangePhoneNumberResponse = {
  __typename: "ChangePhoneNumberResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
};

export type ChangeUserLocationDetectionResponse = {
  __typename: "ChangeUserLocationDetectionResponse",
  memberId?: number | null,
  method?: string | null,
};

export type MemberInquiryInput = {
  userId: number,
  phoneNumber?: string | null,
  email?: string | null,
  dateOfBirth?: string | null,
  address?: string | null,
  messageDescription?: string | null,
  createdBy: number,
  lastModifiedBy: number,
  shareContactDetails?: boolean | null,
  memberEventId: number,
};

export type MemberInquiry = {
  __typename: "MemberInquiry",
  id: number,
  userId: number,
  phoneNumber?: string | null,
  email?: string | null,
  dateOfBirth?: string | null,
  address?: string | null,
  title?: string | null,
  messageDescription?: string | null,
};

export type LocationZoneInput = {
  id?: number | null,
  siteLocationId: number,
  zoneName: string,
  zoneDescription: string,
  arxReferenceId: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type LambdaResponse = {
  __typename: "LambdaResponse",
  error: boolean,
  errorType?: string | null,
  errorMsg?: string | null,
  rollbackStatus?: string | null,
};

export type LocationZoneMembershipInput = {
  locationZoneId: number,
  membershipId: number,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type LocationZone = {
  __typename: "LocationZone",
  id?: number | null,
  siteLocationId?: number | null,
  zoneName?: string | null,
  zoneDescription?: string | null,
  arxReferenceId?: string | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  accessCategoryId?: number | null,
  accessCategoryName?: string | null,
  accessCategoryGender?: string | null,
  accessCategoryAge?: number | null,
  accessCategorySchedulesOnly?: boolean | null,
  accessCategoryStatus?: string | null,
  locationAccessCategoryZoneId?: number | null,
  locationAccessCategoryId?: number | null,
  siteAccessCategoryId?: number | null,
  locationAccessCategoryName?: string | null,
  locationAccessCategoryGender?: string | null,
  locationAccessCategoryArxRefId?: string | null,
  locationProgramAccessCategoryZoneId?: number | null,
  locationProgramAccessCategoryId?: number | null,
  siteProgramAccessCategoryId?: number | null,
  locationProgramAccessCategoryName?: string | null,
  locationProgramAccessCategoryGender?: string | null,
  locationProgramAccessCategoryArxRefId?: string | null,
  programId?: number | null,
  programName?: string | null,
  programImportedId?: number | null,
  programScheduleType?: string | null,
};

export type LocationZoneMembership = {
  __typename: "LocationZoneMembership",
  id?: number | null,
  locationZoneId?: number | null,
  membershipId?: number | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type MemberInput = {
  id?: number | null,
  userId?: number | null,
  firstName: string,
  lastName: string,
  email?: string | null,
  phoneNumber?: string | null,
  address?: string | null,
  profilePicturePath?: string | null,
  status?: string | null,
  lastModifiedBy?: number | null,
  memberStatusId?: number | null,
  arxReferenceId?: string | null,
  isNew?: boolean | null,
};

export type Member = {
  __typename: "Member",
  memberId?: number | null,
  memberFirstName?: string | null,
  memberLastName?: string | null,
  isMobileAppDisabled?: boolean | null,
  isJustTapRevoked?: boolean | null,
  isStaffMember?: boolean | null,
  validFrom?: string | null,
  validTo?: string | null,
  signedUpDate?: string | null,
  phoneNumber?: string | null,
  status?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: number | null,
  expiredDate?: string | null,
  isBlocked?: boolean | null,
  membership?: string | null,
  defaultGymDetectionMethod?: string | null,
  email?: string | null,
  profilePicturePath?: string | null,
  membershipStatus?: string | null,
  forcedAccessStartTime?: string | null,
  forcedAccessEndTime?: string | null,
  lastSyncDate?: string | null,
  subscriptionDeleted?: boolean | null,
  isNew?: boolean | null,
  isTrial?: boolean | null,
  arxReferenceId?: string | null,
  userId?: number | null,
};

export type MemberLocationMembershipInput = {
  siteLocationMembershipId?: number | null,
  memberId?: number | null,
  status?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
};

export type MemberLocationMembershipType = {
  __typename: "MemberLocationMembershipType",
  id?: number | null,
  siteLocationMembershipId?: number | null,
  memberId?: number | null,
  status?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isSelected?: boolean | null,
  isNotMyGym?: boolean | null,
  isRejected?: boolean | null,
  isDeleted?: boolean | null,
  isGranted?: boolean | null,
};

export type LocationAccessPointDoorInput = {
  id?: number | null,
  siteLocationId: number,
  accessPointType: string,
  beaconUUID: string,
  beaconMajor: string,
  beaconMinor: string,
  doorARXId: string,
  doorName: string,
  doorDescription: string,
  handbackTime: number,
  doorCaption: string,
  priority: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  uniqueId: string,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
};

export type LocationAccessPoint = {
  __typename: "LocationAccessPoint",
  id?: number | null,
  siteLocationId?: number | null,
  locationZoneId?: number | null,
  locationZoneName?: string | null,
  zoneAccessPointId?: number | null,
  accessPointType?: string | null,
  uniqueId?: string | null,
  beaconUUID?: string | null,
  beaconMajor?: string | null,
  beaconMinor?: string | null,
  doorARXId?: string | null,
  classId?: string | null,
  doorName?: string | null,
  doorDescription?: string | null,
  handbackTime?: number | null,
  doorCaption?: string | null,
  priority?: string | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
  batteryLevel?: number | null,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
  fromZoneId?: number | null,
  toZoneId?: number | null,
  fromZoneName?: string | null,
  toZoneName?: string | null,
};

export type LocationAccessPointClassInput = {
  id?: number | null,
  siteLocationId: number,
  accessPointType: string,
  beaconUUID: string,
  beaconMajor: string,
  beaconMinor: string,
  doorARXId: string,
  classId: string,
  doorName: string,
  doorDescription: string,
  handbackTime: number,
  doorCaption: string,
  priority: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  uniqueId: string,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
};

export type ZoneAccessPointInput = {
  locationZoneId: number,
  locationAccessPointId: number,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type MobileNumberHistoryInput = {
  oldMobileNumber?: string | null,
  newMobileNumber?: string | null,
  memberId: number,
};

export type ResyncMemberArgs = {
  provider?: string | null,
  memberId?: number | null,
  siteLocationId?: number | null,
  siteId?: number | null,
  userId?: number | null,
};

export type ResyncMemberResponse = {
  __typename: "ResyncMemberResponse",
  error?: string | null,
  message?: string | null,
  memberModified?: boolean | null,
  membershipsModified?: boolean | null,
};

export type MindbodyNightlySyncResponse = {
  __typename: "MindbodyNightlySyncResponse",
  error?: boolean | null,
  message?: string | null,
};

export type MindbodyNightlySyncStatusResponse = {
  __typename: "MindbodyNightlySyncStatusResponse",
  error?: boolean | null,
  message?: string | null,
  nightlySyncRunning?: boolean | null,
};

export type hardwareProviderSyncResponse = {
  __typename: "hardwareProviderSyncResponse",
  error?: boolean | null,
  message?: string | null,
};

export type hardwareProviderSyncStatusResponse = {
  __typename: "hardwareProviderSyncStatusResponse",
  error?: boolean | null,
  message?: string | null,
  hardwareProviderSyncRunning?: boolean | null,
};

export type InvitationEmailInput = {
  userName: string,
  userEmail: string,
  gymName: string,
  gymUrl: string,
  language: string,
};

export type EmailLambdaResponse = {
  __typename: "EmailLambdaResponse",
  error: boolean,
  errorMessage?: string | null,
};

export type ArxPersonInput = {
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  newAccessCategories?: Array< string | null > | null,
  removedAccessCategories?: Array< string | null > | null,
};

export type ArxAccessResponse = {
  __typename: "ArxAccessResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  statusCode?: string | null,
  statusMessage?: string | null,
};

export type ArxCarfOfPersonInput = {
  cardNumber: string,
  cardFormat: string,
  arxPersonId: string,
  isDeleted: boolean,
};

export type InactivateBeaconsInput = {
  siteLocationId: number,
  status: string,
};

export type AssignMemberEventInput = {
  memberEventId: number,
  assignedBy: number,
  createdBy: number,
  assignedUserId: number,
  assignedRoleId: number,
  lastModifiedBy: number,
  memberAssignmentId?: number | null,
};

export type MemberEventInput = {
  memberId: number,
  eventId: number,
  memberEventStatusTypeId?: number | null,
  lastModifiedBy: number,
  siteLocationId?: number | null,
};

export type MemberEvent = {
  __typename: "MemberEvent",
  id: number,
  memberId: number,
  eventId: number,
  isAutoAssigned?: boolean | null,
  lastModifiedBy: number,
  siteLocationId?: number | null,
};

export type AddSiteLocationAccessCategoryInput = {
  id?: number | null,
  name: string,
  accessCategoryId: number,
  arxAccessCategoryId: string,
  gender?: string | null,
  age?: number | null,
  membershipIds: Array< number | null >,
  siteLocationIds: Array< number | null >,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  schedulesOnly: boolean,
  siteLocationMemberships: Array< string | null >,
};

export type AddProgramAccessCategoryInput = {
  id?: number | null,
  name: string,
  accessCategoryId: number,
  arxAccessCategoryId: string,
  gender?: string | null,
  age?: number | null,
  programIds: Array< number | null >,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  programs: Array< string | null >,
};

export type AddSiteLocationProgramAccessCategoryInput = {
  name?: string | null,
  accessCategoryId: number,
  arxAccessCategoryId?: string | null,
  gender?: string | null,
  age?: number | null,
  programIds: Array< number >,
  siteLocationId: number,
  status?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
  schedulesOnly?: boolean | null,
};

export type SiteLocationAccessCategoryInput = {
  id?: number | null,
  name: string,
  arxAccessCategoryId: string,
  gender?: string | null,
  age?: number | null,
  siteLocationMembershipId: number,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  schedulesOnly: boolean,
};

export type IssueCloseEmailInput = {
  userName: string,
  userEmail: string,
  gymName: string,
  issueDescription: string,
  closeDescription: string,
  reportedDate: string,
  closedDate: string,
  language: string,
};

export type LocationAccessCategoryZoneInput = {
  locationZoneId: number,
  accessCategoryId: number,
  createdBy: number,
  lastModifiedBy: number,
};

export type LocationProgramAccessCategoryZoneInput = {
  locationZoneId: number,
  locationProgramAccessCategoryId: number,
  createdBy: number,
  lastModifiedBy: number,
};

export type DaySchedule = {
  __typename: "DaySchedule",
  id?: number | null,
  name?: string | null,
  arxReferenceId?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  status?: string | null,
  weekdayId?: number | null,
  weekdayName?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type DayScheduleInput = {
  id?: number | null,
  arxReferenceId: string,
  name: string,
  weekdayId: number,
  startTime: string,
  endTime: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
};

export type SignUpMobileUser = {
  username?: string | null,
  phone?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  profilePicturePath?: string | null,
  email?: string | null,
  appVersion?: string | null,
  macAddress?: string | null,
  model?: string | null,
  uniqueId?: string | null,
  manufacturer?: string | null,
  locale?: string | null,
  type?: string | null,
  timeZone?: string | null,
  country?: string | null,
  baseOs?: string | null,
  isCameraPresent?: boolean | null,
  signedUpStatus?: boolean | null,
  memberId?: number | null,
};

export type InquiryEventInput = {
  userId: number,
  phoneNumber?: string | null,
  email?: string | null,
  dateOfBirth?: string | null,
  address?: string | null,
  title?: string | null,
  messageDescription?: string | null,
  createdBy: number,
  lastModifiedBy: number,
  shareContactDetails?: boolean | null,
  memberId: number,
  eventId: number,
  memberEventStatusTypeId?: number | null,
  siteLocationId?: number | null,
  isMoreInfoRequested?: boolean | null,
};

export type SiteScheduleInput = {
  id?: number | null,
  siteId: number,
  name: string,
  type: string,
  validFrom: string,
  validTo: string,
  scheduleStatusId: number,
  createdBy: number,
  lastModifiedBy: number,
  status: string,
};

export type SiteSchedule = {
  __typename: "SiteSchedule",
  id?: number | null,
  siteId?: number | null,
  name?: string | null,
  type?: string | null,
  validFrom?: string | null,
  validTo?: string | null,
  utcValidFrom?: string | null,
  utcValidTo?: string | null,
  scheduleStatusId?: number | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  status?: string | null,
};

export type SiteLocationScheduleForAccessCategoryInput = {
  siteScheduleId: number,
  siteLocationId: number,
  zoneId: number,
  accessCategoryId: number,
  siteLocationMembershipId?: number | null,
  createdBy: number,
  lastModifiedBy: number,
  status: string,
};

export type SiteScheduleDetailsInput = {
  siteScheduleId: number,
  weekdayId: number,
  startTime: string,
  endTime: string,
  dayScheduleId?: number | null,
  createdBy: number,
  lastModifiedBy: number,
  status: string,
  isRequested: boolean,
};

export type SiteLocationScheduleForLocationAccessPointInput = {
  siteScheduleId: number,
  siteLocationId: number,
  zoneId: number,
  locationAccessPointId: number,
  createdBy: number,
  lastModifiedBy: number,
  status: string,
};

export type AccessCardHistoryInput = {
  id?: number | null,
  accessCardUID: string,
  userId?: number | null,
  accessCardFormatName: string,
  memberId: number,
  integrationCardId: string,
  createdBy: number,
  siteLocationId: number,
};

export type AddAccessCardResponse = {
  __typename: "AddAccessCardResponse",
  existingCardsCount?: number | null,
};

export type WebUserInput = {
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
  createdBy: number,
  siteLocationData: Array< number | null >,
  accessViaMembership: boolean,
  password: string,
  roleId: number,
  imageUrl: string,
  language: string,
};

export type UserManagementResponse = {
  __typename: "UserManagementResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  success?: boolean | null,
};

export type WebUserModifyInput = {
  userId: number,
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
  lastModifiedBy: number,
  memberId: number,
  roleId: number,
  siteLocationData: Array< number | null >,
  accessViaMembership: boolean,
  userRoleChanged: boolean,
  updatedEmail: string,
  updatedPhone: string,
  imageUrl: string,
  language: string,
  memberArxReferenceId: string,
};

export type GiveForcedAccessInput = {
  memberId: number,
  userId: number,
  siteLocationId: number,
  memberLocationId: number,
  startingTime: string,
  endingTime: string,
  isIndefinite: boolean,
  overrideLocationDetection: boolean,
  overrideClientStatuses: boolean,
};

export type GymVisitActivityInput = {
  memberEventId?: number | null,
  memberId?: number | null,
  memberEmail?: string | null,
  eventId?: number | null,
  eventDescription?: string | null,
  eventType?: string | null,
  stageId?: number | null,
  stage?: string | null,
  createdTime?: string | null,
  isAutoAssigned?: boolean | null,
  memberEventStatusTypeId?: number | null,
  memberEventStatusType?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  siteLocationId?: number | null,
  assignedUserId?: number | null,
  assignmentHistoryId?: number | null,
  locationName?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  inquiryDescription?: string | null,
  memberLocationId?: number | null,
};

export type GymVisitActivity = {
  __typename: "GymVisitActivity",
  memberEventId?: number | null,
  memberId?: number | null,
  memberEmail?: string | null,
  eventId?: number | null,
  eventDescription?: string | null,
  eventType?: string | null,
  stageId?: number | null,
  stage?: string | null,
  createdTime?: string | null,
  isAutoAssigned?: boolean | null,
  memberEventStatusTypeId?: number | null,
  memberEventStatusType?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  siteLocationId?: number | null,
  assignedUserId?: number | null,
  assignmentHistoryId?: number | null,
  locationName?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  inquiryDescription?: string | null,
  memberLocationId?: number | null,
  informationReceivedEvent?: boolean | null,
};

export type ProvisionStaffAccountInput = {
  customerSiteId: string,
  email: string,
  gymChainName: string,
  ownerName: string,
  language: string,
};

export type StaffAccountInput = {
  siteId: number,
  customerSiteId: string,
  createdBy: number,
};

export type memberMappingInput = {
  providerId: number,
  oldMemberId: number,
  newMemberId: number,
  phoneNumber: string,
  isChecked: boolean,
  uniqueId: number,
  oldUserId: number,
  newUserId: number,
  loggedInUserId: number,
  siteLocationId?: number | null,
};

export type MapMatchingRecordsResponse = {
  __typename: "MapMatchingRecordsResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
};

export type RequestInfoMemberEventInput = {
  userId: number,
  createdBy: number,
  lastModifiedBy: number,
  memberId: number,
  eventId: number,
  assignedBy: number,
  assignedUserId: number,
};

export type sendRequestMoreInformationEmailInput = {
  firstName: string,
  userEmail: string,
  language: string,
};

export type MapMembersWithUserInput = {
  memberIds: string,
  userId: number,
};

export type MemberUserMapStatus = {
  __typename: "MemberUserMapStatus",
  id: number,
  userId: number,
};

export type updateAccessCategoryGroupIdInput = {
  arxAccessCategoryId: string,
  membershipIds: string,
  siteLocationIds: string,
  accessCategoryId: number,
  lastModifiedBy: number,
};

export type SiteLocationAccessCategory = {
  __typename: "SiteLocationAccessCategory",
  id?: number | null,
  name?: string | null,
  arxAccessCategoryId?: string | null,
  gender?: string | null,
  age?: number | null,
  siteLocationMembershipId?: number | null,
  membershipName?: string | null,
  program?: string | null,
  scheduleType?: string | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  siteLocationId?: number | null,
  schedulesOnly?: boolean | null,
};

export type UpdateSiteLocationProgramAccessCategoryGroupIdInput = {
  siteLocationId: number,
  accessCategoryId: number,
  programIds: Array< number >,
  arxAccessCategoryId: string,
  lastModifiedBy: number,
};

export type CreateMobileUserInput = {
  username?: string | null,
  phone?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  profilePicturePath?: string | null,
  email?: string | null,
  appVersion?: string | null,
  macAddress?: string | null,
  model?: string | null,
  uniqueId?: string | null,
  manufacturer?: string | null,
  locale?: string | null,
  type?: string | null,
  timeZone?: string | null,
  country?: string | null,
  baseOs?: string | null,
  isCameraPresent?: boolean | null,
  signedUpStatus?: boolean | null,
  memberIds?: string | null,
};

export type CreateOrGetGymMemberInput = {
  siteLocationId: number,
  phone: string,
  dialingPhone?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  userId: number,
};

export type ReportIssueInput = {
  userId: number,
  phone?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  title?: string | null,
  messageDescription?: string | null,
  shareContactDetails?: boolean | null,
  eventId: number,
  memberEventStatusTypeId?: number | null,
};

export type AddAccessPointInput = {
  siteLocationId: number,
  accessPointType: string,
  beaconUUID: string,
  beaconMajor: string,
  beaconMinor: string,
  doorARXId: string,
  doorName: string,
  handbackTime: number,
  doorCaption: string,
  priority: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  uniqueId: string,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
  locationZoneId: number,
  fromZoneId?: number | null,
  toZoneId?: number | null,
};

export type ModifyAccessPointInput = {
  locationAccessPointId: number,
  siteLocationId: number,
  accessPointType: string,
  beaconUUID: string,
  beaconMajor: string,
  beaconMinor: string,
  doorARXId: string,
  doorName: string,
  handbackTime: number,
  doorCaption: string,
  priority: string,
  status: string,
  createdBy: number,
  lastModifiedBy: number,
  uniqueId: string,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
  locationZoneId: number,
  fromZoneId?: number | null,
  toZoneId?: number | null,
};

export type AccessRuleInput = {
  id?: number | null,
  maxLimit?: number | null,
  allowAccess?: string | null,
  gracePeriod?: string | null,
  graceAccessCount?: number | null,
  noOfDays?: number | null,
  lastModifiedBy?: number | null,
};

export type MobileVisitInput = {
  type?: string | null,
  gymId?: number | null,
  memberId?: number | null,
  locationAccessPointId?: number | null,
  createdTime?: string | null,
};

export type UpdateClientVisitInput = {
  customerSiteId: string,
  siteId: number,
  mlmAccessId: number,
  visitImportedId: number,
  lastModifiedBy?: number | null,
};

export type AddClientArrivalInput = {
  customerSiteId: string,
  siteId: number,
  memberId: number,
  siteLocationId: number,
  programId?: number | null,
  uniqueId: number,
  siteLocationIdApi: number,
  accessPointId: number,
  doorOpenedTime: string,
};

export type YellowboxCreateBookingInput = {
  locationId?: string | null,
  memberId?: string | null,
  prefix?: string | null,
  size?: string | null,
};

export type YellowboxBooking = {
  __typename: "YellowboxBooking",
  lockerId?: string | null,
  location?: string | null,
  lockerNumber?: number | null,
  prefix?: string | null,
  prefixLong?: string | null,
  bookingStart?: string | null,
};

export type SiteLocationUserRecordInput = {
  siteId: number,
  siteLocationId: number,
  userId: number,
};

export type ModifyProgramInput = {
  add?: Array< AddProgram | null > | null,
  remove?: Array< RemoveProgram | null > | null,
};

export type AddProgram = {
  originalProgramId: number,
  originalProgramImportedId: number,
  relatedProgramId: number,
  relatedProgramName: string,
  relatedProgramImportedId: number,
  relatedProgramScheduleType: string,
  createdBy: number,
  siteId: number,
};

export type RemoveProgram = {
  originalProgramId: number,
  originalProgramImportedId: number,
  relatedProgramId: number,
  relatedProgramImportedId: number,
  lastModifiedBy: number,
  siteId: number,
};

export type ManualMemberImportParams = {
  clientId: string,
  customerSiteId: string,
  siteId: number,
  userId: number,
};

export type MarkArrivalsInput = {
  memberId: number,
  accessPointId: number,
  userTime: string,
};

export type ClassPortalData = {
  __typename: "ClassPortalData",
  id: number,
  importedId: number,
  name: string,
  siteLocationId: number,
  resourceId: number,
  staffId: number,
  startDateTime: string,
  endDateTime: string,
  maxCapacity: number,
  totalBooked: number,
  resourceMindbodyId: number,
  resourceName: string,
  resourceImageUrl?: string | null,
  staffMindbodyId: number,
  staffName: string,
  staffImageUrl?: string | null,
  imageUrl?: string | null,
};

export type KisiEvent = {
  __typename: "KisiEvent",
  id: number,
  siteId: number,
  siteLocationId: number,
  kisiDoorId: number,
  kisiDoorName?: string | null,
  doorOpenMemberEmail: string,
  doorOpenedTime: string,
  accessGranted: boolean,
  accessFailureCode?: string | null,
  accessFailureMessage?: string | null,
  memberId?: number | null,
  createdBy: number,
  createdDate?: string | null,
  lastModifiedBy: number,
  lastModifiedDate?: string | null,
  businessName?: string | null,
  memberName?: string | null,
  memberUniqueId?: string | null,
  memberClientId?: string | null,
  memberStatus?: string | null,
  memberAccountBalance?: number | null,
  memberNote?: string | null,
  memberWaiverStatus?: string | null,
  memberWaiverAgreementDateTime?: string | null,
  memberWaiverGraceUntil?: string | null,
  memberWaiverPolicyEnforced?: boolean | null,
};

export type EmployeeDashboardEvent = {
  __typename: "EmployeeDashboardEvent",
  id: number,
  providerEventId?: string | null,
  accessProvider: string,
  siteId: number,
  siteLocationId: number,
  doorId: number,
  doorName?: string | null,
  memberEmail: string,
  doorOpenedTime: string,
  doorOpenedTimeUtc: string,
  accessGranted: boolean,
  accessFailureCode?: string | null,
  accessFailureMessage?: string | null,
  memberId?: number | null,
  memberName?: string | null,
  memberUniqueId?: string | null,
  memberClientId?: string | null,
  memberStatus?: string | null,
  memberAccountBalance?: number | null,
  memberNote?: string | null,
  memberWaiverStatus?: string | null,
  memberWaiverAgreementDateTime?: string | null,
  memberWaiverGraceUntil?: string | null,
  memberWaiverPolicyEnforced?: boolean | null,
};

export type ClassPortalSnapshot = {
  __typename: "ClassPortalSnapshot",
  generatedAt: string,
  location: ClassPortalSnapshotLocation,
  classes:  Array<ClassPortalSnapshotClass >,
};

export type ClassPortalSnapshotLocation = {
  __typename: "ClassPortalSnapshotLocation",
  id: number,
  gymChainId: number,
  name: string,
  logo?: ClassPortalSnapshotImage | null,
};

export type ClassPortalSnapshotImage = {
  __typename: "ClassPortalSnapshotImage",
  kind: string,
  url: string,
  alt: string,
};

export type ClassPortalSnapshotClass = {
  __typename: "ClassPortalSnapshotClass",
  id: string,
  name: string,
  startsAt: string,
  endsAt: string,
  availability: ClassPortalSnapshotAvailability,
  instructor: ClassPortalSnapshotInstructor,
};

export type ClassPortalSnapshotAvailability = {
  __typename: "ClassPortalSnapshotAvailability",
  available: number,
  capacity: number,
};

export type ClassPortalSnapshotInstructor = {
  __typename: "ClassPortalSnapshotInstructor",
  name: string,
  image?: ClassPortalSnapshotImage | null,
};

export type MembershipType = {
  __typename: "MembershipType",
  id?: number | null,
  name?: string | null,
  isDeleted?: boolean | null,
};

export type SearchInput = {
  searchField?: string | null,
  searchText?: string | null,
};

export type MembershipSiteResponse = {
  __typename: "MembershipSiteResponse",
  totalRecords?: PageCount | null,
  items?:  Array<MembershipSite | null > | null,
};

export type PageCount = {
  __typename: "PageCount",
  totalRecords: number,
};

export type MembershipSite = {
  __typename: "MembershipSite",
  id?: number | null,
  siteId?: number | null,
  membershipName?: string | null,
  membershipTypeId?: number | null,
  membershipType?: string | null,
  importedId?: number | null,
  isImported?: boolean | null,
  validityPeriod?: number | null,
  isMinusCreditBalanceApplied?: boolean | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
  firstName?: string | null,
  lastName?: string | null,
  program?: string | null,
  siteLocations?: string | null,
  programAccessLocations?: string | null,
  hasRelatedAccessCategory?: boolean | null,
  hasRelatedProgramAccessCategory?: boolean | null,
  scheduleType?: string | null,
  isContractOnly?: boolean | null,
};

export type SiteLocationMembershipSite = {
  __typename: "SiteLocationMembershipSite",
  siteLocationMembershipId?: number | null,
  siteLocationId?: number | null,
  siteLocationName?: string | null,
  siteLocationStatus?: string | null,
  siteLocationMembershipStatus?: string | null,
  isDeleted?: boolean | null,
};

export type SiteLocationAccessCategorySite = {
  __typename: "SiteLocationAccessCategorySite",
  siteLocationAccessCategoryId?: number | null,
  siteLocationMembershipId?: number | null,
  siteLocationId?: number | null,
  siteLocationName?: string | null,
  siteLocationStatus?: string | null,
  siteLocationAccessCategoryStatus?: string | null,
  membershipId?: number | null,
  membershipImportedId?: number | null,
  membershipName?: string | null,
};

export type ProgramAccessCategorySite = {
  __typename: "ProgramAccessCategorySite",
  programAccessCategoryId?: number | null,
  programArxAccessCategoryId?: string | null,
  programId?: number | null,
  programName?: string | null,
  programScheduleType?: string | null,
  programImportedId?: number | null,
  programAccessCategoryStatus?: string | null,
  isDeleted?: boolean | null,
};

export type WebGymChainReponse = {
  __typename: "WebGymChainReponse",
  totalRecords?: PageCount | null,
  items?:  Array<WebGymChain | null > | null,
};

export type WebGymResponse = {
  __typename: "WebGymResponse",
  totalRecords?: PageCount | null,
  items?:  Array<Gym | null > | null,
};

export type WebUserResponse = {
  __typename: "WebUserResponse",
  totalRecords?: PageCount | null,
  items?:  Array<WebUser | null > | null,
};

export type WebUser = {
  __typename: "WebUser",
  userId?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: number | null,
  isActive?: boolean | null,
  memberId?: number | null,
  roleId?: number | null,
  profilePicturePath?: string | null,
  roleName?: string | null,
  siteId?: number | null,
  siteName?: string | null,
  siteLocationId?: number | null,
  siteLocationName?: string | null,
  language?: string | null,
  memberArxReferenceId?: string | null,
};

export type MobileUserResponse = {
  __typename: "MobileUserResponse",
  totalRecords?: PageCount | null,
  items?:  Array<MobileUser | null > | null,
};

export type MobileUser = {
  __typename: "MobileUser",
  id?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  status?: boolean | null,
  isMobileAppDisabled?: boolean | null,
  isJustTapRevoked?: boolean | null,
  isMoreInfoRequested?: boolean | null,
  imageUrl?: string | null,
  language?: string | null,
  defaultLocationDetectionMethod?: string | null,
  memberId?: string | null,
  memberName?: string | null,
};

export type ImportSiteResponse = {
  __typename: "ImportSiteResponse",
  PaginationResponse?: MindbodyPaginationResponseType | null,
  Sites?:  Array<MindbodyImportedSite | null > | null,
  error?: boolean | null,
  errorMsg?: string | null,
};

export type MindbodyPaginationResponseType = {
  __typename: "MindbodyPaginationResponseType",
  RequestedLimit?: number | null,
  RequestedOffset?: number | null,
  PageSize?: number | null,
  TotalResults?: number | null,
};

export type MindbodyImportedSite = {
  __typename: "MindbodyImportedSite",
  AcceptsAmericanExpress?: boolean | null,
  AcceptsDiscover?: boolean | null,
  AcceptsMasterCard?: boolean | null,
  AcceptsVisa?: boolean | null,
  AllowsDashboardAccess?: boolean | null,
  ContactEmail?: string | null,
  Description?: string | null,
  Id?: number | null,
  LogoUrl?: string | null,
  Name?: string | null,
  PageColor1?: string | null,
  PageColor2?: string | null,
  PageColor3?: string | null,
  PageColor4?: string | null,
  PricingLevel?: string | null,
  SmsPackageEnabled?: boolean | null,
  TaxInclusivePrices?: boolean | null,
  CurrencyIsoCode?: string | null,
  CountryCode?: string | null,
  TimeZone?: string | null,
  AcceptsDirectDebit?: boolean | null,
};

export type GymResponse = {
  __typename: "GymResponse",
  totalRecords?: PageCount | null,
  items?:  Array<Gym | null > | null,
};

export type UploadImageResponse = {
  __typename: "UploadImageResponse",
  url?: string | null,
  uploadUrl?: string | null,
};

export type LocationDetectionMethod = {
  __typename: "LocationDetectionMethod",
  gymId?: number | null,
  gymDefined?: string | null,
  userDefined?: string | null,
};

export type PlatformSetting = {
  __typename: "PlatformSetting",
  id?: number | null,
  setting?: string | null,
  value?: string | null,
  isDeleted?: boolean | null,
};

export type MindbodyImportedLocation = {
  __typename: "MindbodyImportedLocation",
  AdditionalImageURLs?: Array< string | null > | null,
  Address?: string | null,
  Address2?: string | null,
  BusinessDescription?: string | null,
  City?: string | null,
  Description?: string | null,
  HasClasses?: boolean | null,
  Id?: number | null,
  Latitude?: number | null,
  Longitude?: number | null,
  Name?: string | null,
  Phone?: string | null,
  PhoneExtension?: string | null,
  PostalCode?: string | null,
  SiteID?: number | null,
  StateProvCode?: string | null,
};

export type KisiImportedDoor = {
  __typename: "KisiImportedDoor",
  id?: number | null,
  name?: string | null,
  placeId?: number | null,
  placeName?: string | null,
};

export type DeletableResponse = {
  __typename: "DeletableResponse",
  id?: number | null,
  rowCount?: number | null,
  tableName?: string | null,
};

export type isMemberLinkedResponse = {
  __typename: "isMemberLinkedResponse",
  rowCount?: number | null,
};

export type getMemberUserLinkResponse = {
  __typename: "getMemberUserLinkResponse",
  totalRecords?: number | null,
};

export type LocationOpeningHourReponse = {
  __typename: "LocationOpeningHourReponse",
  totalRecords?: PageCount | null,
  items?:  Array<LocationOpeningHourWithDay | null > | null,
};

export type LocationOpeningHourWithDay = {
  __typename: "LocationOpeningHourWithDay",
  id: number,
  locationId: number,
  name: string,
  isHoliday?: boolean | null,
  isGeneral?: boolean | null,
  validFromDateTime: string,
  validToDateTime: string,
  createdBy: number,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  status: string,
  dayOfWeek?: string | null,
  isDeleted?: boolean | null,
  hourDetailId?: number | null,
  validFromDate?: string | null,
  validToDate?: string | null,
};

export type MembershipImport = {
  __typename: "MembershipImport",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  memberships?:  Array<Membership | null > | null,
};

export type MembershipInfo = {
  __typename: "MembershipInfo",
  siteLocationMembershipId?: number | null,
  siteLocationId?: number | null,
  siteLocationImportedId?: number | null,
  siteLocationName?: string | null,
  membershipId?: number | null,
  membershipName?: string | null,
  membershipTypeName?: string | null,
  validityPeriod?: number | null,
  isImported?: boolean | null,
  importedId?: number | null,
  status?: string | null,
  createdDate?: string | null,
  program?: string | null,
  scheduleType?: string | null,
};

export type AccessCategoryMembershipInfo = {
  __typename: "AccessCategoryMembershipInfo",
  membershipId?: number | null,
  membershipName?: string | null,
  membershipTypeName?: string | null,
  validityPeriod?: number | null,
  isImported?: boolean | null,
  importedId?: number | null,
  status?: string | null,
  createdDate?: string | null,
  program?: string | null,
  scheduleType?: string | null,
};

export type MembershipSiteLocationResponse = {
  __typename: "MembershipSiteLocationResponse",
  totalRecords?: PageCount | null,
  items?:  Array<MembershipInfo | null > | null,
};

export type LocationOpeningHoursJoinedResponse = {
  __typename: "LocationOpeningHoursJoinedResponse",
  totalRecords?: PageCount | null,
  items?:  Array<LocationOpeningHoursJoined | null > | null,
};

export type LocationOpeningHoursJoined = {
  __typename: "LocationOpeningHoursJoined",
  id?: number | null,
  locationId?: number | null,
  openingHourId?: number | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  dayOfWeek?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isHoliday?: boolean | null,
  name?: string | null,
  status?: string | null,
  validFromDate?: string | null,
  validToDate?: string | null,
};

export type GymSearchResult = {
  __typename: "GymSearchResult",
  gymId: number,
  gymName: string,
  gymLogo?: string | null,
  gymAddress?: string | null,
  gymCity?: string | null,
  freePassId?: number | null,
  trialMembershipId?: number | null,
  membershipOnSignup?: number | null,
  membershipForVisits?: number | null,
  syncAllVisitsWithGenericSubscription?: boolean | null,
  providerId?: number | null,
};

export type SiteLocationMembersReponse = {
  __typename: "SiteLocationMembersReponse",
  totalRecords?: PageCount | null,
  items?:  Array<SiteLocationMember | null > | null,
};

export type SiteLocationMember = {
  __typename: "SiteLocationMember",
  memberId?: number | null,
  uniqueId?: string | null,
  clientId?: string | null,
  externalId?: string | null,
  accountBalance?: number | null,
  businessName?: string | null,
  memberWaiverStatus?: string | null,
  memberWaiverAgreementDateTime?: string | null,
  memberWaiverGraceUntil?: string | null,
  memberFirstName?: string | null,
  memberLastName?: string | null,
  isMobileAppDisabled?: boolean | null,
  isJustTapRevoked?: boolean | null,
  isStaffMember?: boolean | null,
  signedUpDate?: string | null,
  phoneNumber?: string | null,
  status?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: number | null,
  expiredDate?: string | null,
  isBlocked?: boolean | null,
  defaultGymDetectionMethod?: string | null,
  email?: string | null,
  profilePicturePath?: string | null,
  lastSyncDate?: string | null,
  isTrial?: boolean | null,
  arxReferenceId?: string | null,
  userId?: number | null,
  linkedPhoneNumber?: string | null,
  language?: string | null,
  hasAccessCard?: boolean | null,
  hasActiveWalletPass?: boolean | null,
  hasForcedAccess?: boolean | null,
  hasLocationOverride?: boolean | null,
  hasManualAccess?: boolean | null,
  isFreepassMember?: boolean | null,
  memberLocationId?: number | null,
  flag?: number | null,
};

export type GetMemberByMemberIdResponse = {
  __typename: "GetMemberByMemberIdResponse",
  totalRecords?: PageCount | null,
  items?:  Array<SiteLocationMember | null > | null,
};

export type SiteLocationMemberDetails = {
  __typename: "SiteLocationMemberDetails",
  membership?: string | null,
  memberLocationMembershipId?: number | null,
  subscriptionDeleted?: boolean | null,
  validFrom?: string | null,
  validTo?: string | null,
  subscriptionCreatedDate?: string | null,
  subscriptionModifiedDate?: string | null,
  subscriptionIsSelected?: boolean | null,
  subscriptionStatus?: string | null,
  scheduleType?: string | null,
  remainingSessions?: number | null,
  siteLocationMembershipStatus?: string | null,
};

export type MemberBookingDetails = {
  __typename: "MemberBookingDetails",
  booking?: string | null,
  importedId?: number | null,
  appointmentId?: number | null,
  isVisited?: boolean | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  createdDate?: string | null,
  lastModifiedDate?: string | null,
  membershipName?: string | null,
  siteLocation?: string | null,
  isDeleted?: boolean | null,
  grantsAccess?: boolean | null,
};

export type LocationZoneResponse = {
  __typename: "LocationZoneResponse",
  items?:  Array<LocationZone | null > | null,
  totalRecords?: PageCount | null,
};

export type MemberAndSubscriptionsResponse = {
  __typename: "MemberAndSubscriptionsResponse",
  memberId?: number | null,
  uniqueId?: string | null,
  memberFirstName?: string | null,
  memberLastName?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  address?: string | null,
  profilePicturePath?: string | null,
  status?: string | null,
  membershipId?: number | null,
  membershipName?: string | null,
  membershipImportedId?: number | null,
  validFrom?: string | null,
  validTo?: string | null,
  memberStatus?: string | null,
  arxReferenceId?: string | null,
};

export type CountResponse = {
  __typename: "CountResponse",
  count?: number | null,
};

export type DataUpdateStatus = {
  __typename: "DataUpdateStatus",
  memberId?: string | null,
  lastSyncDate?: string | null,
  memberPhone?: string | null,
};

export type MemberStatus = {
  __typename: "MemberStatus",
  id?: number | null,
  status?: string | null,
};

export type LocationAccessPointResponse = {
  __typename: "LocationAccessPointResponse",
  items?:  Array<LocationAccessPoint | null > | null,
  totalRecords?: PageCount | null,
};

export type KisiDoorResponse = {
  __typename: "KisiDoorResponse",
  items?:  Array<KisiDoor | null > | null,
  totalRecords?: PageCount | null,
};

export type KisiEventResponse = {
  __typename: "KisiEventResponse",
  items?:  Array<KisiEvent | null > | null,
  totalRecords?: PageCount | null,
};

export type EmployeeDashboardEventHistoryInput = {
  siteLocationId: number,
  doorId: number,
  pageSize: number,
  cursor?: EmployeeDashboardEventCursorInput | null,
  dateFrom?: string | null,
  dateTo?: string | null,
  memberId?: number | null,
  accessGranted?: boolean | null,
  search?: string | null,
};

export type EmployeeDashboardEventCursorInput = {
  doorOpenedTimeUtc: string,
  id: number,
};

export type EmployeeDashboardEventHistoryResponse = {
  __typename: "EmployeeDashboardEventHistoryResponse",
  items?:  Array<EmployeeDashboardEvent | null > | null,
  totalRecords?: PageCount | null,
};

export type EmployeeDashboardMembership = {
  __typename: "EmployeeDashboardMembership",
  membership?: string | null,
  memberLocationMembershipId?: number | null,
  validFrom?: string | null,
  validTo?: string | null,
  subscriptionStatus?: string | null,
  scheduleType?: string | null,
  remainingSessions?: number | null,
  remainingVisits?: number | null,
  siteLocationMembershipStatus?: string | null,
  siteLocationId?: number | null,
  siteLocationName?: string | null,
  isProbableAccess: boolean,
  accessProvider?: string | null,
};

export type KisiEventMemberResponse = {
  __typename: "KisiEventMemberResponse",
  items?:  Array<KisiEventMember | null > | null,
  totalRecords?: PageCount | null,
};

export type KisiEventMember = {
  __typename: "KisiEventMember",
  id: number,
  uniqueId?: string | null,
  clientId?: string | null,
  memberStatusId?: number | null,
  userId?: number | null,
  username?: string | null,
  name: string,
  address?: string | null,
  phone?: string | null,
  email?: string | null,
  createdBy: number,
  createdDate?: string | null,
  lastModifiedBy: number,
  lastModifiedDate?: string | null,
  note?: string | null,
  accountBalance: number,
  accountBalanceChangeDate?: string | null,
};

export type SubscribedGym = {
  __typename: "SubscribedGym",
  providerId: number,
  providerName?: string | null,
  gymChainId: number,
  gymChainName?: string | null,
  locationId: number,
  accessPointId?: number | null,
  locationName?: string | null,
  locationCity?: string | null,
  gymInquiriesByUser?: number | null,
  imageUrl?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  beaconUUID?: string | null,
  beaconMajor?: string | null,
  beaconMinor?: string | null,
  membershipName?: string | null,
  defaultLocationDetectionMethod?: string | null,
  doorName?: string | null,
  doorDescription?: string | null,
  status?: string | null,
  doorARXId?: string | null,
  locationAddress?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionId?: number | null,
  sodvinDoorId?: string | null,
  sodvinDoorSecret?: string | null,
  sodvinCompanyId?: string | null,
  siteLocationArxReferenceId?: string | null,
  memberUniqueId?: string | null,
  memberArxReferenceId?: string | null,
  siteLocationHandbackTime?: number | null,
  accessPointHandbackTime?: number | null,
  isGranted?: boolean | null,
  isTrial?: boolean | null,
  accessPointType?: string | null,
  siteLocationPhone?: string | null,
  externalBookingsLink?: string | null,
  facebookLink?: string | null,
  twitterLink?: string | null,
  instagramLink?: string | null,
  websiteLink?: string | null,
  gymStatus?: string | null,
  forcedAccessStartTime?: string | null,
  forcedAccessEndTime?: string | null,
  forcedAccessIsIndefinite?: boolean | null,
  overrideLocationDetection?: boolean | null,
  overrideClientStatuses?: boolean | null,
  isMemberBlocked?: boolean | null,
  isSodvinCompany?: boolean | null,
  customerSiteId?: string | null,
  memberId?: number | null,
  memberPhone?: string | null,
  isDeclined?: boolean | null,
  isSuspended?: boolean | null,
  notAvailable?: boolean | null,
  scheduleType?: string | null,
  programId?: number | null,
  serviceId?: number | null,
  totalVisits?: number | null,
  remainingVisits?: number | null,
  sessionCheckTimeLimit?: number | null,
  sessionCheckTimeLimitUpper?: number | null,
  excludeBookingTime?: boolean | null,
  serviceCategory?: string | null,
  siteLocationIdApi?: number | null,
  subscriptionStatus?: string | null,
  remainingSessions?: number | null,
  isLockerEnabled?: boolean | null,
  allowDoorOpenOnNoVisit?: boolean | null,
  locationAccessCategoryId?: number | null,
  locationZoneId?: number | null,
  addVisitAuto?: boolean | null,
  addArrivalAuto?: boolean | null,
  arrivalId?: number | null,
  arrivalACId?: number | null,
  arrivalStartDateTime?: string | null,
  arrivalEndDateTime?: string | null,
  siteLocationMembershipId?: number | null,
  yellowboxId?: string | null,
  blockTime?: number | null,
};

export type PriorityInfo = {
  __typename: "PriorityInfo",
  id?: number | null,
  doorARXId?: string | null,
  priority?: string | null,
};

export type MembershipsForUser = {
  __typename: "MembershipsForUser",
  mlmId?: number | null,
  memberId?: number | null,
  memberName?: string | null,
  gymId?: number | null,
  gymName?: string | null,
  gymChainId?: number | null,
  gymChainName?: string | null,
  subscriptionValidFrom?: string | null,
  subscriptionValidTo?: string | null,
  status?: string | null,
  expiryDate?: string | null,
  profilePicturePath?: string | null,
  membershipName?: string | null,
};

export type BeaconStatus = {
  __typename: "BeaconStatus",
  id?: number | null,
  siteLocationId?: number | null,
  locationZoneId?: number | null,
  locationZoneName?: string | null,
  zoneAccessPointId?: number | null,
  accessPointType?: string | null,
  uniqueId?: string | null,
  beaconUUID?: string | null,
  beaconMajor?: string | null,
  beaconMinor?: string | null,
  doorARXId?: string | null,
  classId?: string | null,
  doorName?: string | null,
  doorDescription?: string | null,
  handbackTime?: number | null,
  doorCaption?: string | null,
  priority?: string | null,
  status?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isDeleted?: boolean | null,
  batteryLevel?: number | null,
};

export type AccessCard = {
  __typename: "AccessCard",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  cardId?: string | null,
  cardType?: string | null,
};

export type BeaconIdImport = {
  __typename: "BeaconIdImport",
  error?: boolean | null,
  errorMsg?: string | null,
  BeaconId?: BeaconId | null,
};

export type BeaconId = {
  __typename: "BeaconId",
  uuid?: string | null,
  major?: string | null,
  minor?: string | null,
};

export type ArxAccessCategoryResponse = {
  __typename: "ArxAccessCategoryResponse",
  items?:  Array<ArxAccessCategory | null > | null,
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
};

export type ArxAccessCategory = {
  __typename: "ArxAccessCategory",
  id?: string | null,
  categoryName?: string | null,
};

export type ArxExportPersonResponse = {
  __typename: "ArxExportPersonResponse",
  id?: string | null,
  name?: string | null,
  accessCategories?:  Array<ArxPersonAccessCategory | null > | null,
  accessCards?:  Array<ArxPersonAccessCard | null > | null,
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
};

export type ArxPersonAccessCategory = {
  __typename: "ArxPersonAccessCategory",
  id?: string | null,
  name?: string | null,
  startDate?: string | null,
  endDate?: string | null,
};

export type ArxPersonAccessCard = {
  __typename: "ArxPersonAccessCard",
  cardNumber?: string | null,
  formatName?: string | null,
  cardDescription?: string | null,
};

export type GymActivityResponse = {
  __typename: "GymActivityResponse",
  items?:  Array<GymActivity | null > | null,
  totalRecords?: PageCount | null,
};

export type GymActivity = {
  __typename: "GymActivity",
  memberEventId?: number | null,
  memberId?: number | null,
  memberEmail?: string | null,
  eventId?: number | null,
  accessCardUID?: string | null,
  eventDescription?: string | null,
  eventType?: string | null,
  stageId?: number | null,
  stage?: string | null,
  createdTime?: string | null,
  isAutoAssigned?: boolean | null,
  memberEventStatusTypeId?: number | null,
  memberEventStatusType?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  siteLocationId?: number | null,
  assignedUserId?: number | null,
  assignmentHistoryId?: number | null,
  locationName?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  inquiryDescription?: string | null,
  memberLocationId?: number | null,
  informationReceivedEvent?: boolean | null,
  language?: string | null,
  userId?: number | null,
  en?: string | null,
  nor?: string | null,
  nl?: string | null,
  locationAccessPointId?: number | null,
  locationAccessPointName?: string | null,
};

export type SodvinOpenDoorResponse = {
  __typename: "SodvinOpenDoorResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  message?: string | null,
  success?: boolean | null,
};

export type SodvinPreCheckResponse = {
  __typename: "SodvinPreCheckResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  message?: string | null,
  accessAllowed?: boolean | null,
  customerId?: number | null,
  authMessageValue?: number | null,
  authMessageText?: string | null,
};

export type MemberEventStatus = {
  __typename: "MemberEventStatus",
  id?: number | null,
  description?: string | null,
  isDeleted?: boolean | null,
};

export type GetAllUsersResponse = {
  __typename: "GetAllUsersResponse",
  id: number,
  firstName: string,
  lastName: string,
  isPlatformUser?: boolean | null,
};

export type EventJoined = {
  __typename: "EventJoined",
  eventId: number,
  eventDescription?: string | null,
  eventTypeId: number,
  eventType?: string | null,
  stageId?: number | null,
  stage?: string | null,
};

export type SodvinImportedLocation = {
  __typename: "SodvinImportedLocation",
  name?: string | null,
  organizationNumber?: string | null,
  webAddress?: string | null,
  logo?: string | null,
  address1?: string | null,
  address2?: string | null,
  zip?: string | null,
  postOffice?: string | null,
  telephone?: string | null,
  email?: string | null,
  error?: boolean | null,
  errorMsg?: string | null,
};

export type GymAccessCategoriesResponse = {
  __typename: "GymAccessCategoriesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<GymChainAccessCategories | null > | null,
};

export type GymChainAccessCategories = {
  __typename: "GymChainAccessCategories",
  id?: number | null,
  siteId?: number | null,
  name?: string | null,
  gender?: string | null,
  age?: number | null,
  schedulesOnly?: boolean | null,
  status?: string | null,
  accessCategoryId?: number | null,
  siteLocationAccessCategoryId?: number | null,
  siteLocationId?: number | null,
  siteLocationMembershipId?: number | null,
  locationName?: string | null,
  arxAccessCategoryId?: string | null,
  importedId?: string | null,
  membershipId?: number | null,
  membershipName?: string | null,
  program?: string | null,
  scheduleType?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type SiteLocationProgramAccessCategoriesResponse = {
  __typename: "SiteLocationProgramAccessCategoriesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<SiteLocationProgramAccessCategory | null > | null,
};

export type SiteLocationProgramAccessCategory = {
  __typename: "SiteLocationProgramAccessCategory",
  id?: number | null,
  siteId?: number | null,
  siteLocationId?: number | null,
  locationName?: string | null,
  accessCategoryId?: number | null,
  siteLocationProgramAccessCategoryId?: number | null,
  name?: string | null,
  gender?: string | null,
  age?: number | null,
  schedulesOnly?: boolean | null,
  status?: string | null,
  arxAccessCategoryId?: string | null,
  programId?: number | null,
  programName?: string | null,
  programImportedId?: number | null,
  scheduleType?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type DaySchedulesResponse = {
  __typename: "DaySchedulesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<DaySchedule | null > | null,
};

export type getAllWeekDaysResponse = {
  __typename: "getAllWeekDaysResponse",
  id: number,
  name: string,
};

export type GymSchedulesResponse = {
  __typename: "GymSchedulesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<GymSchedule | null > | null,
};

export type GymSchedule = {
  __typename: "GymSchedule",
  siteId?: number | null,
  siteName?: string | null,
  siteScheduleId?: number | null,
  siteScheduleName?: string | null,
  siteScheduleType?: string | null,
  validFrom?: string | null,
  validTo?: string | null,
  scheduleStatusId?: number | null,
  scheduleStatusName?: string | null,
  siteScheduleStatus?: string | null,
  siteScheduleCreatedBy?: number | null,
  siteScheduleCreatedDate?: string | null,
  siteScheduleLastModifiedBy?: number | null,
  siteScheduleLastModifiedDate?: string | null,
  siteScheduleDetailId?: number | null,
  weekdayId?: number | null,
  weekdayName?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  dayScheduleId?: number | null,
  siteScheduleDetailStatus?: string | null,
  siteScheduleDetailCreatedBy?: number | null,
  siteLocationScheduleId?: number | null,
  siteLocationId?: number | null,
  siteLocationName?: string | null,
  imageUrl?: string | null,
  zoneId?: number | null,
  zoneName?: string | null,
  accessCategoryId?: number | null,
  siteLocationAccessCategoryId?: number | null,
  siteLocationProgramAccessCategoryId?: number | null,
  accessCategoryName?: string | null,
  locationAccessPointId?: number | null,
  locationAccessPointName?: string | null,
  siteLocationScheduleCreatedBy?: number | null,
};

export type GymChainAccessCategoriesResponse = {
  __typename: "GymChainAccessCategoriesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<GymChainAccessCategories | null > | null,
};

export type GymChainProgramAccessCategoriesResponse = {
  __typename: "GymChainProgramAccessCategoriesResponse",
  totalRecords?: PageCount | null,
  items?:  Array<GymChainProgramAccessCategories | null > | null,
};

export type GymChainProgramAccessCategories = {
  __typename: "GymChainProgramAccessCategories",
  id?: number | null,
  siteId?: number | null,
  name?: string | null,
  gender?: string | null,
  age?: number | null,
  schedulesOnly?: boolean | null,
  status?: string | null,
  accessCategoryId?: number | null,
  arxAccessCategoryId?: string | null,
  programAccessCategoryId?: number | null,
  programId?: number | null,
  importedId?: number | null,
  programName?: string | null,
  scheduleType?: string | null,
};

export type SodvinMembershipImport = {
  __typename: "SodvinMembershipImport",
  error?: boolean | null,
  errorMsg?: string | null,
};

export type ZoneAccessCategoryMapping = {
  __typename: "ZoneAccessCategoryMapping",
  siteLocationMembershipId?: number | null,
  siteLocationId?: number | null,
  locationName?: string | null,
  locationAccessCategoryId?: number | null,
  locationAccessCategoryName?: string | null,
  locationArxAccessCategoryId?: string | null,
  locationAccessCategoryZoneId?: number | null,
  accessCategoryId?: number | null,
  locationProgramAccessCategoryId?: number | null,
  locationProgramAccessCategoryName?: string | null,
  locationProgramArxAccessCategoryId?: string | null,
  locationProgramAccessCategoryZoneId?: number | null,
  programId?: number | null,
  programName?: string | null,
  programImportedId?: number | null,
  programScheduleType?: string | null,
  locationZoneId?: number | null,
  zoneName?: string | null,
  zoneDescription?: string | null,
  siteId?: number | null,
  membershipId?: number | null,
  membershipName?: string | null,
};

export type SiteAccessPoint = {
  __typename: "SiteAccessPoint",
  locationAccessPointId?: number | null,
  siteId?: number | null,
  siteLocationId?: number | null,
  locationZoneId?: number | null,
  locationZoneName?: string | null,
  zoneAccessPointId?: number | null,
  doorARXId?: string | null,
  doorName?: string | null,
  status?: string | null,
};

export type ScheduleStatuses = {
  __typename: "ScheduleStatuses",
  id: number,
  name: string,
};

export type DoorScheduleStatus = {
  __typename: "DoorScheduleStatus",
  success?: boolean | null,
};

export type UserIssue = {
  __typename: "UserIssue",
  issueId?: number | null,
  issueTitle?: string | null,
  issueDescription?: string | null,
  lastModifiedDate?: string | null,
  issueStatus?: string | null,
};

export type DoorExpiryStatus = {
  __typename: "DoorExpiryStatus",
  success?: boolean | null,
  statusMessage?: string | null,
};

export type Role = {
  __typename: "Role",
  roleId?: number | null,
  roleName?: string | null,
  roleDescription?: string | null,
};

export type AccessCardHistoryResponse = {
  __typename: "AccessCardHistoryResponse",
  id?: number | null,
  accessCardUID?: string | null,
  userId?: number | null,
  isActive?: boolean | null,
  deactivatedDateTime?: string | null,
  accessCardFormatName?: string | null,
  memberId?: number | null,
  integrationCardId?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  siteLocationId?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: string | null,
};

export type WalletPassHistoryResponse = {
  __typename: "WalletPassHistoryResponse",
  id?: number | null,
  memberId?: number | null,
  walletPassType?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  revokedDate?: string | null,
};

export type ForcedAccessResponse = {
  __typename: "ForcedAccessResponse",
  id?: number | null,
  memberLocationId?: number | null,
  startingTime?: string | null,
  endingTime?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  isActive?: boolean | null,
  isIndefinite?: boolean | null,
  overrideLocationDetection?: boolean | null,
  overrideClientStatuses?: boolean | null,
};

export type MemberAccessCard = {
  __typename: "MemberAccessCard",
  userId?: number | null,
  memberId?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  arxReferenceId?: string | null,
  imageUrl?: string | null,
  hasAccessCard?: boolean | null,
};

export type SiteLocationUser = {
  __typename: "SiteLocationUser",
  id: number,
  siteId: number,
  locationId: number,
  userId: number,
};

export type MemberLocation = {
  __typename: "MemberLocation",
  id?: number | null,
  siteLocationId?: number | null,
  memberId?: number | null,
  status?: string | null,
  isBlocked?: boolean | null,
  contractExpiryDate?: string | null,
};

export type MemberAccessMethodsResponse = {
  __typename: "MemberAccessMethodsResponse",
  totalRecords?: PageCount | null,
  items?:  Array<AccessMethod | null > | null,
};

export type AccessMethod = {
  __typename: "AccessMethod",
  accessCardUID?: number | null,
  mobileAppId?: number | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: number | null,
  isMobileAppDisabled?: boolean | null,
  isActive?: boolean | null,
  type?: string | null,
};

export type ReceivedInformation = {
  __typename: "ReceivedInformation",
  id?: number | null,
  userPhone?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  birthDate?: string | null,
  inquiryMemberId?: number | null,
  siteId?: number | null,
  siteLocationId?: number | null,
};

export type MatchingRecordsResponse = {
  __typename: "MatchingRecordsResponse",
  totalRecords?: PageCount | null,
  items?:  Array<MatchingRecords | null > | null,
};

export type MatchingRecords = {
  __typename: "MatchingRecords",
  id?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  birthDate?: string | null,
  providerId?: number | null,
  uniqueId?: number | null,
  userId?: number | null,
  address?: string | null,
};

export type MemberResponse = {
  __typename: "MemberResponse",
  id?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  createdDate?: string | null,
  createdBy?: number | null,
  lastModifiedDate?: string | null,
  lastModifiedBy?: number | null,
  email?: string | null,
  lastSyncDate?: string | null,
  isNew?: boolean | null,
  providerId?: string | null,
  arxReferenceId?: string | null,
  userId?: number | null,
  dateOfBirth?: string | null,
};

export type SchedulesFilterResponse = {
  __typename: "SchedulesFilterResponse",
  date?: string | null,
  schedules?:  Array<DateSchedule | null > | null,
};

export type DateSchedule = {
  __typename: "DateSchedule",
  name?: string | null,
  startTime?: string | null,
  endTime?: string | null,
};

export type OpeningHoursFilterResponse = {
  __typename: "OpeningHoursFilterResponse",
  date?: string | null,
  openingHours?:  Array<GymOpeningHour | null > | null,
};

export type GymOpeningHour = {
  __typename: "GymOpeningHour",
  name?: string | null,
  startTime?: string | null,
  endTime?: string | null,
};

export type AccessRule = {
  __typename: "AccessRule",
  id?: number | null,
  level?: string | null,
  type?: string | null,
  defaultRef?: number | null,
  serviceResponse?: string | null,
  accessStatus?: string | null,
  maxLimit?: number | null,
  allowAccess?: string | null,
  gracePeriod?: string | null,
  graceAccessCount?: number | null,
  isCustom?: boolean | null,
  noOfDays?: number | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
};

export type LoggedInUser = {
  __typename: "LoggedInUser",
  userId?: number | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  roleId?: number | null,
  roleName?: string | null,
  language?: string | null,
  siteCount?: number | null,
  locationCount?: number | null,
};

export type MemberAssignmentHistoryResponse = {
  __typename: "MemberAssignmentHistoryResponse",
  id?: number | null,
  memberEventId?: number | null,
  createdDate?: string | null,
  assignedBy?: number | null,
  createdBy?: number | null,
  isDeleted?: boolean | null,
  assignedUserId?: number | null,
  assignedRoleId?: number | null,
  assignedDateTime?: string | null,
  currentlyAssigned?: boolean | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  resolvedDescription?: string | null,
  closedDescription?: string | null,
};

export type ReceivedInformationForMemberResponse = {
  __typename: "ReceivedInformationForMemberResponse",
  id?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  imageUrl?: string | null,
};

export type SodvinBookingsResponse = {
  __typename: "SodvinBookingsResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  customerBookings?:  Array<CustomerBooking | null > | null,
  success?: boolean | null,
};

export type CustomerBooking = {
  __typename: "CustomerBooking",
  groupSessionCustomerId?: number | null,
  customerId?: number | null,
  reservationDate?: string | null,
  cancelationDate?: string | null,
  movedFromWaitingListDate?: string | null,
  groupSessionId?: number | null,
  groupSessionDepartmentId?: number | null,
  groupSessionDepartmentName?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  subject?: string | null,
  reservationStatus?: number | null,
  nrOnWaitingList?: number | null,
  attended?: boolean | null,
  reservationGUID?: string | null,
  isInCancelInterval?: boolean | null,
  isInRegistrateAttendencyInterval?: boolean | null,
  customerFirstName?: string | null,
  customerLastName?: string | null,
  bookingCustomerName?: string | null,
  extendedInfo?: CustomerBookingExtendedInfo | null,
};

export type CustomerBookingExtendedInfo = {
  __typename: "CustomerBookingExtendedInfo",
  groupSessionCustomerExtendedInfoId?: number | null,
  groupSessionCustomerId?: number | null,
  name?: string | null,
  email?: string | null,
  mobile?: string | null,
  confirmOnMail?: boolean | null,
  confirmOnSMS?: boolean | null,
};

export type GymSubscription = {
  __typename: "GymSubscription",
  subscriptionId: number,
  gymDefLocationDetectionMethod?: string | null,
  gymName: string,
  membershipName: string,
  gymChainName: string,
  gymChainLogo?: string | null,
  userDefLocationDetectionMethod?: string | null,
  memberId?: number | null,
  memberFirstName?: string | null,
  memberLastName?: string | null,
  memberPhone?: string | null,
  userId?: number | null,
  gymLogo?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  isGranted?: boolean | null,
  isTrial?: boolean | null,
  isDeleted?: boolean | null,
  isMemberBlocked?: boolean | null,
  gymStatus?: string | null,
  gymId: number,
  siteLocationMembershipId?: string | null,
  scheduleType?: string | null,
  programId?: number | null,
  serviceId?: number | null,
  totalVisits?: number | null,
  remainingVisits?: number | null,
  providerId?: number | null,
  subscriptionStatus?: string | null,
  yellowboxId?: string | null,
};

export type NewNumberResponse = {
  __typename: "NewNumberResponse",
  error?: boolean | null,
  errorType?: string | null,
  errorMsg?: string | null,
  memberIds?: Array< number | null > | null,
  success?: boolean | null,
};

export type ProviderResponse = {
  __typename: "ProviderResponse",
  siteLocationId?: number | null,
  providerId?: number | null,
  providerName?: string | null,
};

export type GetAllAccessCardTypesResponse = {
  __typename: "GetAllAccessCardTypesResponse",
  id?: number | null,
  accessCard?: string | null,
  value?: string | null,
};

export type ScheduleRequestsResponse = {
  __typename: "ScheduleRequestsResponse",
  totalRecords?: PageCount | null,
  items?:  Array<ScheduleRequest | null > | null,
};

export type ScheduleRequest = {
  __typename: "ScheduleRequest",
  scheduleId?: number | null,
  gymName?: string | null,
  gymChainName?: string | null,
  scheduleName?: string | null,
  status?: string | null,
  createdDate?: string | null,
  weekdayId?: number | null,
  startTime?: string | null,
  endTime?: string | null,
  gymChainId?: number | null,
  weekdayName?: string | null,
  gymId?: number | null,
};

export type GymChainDropdownItem = {
  __typename: "GymChainDropdownItem",
  gymChainId?: number | null,
  gymChainName?: string | null,
};

export type AccessValidation = {
  __typename: "AccessValidation",
  accessStatus?: string | null,
  accessGranted?: boolean | null,
  isGraceAccess?: boolean | null,
  gracePeriod?: string | null,
  remainingGraceAccessCount?: number | null,
  accessRuleId?: number | null,
  isGranted?: boolean | null,
  isTrial?: boolean | null,
  activeSubscriptionIds?: Array< number | null > | null,
  validatedSubscriptionId?: number | null,
  subscriptionData?:  Array<AccessValidationSubscriptionData | null > | null,
};

export type AccessValidationSubscriptionData = {
  __typename: "AccessValidationSubscriptionData",
  subscriptionId?: number | null,
  programId?: number | null,
  scheduleType?: string | null,
};

export type MindbodyAppointmentRecord = {
  __typename: "MindbodyAppointmentRecord",
  id: number,
  memberLocationMembershipId?: number | null,
  importedId?: number | null,
  name?: string | null,
  startDateTime?: string | null,
  endDateTime?: string | null,
  isVisited?: boolean | null,
  isDeleted?: boolean | null,
  serviceCategory?: string | null,
  remainingVisits?: number | null,
  siteId?: number | null,
  customerSiteId?: string | null,
  locationId?: number | null,
  insideBlockTime?: boolean | null,
};

export type YellowboxBookingsOrAvailabilityResponse = {
  __typename: "YellowboxBookingsOrAvailabilityResponse",
  availability?:  Array<YellowboxAvailability | null > | null,
  bookings?:  Array<YellowboxBooking | null > | null,
};

export type YellowboxAvailability = {
  __typename: "YellowboxAvailability",
  prefix?: string | null,
  prefixLong?: string | null,
  availabilityBySize?:  Array<YellowboxAvailabilityBySize | null > | null,
};

export type YellowboxAvailabilityBySize = {
  __typename: "YellowboxAvailabilityBySize",
  size?: string | null,
  countAvailable?: number | null,
};

export type SiteScheduleDetails = {
  __typename: "SiteScheduleDetails",
  id?: number | null,
  siteScheduleId?: number | null,
  isRequested?: boolean | null,
  siteId?: number | null,
};

export type ActiveAccessCardForUserResponse = {
  __typename: "ActiveAccessCardForUserResponse",
  accessCardUID?: string | null,
  accessCardFormatName?: string | null,
  memberArxReferenceId?: string | null,
};

export type RelatedProgram = {
  __typename: "RelatedProgram",
  id?: number | null,
  siteId?: number | null,
  importedId?: number | null,
  programName?: string | null,
  scheduleType?: string | null,
  createdBy?: number | null,
  createdDate?: string | null,
  lastModifiedBy?: number | null,
  lastModifiedDate?: string | null,
  linkedProgramId?: number | null,
  linkCreatedBy?: number | null,
  linkCreatedDate?: string | null,
  linkLastModifiedBy?: number | null,
  linkLastModifiedDate?: string | null,
};

export type MemberSyncStatus = {
  __typename: "MemberSyncStatus",
  id?: number | null,
};

export type ArrivalValidation = {
  __typename: "ArrivalValidation",
  marked?: Array< number | null > | null,
  unmarked?: Array< number | null > | null,
};

export type MemberForPhoneNumber = {
  __typename: "MemberForPhoneNumber",
  id: number,
  userId?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
};

export type MobileMember = {
  __typename: "MobileMember",
  id: number,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  email?: string | null,
  arxReferenceId?: string | null,
  userId?: number | null,
};

export type RemoteUnlockMutationVariables = {
  input: RemoteUnlockInput,
};

export type RemoteUnlockMutation = {
  remoteUnlock?: boolean | null,
};

export type IssueGymKeyAccessCardMutationVariables = {
  input: IssueGymKeyAccessCardInput,
};

export type IssueGymKeyAccessCardMutation = {
  issueGymKeyAccessCard?: boolean | null,
};

export type DeactivateGymKeyAccessCardMutationVariables = {
  memberId: number,
  siteLocationId: number,
  lastModifiedBy: number,
  accessCardUID: string,
};

export type DeactivateGymKeyAccessCardMutation = {
  deactivateGymKeyAccessCard?: boolean | null,
};

export type AddItemMutationVariables = {
  input: ItemInput,
};

export type AddItemMutation = {
  addItem?:  {
    __typename: "Item",
    id: string,
    type: string,
    price?: number | null,
  } | null,
};

export type DeleteItemMutationVariables = {
  input: string,
};

export type DeleteItemMutation = {
  deleteItem?:  {
    __typename: "Item",
    id: string,
    type: string,
    price?: number | null,
  } | null,
};

export type AddUserMutationVariables = {
  input: UserInput,
};

export type AddUserMutation = {
  addUser?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type AddDeviceHistoryMutationVariables = {
  input: DeviceHistoryInput,
};

export type AddDeviceHistoryMutation = {
  addDeviceHistory?:  {
    __typename: "DeviceHistory",
    id: number,
    userId: number,
    appVersion: string,
    macAddress: string,
    uniqueId: string,
    model?: string | null,
    manufacturer?: string | null,
    isActive?: boolean | null,
    isCameraPresent?: boolean | null,
    locale?: string | null,
    type?: string | null,
    timeZone?: string | null,
    signedUpStatus?: boolean | null,
    country?: string | null,
    baseOs?: string | null,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type SetActiveDeviceMutationVariables = {
  id: number,
};

export type SetActiveDeviceMutation = {
  setActiveDevice?:  {
    __typename: "DeviceHistory",
    id: number,
    userId: number,
    appVersion: string,
    macAddress: string,
    uniqueId: string,
    model?: string | null,
    manufacturer?: string | null,
    isActive?: boolean | null,
    isCameraPresent?: boolean | null,
    locale?: string | null,
    type?: string | null,
    timeZone?: string | null,
    signedUpStatus?: boolean | null,
    country?: string | null,
    baseOs?: string | null,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type DeleteGymChainMutationVariables = {
  id: number,
};

export type DeleteGymChainMutation = {
  deleteGymChain?:  {
    __typename: "WebGymChain",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    supportPhone?: string | null,
    maximumNegativeBalance?: number | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    status?: string | null,
    membershipsImported?: boolean | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    createdDate?: string | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    imageUrl?: string | null,
    isDeleted?: boolean | null,
    arxReferenceId?: string | null,
    providerConnected?: boolean | null,
    isSodvinCompany?: boolean | null,
    gymCount?: number | null,
    allowConvertingAccessCards?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    processBookings?: boolean | null,
    processSales?: boolean | null,
    processAppointments?: boolean | null,
    fetchAccountBalance?: boolean | null,
    kisiApiKey?: string | null,
    kisiNightlySyncApiKey?: string | null,
    gymKeyChainId?: string | null,
    hardwareProvider?: HardwareProvider | null,
  } | null,
};

export type AddGymChainsMutationVariables = {
  input: WebGymChainInput,
};

export type AddGymChainsMutation = {
  addGymChains?:  {
    __typename: "WebGymChain",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    supportPhone?: string | null,
    maximumNegativeBalance?: number | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    status?: string | null,
    membershipsImported?: boolean | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    createdDate?: string | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    imageUrl?: string | null,
    isDeleted?: boolean | null,
    arxReferenceId?: string | null,
    providerConnected?: boolean | null,
    isSodvinCompany?: boolean | null,
    gymCount?: number | null,
    allowConvertingAccessCards?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    processBookings?: boolean | null,
    processSales?: boolean | null,
    processAppointments?: boolean | null,
    fetchAccountBalance?: boolean | null,
    kisiApiKey?: string | null,
    kisiNightlySyncApiKey?: string | null,
    gymKeyChainId?: string | null,
    hardwareProvider?: HardwareProvider | null,
  } | null,
};

export type ModifyGymChainMutationVariables = {
  input: WebGymChainInput,
};

export type ModifyGymChainMutation = {
  modifyGymChain?:  {
    __typename: "WebGymChain",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    supportPhone?: string | null,
    maximumNegativeBalance?: number | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    status?: string | null,
    membershipsImported?: boolean | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    createdDate?: string | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    imageUrl?: string | null,
    isDeleted?: boolean | null,
    arxReferenceId?: string | null,
    providerConnected?: boolean | null,
    isSodvinCompany?: boolean | null,
    gymCount?: number | null,
    allowConvertingAccessCards?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    processBookings?: boolean | null,
    processSales?: boolean | null,
    processAppointments?: boolean | null,
    fetchAccountBalance?: boolean | null,
    kisiApiKey?: string | null,
    kisiNightlySyncApiKey?: string | null,
    gymKeyChainId?: string | null,
    hardwareProvider?: HardwareProvider | null,
  } | null,
};

export type DeleteGymMutationVariables = {
  id: number,
};

export type DeleteGymMutation = {
  deleteGym?:  {
    __typename: "SiteLocation",
    id: number,
    siteId: number,
    siteLocationIdApi: number,
    locationName: string,
    locationContactPerson?: string | null,
    locationPhone?: string | null,
    locationEmail?: string | null,
    locationAddress?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    freePassId?: number | null,
    trailMembershipId?: number | null,
    staffAccessMembershipId?: string | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    isLockerEnabled?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
  } | null,
};

export type DeleteKisiDoorMutationVariables = {
  id: number,
  lastModifiedBy: number,
};

export type DeleteKisiDoorMutation = {
  deleteKisiDoor?:  {
    __typename: "KisiDoor",
    id: number,
    siteId: number,
    siteLocationId: number,
    kisiDoorId: number,
    kisiDoorName: string,
    kisiPlaceId: number,
    kisiPlaceName: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
  } | null,
};

export type AddMembershipMutationVariables = {
  input: MembershipInput,
};

export type AddMembershipMutation = {
  addMembership?:  {
    __typename: "Membership",
    id?: number | null,
    siteId?: number | null,
    importedId?: number | null,
    membershipName?: string | null,
    membershipTypeId?: number | null,
    isImported?: boolean | null,
    validityPeriod?: number | null,
    isMinusCreditBalanceApplied?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ModifyMembershipMutationVariables = {
  input: MembershipInput,
};

export type ModifyMembershipMutation = {
  modifyMembership?:  {
    __typename: "Membership",
    id?: number | null,
    siteId?: number | null,
    importedId?: number | null,
    membershipName?: string | null,
    membershipTypeId?: number | null,
    isImported?: boolean | null,
    validityPeriod?: number | null,
    isMinusCreditBalanceApplied?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type AddGymChainAccessCategoryMutationVariables = {
  input: GymChainAccessCategoryInput,
};

export type AddGymChainAccessCategoryMutation = {
  addGymChainAccessCategory?:  {
    __typename: "GymChainAccessCategory",
    id?: number | null,
    siteId?: number | null,
    name?: string | null,
    gender?: string | null,
    age?: number | null,
    schedulesOnly?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ModifyGymChainAccessCategoryMutationVariables = {
  input: GymChainAccessCategoryInput,
};

export type ModifyGymChainAccessCategoryMutation = {
  modifyGymChainAccessCategory?:  {
    __typename: "GymChainAccessCategory",
    id?: number | null,
    siteId?: number | null,
    name?: string | null,
    gender?: string | null,
    age?: number | null,
    schedulesOnly?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type AddGymMutationVariables = {
  input: GymInput,
};

export type AddGymMutation = {
  addGym?:  {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null,
};

export type AddKisiDoorMutationVariables = {
  input: KisiDoorInput,
};

export type AddKisiDoorMutation = {
  addKisiDoor?:  {
    __typename: "KisiDoor",
    id: number,
    siteId: number,
    siteLocationId: number,
    kisiDoorId: number,
    kisiDoorName: string,
    kisiPlaceId: number,
    kisiPlaceName: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
  } | null,
};

export type SetProfilePictureMutationVariables = {
  input: UserInput,
};

export type SetProfilePictureMutation = {
  setProfilePicture?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type AddSiteLocationMembershipMutationVariables = {
  input?: SiteLocationMembershipInput | null,
};

export type AddSiteLocationMembershipMutation = {
  addSiteLocationMembership?:  {
    __typename: "SiteLocationMembership",
    id?: number | null,
    siteLocationId?: number | null,
    membershipId?: number | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type RemoveSiteLocationMembershipMutationVariables = {
  id?: number | null,
};

export type RemoveSiteLocationMembershipMutation = {
  removeSiteLocationMembership?:  {
    __typename: "SiteLocationMembership",
    id?: number | null,
    siteLocationId?: number | null,
    membershipId?: number | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type SelectSubscriptionsMutationVariables = {
  input?: SubscriptionSelection | null,
};

export type SelectSubscriptionsMutation = {
  selectSubscriptions?:  Array< {
    __typename: "SelectionStatus",
    id: number,
    isSelected: boolean,
  } | null > | null,
};

export type RejectSubscriptionsMutationVariables = {
  input?: SubscriptionRejection | null,
};

export type RejectSubscriptionsMutation = {
  rejectSubscriptions?:  Array< {
    __typename: "RejectionStatus",
    id: number,
    isRejected: boolean,
  } | null > | null,
};

export type DeleteMembershipMutationVariables = {
  id: number,
};

export type DeleteMembershipMutation = {
  deleteMembership?:  {
    __typename: "Membership",
    id?: number | null,
    siteId?: number | null,
    importedId?: number | null,
    membershipName?: string | null,
    membershipTypeId?: number | null,
    isImported?: boolean | null,
    validityPeriod?: number | null,
    isMinusCreditBalanceApplied?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ModifyGymMutationVariables = {
  input: GymInput,
};

export type ModifyGymMutation = {
  modifyGym?:  {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null,
};

export type ModifyKisiDoorMutationVariables = {
  input: KisiDoorInput,
};

export type ModifyKisiDoorMutation = {
  modifyKisiDoor?:  {
    __typename: "KisiDoor",
    id: number,
    siteId: number,
    siteLocationId: number,
    kisiDoorId: number,
    kisiDoorName: string,
    kisiPlaceId: number,
    kisiPlaceName: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
  } | null,
};

export type AddLocationOpeningHourMutationVariables = {
  input: LocationOpeningHourInput,
};

export type AddLocationOpeningHourMutation = {
  addLocationOpeningHour?:  {
    __typename: "LocationOpeningHour",
    id: number,
    locationId: number,
    name: string,
    isHoliday?: boolean | null,
    isGeneral?: boolean | null,
    validFromDateTime: string,
    validToDateTime: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    status: string,
    isDeleted?: boolean | null,
  } | null,
};

export type AddLocationOpeningHourDetailMutationVariables = {
  input: LocationOpeningHourDetailInput,
};

export type AddLocationOpeningHourDetailMutation = {
  addLocationOpeningHourDetail?: number | null,
};

export type UpdateImportMembershipSiteMutationVariables = {
  status: boolean,
  siteId: number,
};

export type UpdateImportMembershipSiteMutation = {
  updateImportMembershipSite?:  {
    __typename: "Site",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    membershipsImported?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ModifyLocationOpeningHourMutationVariables = {
  input: LocationOpeningHourInput,
};

export type ModifyLocationOpeningHourMutation = {
  modifyLocationOpeningHour?:  {
    __typename: "LocationOpeningHour",
    id: number,
    locationId: number,
    name: string,
    isHoliday?: boolean | null,
    isGeneral?: boolean | null,
    validFromDateTime: string,
    validToDateTime: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    status: string,
    isDeleted?: boolean | null,
  } | null,
};

export type RemoveLocationOpeningHourDetailByDayMutationVariables = {
  openingHourId: number,
  dayOfWeek: string,
};

export type RemoveLocationOpeningHourDetailByDayMutation = {
  removeLocationOpeningHourDetailByDay?:  {
    __typename: "LocationOpeningHourDetail",
    id?: number | null,
    openingHourId?: number | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    dayOfWeek?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type RemoveLocationOpeningHourDetailByTimeMutationVariables = {
  openingHourId: number,
  startDateTime: string,
  endDateTime: string,
};

export type RemoveLocationOpeningHourDetailByTimeMutation = {
  removeLocationOpeningHourDetailByTime?:  {
    __typename: "LocationOpeningHourDetail",
    id?: number | null,
    openingHourId?: number | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    dayOfWeek?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type AddLocationMembershipOpeningHourMutationVariables = {
  input: LocationMembershipOpeningHourInput,
};

export type AddLocationMembershipOpeningHourMutation = {
  addLocationMembershipOpeningHour?: number | null,
};

export type DeleteLocationOpeningHoursMutationVariables = {
  id: number,
};

export type DeleteLocationOpeningHoursMutation = {
  deleteLocationOpeningHours?:  {
    __typename: "LocationOpeningHour",
    id: number,
    locationId: number,
    name: string,
    isHoliday?: boolean | null,
    isGeneral?: boolean | null,
    validFromDateTime: string,
    validToDateTime: string,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    status: string,
    isDeleted?: boolean | null,
  } | null,
};

export type RemoveLocationMembershipOpeningHourMutationVariables = {
  id: number,
};

export type RemoveLocationMembershipOpeningHourMutation = {
  removeLocationMembershipOpeningHour?:  {
    __typename: "LocationMembershipOpeningHour",
    id?: number | null,
    openingHourId?: number | null,
    membershipId?: number | null,
    name?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ChangeMemberLocationIsLockedMutationVariables = {
  memberId: number,
  gymId: number,
  isLocked: boolean,
};

export type ChangeMemberLocationIsLockedMutation = {
  changeMemberLocationIsLocked?:  {
    __typename: "ChangeMemberLocationIsLockedResponse",
    memberId?: number | null,
    gymId?: number | null,
    isLocked?: boolean | null,
  } | null,
};

export type ChangePhoneNumberMutationVariables = {
  siteId: number,
  customerSiteId: string,
  uniqueId: number,
  phoneNumber: string,
};

export type ChangePhoneNumberMutation = {
  changePhoneNumber?:  {
    __typename: "ChangePhoneNumberResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
  } | null,
};

export type ChangeUserLocationDetectionMethodMutationVariables = {
  memberId: number,
  method: string,
};

export type ChangeUserLocationDetectionMethodMutation = {
  changeUserLocationDetectionMethod?:  {
    __typename: "ChangeUserLocationDetectionResponse",
    memberId?: number | null,
    method?: string | null,
  } | null,
};

export type AddInquiryMutationVariables = {
  input: MemberInquiryInput,
};

export type AddInquiryMutation = {
  addInquiry?:  {
    __typename: "MemberInquiry",
    id: number,
    userId: number,
    phoneNumber?: string | null,
    email?: string | null,
    dateOfBirth?: string | null,
    address?: string | null,
    title?: string | null,
    messageDescription?: string | null,
  } | null,
};

export type AddLocationZoneMutationVariables = {
  input: LocationZoneInput,
  accessCategories?: Array< number | null > | null,
  programAccessCategories?: Array< number | null > | null,
};

export type AddLocationZoneMutation = {
  addLocationZone?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type AddLocationMembershipZoneMutationVariables = {
  input: LocationZoneMembershipInput,
};

export type AddLocationMembershipZoneMutation = {
  addLocationMembershipZone?: number | null,
};

export type ModifyLocationZoneMutationVariables = {
  input: LocationZoneInput,
};

export type ModifyLocationZoneMutation = {
  modifyLocationZone?:  {
    __typename: "LocationZone",
    id?: number | null,
    siteLocationId?: number | null,
    zoneName?: string | null,
    zoneDescription?: string | null,
    arxReferenceId?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    accessCategoryId?: number | null,
    accessCategoryName?: string | null,
    accessCategoryGender?: string | null,
    accessCategoryAge?: number | null,
    accessCategorySchedulesOnly?: boolean | null,
    accessCategoryStatus?: string | null,
    locationAccessCategoryZoneId?: number | null,
    locationAccessCategoryId?: number | null,
    siteAccessCategoryId?: number | null,
    locationAccessCategoryName?: string | null,
    locationAccessCategoryGender?: string | null,
    locationAccessCategoryArxRefId?: string | null,
    locationProgramAccessCategoryZoneId?: number | null,
    locationProgramAccessCategoryId?: number | null,
    siteProgramAccessCategoryId?: number | null,
    locationProgramAccessCategoryName?: string | null,
    locationProgramAccessCategoryGender?: string | null,
    locationProgramAccessCategoryArxRefId?: string | null,
    programId?: number | null,
    programName?: string | null,
    programImportedId?: number | null,
    programScheduleType?: string | null,
  } | null,
};

export type RemoveLocationMembershipZoneMutationVariables = {
  locationZoneId: number,
  membershipId: number,
};

export type RemoveLocationMembershipZoneMutation = {
  removeLocationMembershipZone?:  {
    __typename: "LocationZoneMembership",
    id?: number | null,
    locationZoneId?: number | null,
    membershipId?: number | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null,
};

export type RemoveZoneForSiteLocationMutationVariables = {
  id: number,
  userId: number,
};

export type RemoveZoneForSiteLocationMutation = {
  removeZoneForSiteLocation?: number | null,
};

export type ModifyMemberMutationVariables = {
  member: MemberInput,
};

export type ModifyMemberMutation = {
  modifyMember?:  {
    __typename: "Member",
    memberId?: number | null,
    memberFirstName?: string | null,
    memberLastName?: string | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    isStaffMember?: boolean | null,
    validFrom?: string | null,
    validTo?: string | null,
    signedUpDate?: string | null,
    phoneNumber?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastModifiedBy?: number | null,
    expiredDate?: string | null,
    isBlocked?: boolean | null,
    membership?: string | null,
    defaultGymDetectionMethod?: string | null,
    email?: string | null,
    profilePicturePath?: string | null,
    membershipStatus?: string | null,
    forcedAccessStartTime?: string | null,
    forcedAccessEndTime?: string | null,
    lastSyncDate?: string | null,
    subscriptionDeleted?: boolean | null,
    isNew?: boolean | null,
    isTrial?: boolean | null,
    arxReferenceId?: string | null,
    userId?: number | null,
  } | null,
};

export type AddMemberLocationMembershipMutationVariables = {
  input?: MemberLocationMembershipInput | null,
};

export type AddMemberLocationMembershipMutation = {
  addMemberLocationMembership?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type RemoveMemberLocationMembershipMutationVariables = {
  memberId: number,
  siteLocationMembershipId: number,
  userId: number,
};

export type RemoveMemberLocationMembershipMutation = {
  removeMemberLocationMembership?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type AddLocationAccessPointDoorMutationVariables = {
  input: LocationAccessPointDoorInput,
};

export type AddLocationAccessPointDoorMutation = {
  addLocationAccessPointDoor?:  {
    __typename: "LocationAccessPoint",
    id?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    accessPointType?: string | null,
    uniqueId?: string | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    doorARXId?: string | null,
    classId?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    handbackTime?: number | null,
    doorCaption?: string | null,
    priority?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    batteryLevel?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    fromZoneId?: number | null,
    toZoneId?: number | null,
    fromZoneName?: string | null,
    toZoneName?: string | null,
  } | null,
};

export type AddLocationAccessPointClassMutationVariables = {
  input: LocationAccessPointClassInput,
};

export type AddLocationAccessPointClassMutation = {
  addLocationAccessPointClass?:  {
    __typename: "LocationAccessPoint",
    id?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    accessPointType?: string | null,
    uniqueId?: string | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    doorARXId?: string | null,
    classId?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    handbackTime?: number | null,
    doorCaption?: string | null,
    priority?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    batteryLevel?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    fromZoneId?: number | null,
    toZoneId?: number | null,
    fromZoneName?: string | null,
    toZoneName?: string | null,
  } | null,
};

export type ModifyLocationAccessPointDoorMutationVariables = {
  input: LocationAccessPointDoorInput,
};

export type ModifyLocationAccessPointDoorMutation = {
  modifyLocationAccessPointDoor?:  {
    __typename: "LocationAccessPoint",
    id?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    accessPointType?: string | null,
    uniqueId?: string | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    doorARXId?: string | null,
    classId?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    handbackTime?: number | null,
    doorCaption?: string | null,
    priority?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    batteryLevel?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    fromZoneId?: number | null,
    toZoneId?: number | null,
    fromZoneName?: string | null,
    toZoneName?: string | null,
  } | null,
};

export type ModifyLocationAccessPointClassMutationVariables = {
  input: LocationAccessPointClassInput,
};

export type ModifyLocationAccessPointClassMutation = {
  modifyLocationAccessPointClass?:  {
    __typename: "LocationAccessPoint",
    id?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    accessPointType?: string | null,
    uniqueId?: string | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    doorARXId?: string | null,
    classId?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    handbackTime?: number | null,
    doorCaption?: string | null,
    priority?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    batteryLevel?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    fromZoneId?: number | null,
    toZoneId?: number | null,
    fromZoneName?: string | null,
    toZoneName?: string | null,
  } | null,
};

export type ModifyZoneAccessPointMutationVariables = {
  input: ZoneAccessPointInput,
};

export type ModifyZoneAccessPointMutation = {
  modifyZoneAccessPoint?: number | null,
};

export type AddZoneAccessPointMutationVariables = {
  input: ZoneAccessPointInput,
};

export type AddZoneAccessPointMutation = {
  addZoneAccessPoint?: number | null,
};

export type RemoveLocationAccessPointMutationVariables = {
  id: number,
  lastModifiedBy: number,
};

export type RemoveLocationAccessPointMutation = {
  removeLocationAccessPoint?: number | null,
};

export type AddMemberMobileNumberHistoryMutationVariables = {
  input?: MobileNumberHistoryInput | null,
};

export type AddMemberMobileNumberHistoryMutation = {
  addMemberMobileNumberHistory?: number | null,
};

export type ResyncMemberDataMutationVariables = {
  params?: ResyncMemberArgs | null,
};

export type ResyncMemberDataMutation = {
  resyncMemberData?:  {
    __typename: "ResyncMemberResponse",
    error?: string | null,
    message?: string | null,
    memberModified?: boolean | null,
    membershipsModified?: boolean | null,
  } | null,
};

export type RequestGymKeyClientInviteMutationVariables = {
  memberId: number,
};

export type RequestGymKeyClientInviteMutation = {
  requestGymKeyClientInvite?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type MindbodyNightlySyncMutationVariables = {
  siteId: number,
  syncInProgress: boolean,
};

export type MindbodyNightlySyncMutation = {
  mindbodyNightlySync?:  {
    __typename: "MindbodyNightlySyncResponse",
    error?: boolean | null,
    message?: string | null,
  } | null,
};

export type MindbodyNightlySyncStatusMutationVariables = {
  siteId: number,
};

export type MindbodyNightlySyncStatusMutation = {
  mindbodyNightlySyncStatus?:  {
    __typename: "MindbodyNightlySyncStatusResponse",
    error?: boolean | null,
    message?: string | null,
    nightlySyncRunning?: boolean | null,
  } | null,
};

export type HardwareProviderSyncMutationVariables = {
  locationId: number,
  syncInProgress: boolean,
};

export type HardwareProviderSyncMutation = {
  hardwareProviderSync?:  {
    __typename: "hardwareProviderSyncResponse",
    error?: boolean | null,
    message?: string | null,
  } | null,
};

export type HardwareProviderSyncStatusMutation = {
  hardwareProviderSyncStatus?:  {
    __typename: "hardwareProviderSyncStatusResponse",
    error?: boolean | null,
    message?: string | null,
    hardwareProviderSyncRunning?: boolean | null,
  } | null,
};

export type UpdateLocationAccessPointBatteryLevelMutationVariables = {
  id: number,
  batteryLevel: number,
};

export type UpdateLocationAccessPointBatteryLevelMutation = {
  updateLocationAccessPointBatteryLevel?: number | null,
};

export type AddUserInformationRequestMutationVariables = {
  userId: number,
  createdBy: number,
};

export type AddUserInformationRequestMutation = {
  addUserInformationRequest?: number | null,
};

export type SendInvitationEmailMutationVariables = {
  input: InvitationEmailInput,
};

export type SendInvitationEmailMutation = {
  sendInvitationEmail?:  {
    __typename: "EmailLambdaResponse",
    error: boolean,
    errorMessage?: string | null,
  } | null,
};

export type ArxImportPersonMutationVariables = {
  input: ArxPersonInput,
};

export type ArxImportPersonMutation = {
  arxImportPerson?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type UpdateAccessCardOfPersonMutationVariables = {
  input: ArxCarfOfPersonInput,
};

export type UpdateAccessCardOfPersonMutation = {
  updateAccessCardOfPerson?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type InactivateBeaconsMutationVariables = {
  input: InactivateBeaconsInput,
};

export type InactivateBeaconsMutation = {
  inactivateBeacons?: number | null,
};

export type ResolveMemberEventMutationVariables = {
  resolvedDescription: string,
  memberEventId: number,
  memberAssignmentId: number,
  memberEventStatusId: number,
  assignedRoleId: number,
  userId: number,
};

export type ResolveMemberEventMutation = {
  resolveMemberEvent?: number | null,
};

export type CloseMemberEventMutationVariables = {
  memberEventId: number,
  memberAssignmentId: number,
  memberEventStatusId: number,
  closedDescription: string,
  lastModifiedBy: number,
};

export type CloseMemberEventMutation = {
  closeMemberEvent?: number | null,
};

export type AssignMemberEventMutationVariables = {
  input: AssignMemberEventInput,
};

export type AssignMemberEventMutation = {
  assignMemberEvent?: number | null,
};

export type UpdateMemberEventStatusMutationVariables = {
  memberEventId: number,
  memberEventStatusId: number,
};

export type UpdateMemberEventStatusMutation = {
  updateMemberEventStatus?: number | null,
};

export type AddMemberEventMutationVariables = {
  input: MemberEventInput,
};

export type AddMemberEventMutation = {
  addMemberEvent?:  {
    __typename: "MemberEvent",
    id: number,
    memberId: number,
    eventId: number,
    isAutoAssigned?: boolean | null,
    lastModifiedBy: number,
    siteLocationId?: number | null,
  } | null,
};

export type RemoveSiteLocationAccessCategoryMutationVariables = {
  ids: Array< number | null >,
  siteLocationId: number,
};

export type RemoveSiteLocationAccessCategoryMutation = {
  removeSiteLocationAccessCategory?: number | null,
};

export type RemoveProgramAccessCategoryMutationVariables = {
  id: number,
};

export type RemoveProgramAccessCategoryMutation = {
  removeProgramAccessCategory?: number | null,
};

export type RemoveSiteAccessCategoryMutationVariables = {
  ids: Array< number | null >,
};

export type RemoveSiteAccessCategoryMutation = {
  removeSiteAccessCategory?: number | null,
};

export type AddAccessCategoryMutationVariables = {
  input: AddSiteLocationAccessCategoryInput,
};

export type AddAccessCategoryMutation = {
  addAccessCategory?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type AddProgramAccessCategoryMutationVariables = {
  input: AddProgramAccessCategoryInput,
};

export type AddProgramAccessCategoryMutation = {
  addProgramAccessCategory?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type AddSiteLocationProgramAccessCategoryMutationVariables = {
  input: AddSiteLocationProgramAccessCategoryInput,
};

export type AddSiteLocationProgramAccessCategoryMutation = {
  addSiteLocationProgramAccessCategory?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type ModifyAccessCategoryMutationVariables = {
  input: SiteLocationAccessCategoryInput,
};

export type ModifyAccessCategoryMutation = {
  modifyAccessCategory?: number | null,
};

export type RemoveSiteLocationProgramAccessCategoryMutationVariables = {
  ids: Array< number >,
  siteLocationId: number,
};

export type RemoveSiteLocationProgramAccessCategoryMutation = {
  removeSiteLocationProgramAccessCategory?: number | null,
};

export type AddSubscriptionToMemberMutationVariables = {
  userId: number,
  siteLocationMembershipId: number,
  isGranted?: boolean | null,
};

export type AddSubscriptionToMemberMutation = {
  addSubscriptionToMember?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type LinkUserToMemberMutationVariables = {
  memberId: number,
  userId: number,
};

export type LinkUserToMemberMutation = {
  linkUserToMember?: number | null,
};

export type LinkMemberMutationVariables = {
  memberId: number,
};

export type LinkMemberMutation = {
  linkMember?: number | null,
};

export type LinkMemberToEventMutationVariables = {
  memberId: number,
  eventId: number,
};

export type LinkMemberToEventMutation = {
  linkMemberToEvent?: number | null,
};

export type UnlinkMemberMutationVariables = {
  memberId: number,
};

export type UnlinkMemberMutation = {
  unlinkMember?: number | null,
};

export type AddMemberMutationVariables = {
  input: MemberInput,
};

export type AddMemberMutation = {
  addMember?:  {
    __typename: "Member",
    memberId?: number | null,
    memberFirstName?: string | null,
    memberLastName?: string | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    isStaffMember?: boolean | null,
    validFrom?: string | null,
    validTo?: string | null,
    signedUpDate?: string | null,
    phoneNumber?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastModifiedBy?: number | null,
    expiredDate?: string | null,
    isBlocked?: boolean | null,
    membership?: string | null,
    defaultGymDetectionMethod?: string | null,
    email?: string | null,
    profilePicturePath?: string | null,
    membershipStatus?: string | null,
    forcedAccessStartTime?: string | null,
    forcedAccessEndTime?: string | null,
    lastSyncDate?: string | null,
    subscriptionDeleted?: boolean | null,
    isNew?: boolean | null,
    isTrial?: boolean | null,
    arxReferenceId?: string | null,
    userId?: number | null,
  } | null,
};

export type SendIssueCloseEmailMutationVariables = {
  input: IssueCloseEmailInput,
};

export type SendIssueCloseEmailMutation = {
  sendIssueCloseEmail?:  {
    __typename: "EmailLambdaResponse",
    error: boolean,
    errorMessage?: string | null,
  } | null,
};

export type AddLocationAccessCategoryZoneMutationVariables = {
  input?: LocationAccessCategoryZoneInput | null,
};

export type AddLocationAccessCategoryZoneMutation = {
  addLocationAccessCategoryZone?: number | null,
};

export type AddLocationProgramAccessCategoryZoneMutationVariables = {
  input?: LocationProgramAccessCategoryZoneInput | null,
};

export type AddLocationProgramAccessCategoryZoneMutation = {
  addLocationProgramAccessCategoryZone?: number | null,
};

export type RemoveLocationAccessCategoryZoneMutationVariables = {
  locationZoneId: number,
  accessCategoryId: number,
  userId: number,
};

export type RemoveLocationAccessCategoryZoneMutation = {
  removeLocationAccessCategoryZone?: number | null,
};

export type RemoveLocationProgramAccessCategoryZoneMutationVariables = {
  locationZoneId: number,
  locationProgramAccessCategoryId: number,
  userId: number,
};

export type RemoveLocationProgramAccessCategoryZoneMutation = {
  removeLocationProgramAccessCategoryZone?: number | null,
};

export type RemoveDaySchedulesMutationVariables = {
  id?: number | null,
};

export type RemoveDaySchedulesMutation = {
  removeDaySchedules?:  {
    __typename: "DaySchedule",
    id?: number | null,
    name?: string | null,
    arxReferenceId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    status?: string | null,
    weekdayId?: number | null,
    weekdayName?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null,
};

export type AddDayScheduleMutationVariables = {
  input: DayScheduleInput,
};

export type AddDayScheduleMutation = {
  addDaySchedule?:  {
    __typename: "DaySchedule",
    id?: number | null,
    name?: string | null,
    arxReferenceId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    status?: string | null,
    weekdayId?: number | null,
    weekdayName?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null,
};

export type ModifyDayScheduleMutationVariables = {
  input: DayScheduleInput,
};

export type ModifyDayScheduleMutation = {
  modifyDaySchedule?:  {
    __typename: "DaySchedule",
    id?: number | null,
    name?: string | null,
    arxReferenceId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    status?: string | null,
    weekdayId?: number | null,
    weekdayName?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null,
};

export type UpdateUserInformationRequestMutationVariables = {
  userId: number,
  updatedBy: number,
};

export type UpdateUserInformationRequestMutation = {
  updateUserInformationRequest?: number | null,
};

export type SignUpMobileUserMutationVariables = {
  input: SignUpMobileUser,
};

export type SignUpMobileUserMutation = {
  signUpMobileUser?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type AddInquiryEventMutationVariables = {
  input: InquiryEventInput,
};

export type AddInquiryEventMutation = {
  addInquiryEvent?:  {
    __typename: "MemberInquiry",
    id: number,
    userId: number,
    phoneNumber?: string | null,
    email?: string | null,
    dateOfBirth?: string | null,
    address?: string | null,
    title?: string | null,
    messageDescription?: string | null,
  } | null,
};

export type AddSiteSchedulesMutationVariables = {
  input: SiteScheduleInput,
};

export type AddSiteSchedulesMutation = {
  addSiteSchedules?:  {
    __typename: "SiteSchedule",
    id?: number | null,
    siteId?: number | null,
    name?: string | null,
    type?: string | null,
    validFrom?: string | null,
    validTo?: string | null,
    utcValidFrom?: string | null,
    utcValidTo?: string | null,
    scheduleStatusId?: number | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    status?: string | null,
  } | null,
};

export type AddSiteLocationSchedulesForAccessCategoryMutationVariables = {
  input: SiteLocationScheduleForAccessCategoryInput,
};

export type AddSiteLocationSchedulesForAccessCategoryMutation = {
  addSiteLocationSchedulesForAccessCategory?: number | null,
};

export type AddSiteScheduleDetailsMutationVariables = {
  input: SiteScheduleDetailsInput,
};

export type AddSiteScheduleDetailsMutation = {
  addSiteScheduleDetails?: number | null,
};

export type AddSiteLocationSchedulesForLocationAccessPointMutationVariables = {
  input: SiteLocationScheduleForLocationAccessPointInput,
};

export type AddSiteLocationSchedulesForLocationAccessPointMutation = {
  addSiteLocationSchedulesForLocationAccessPoint?: number | null,
};

export type RemoveSiteSchedulesMutationVariables = {
  id: number,
  userId: number,
  siteId: number,
};

export type RemoveSiteSchedulesMutation = {
  removeSiteSchedules?: number | null,
};

export type RemoveSiteLocationSchedulesMutationVariables = {
  siteScheduleId: number,
  userId: number,
};

export type RemoveSiteLocationSchedulesMutation = {
  removeSiteLocationSchedules?: number | null,
};

export type RemoveSiteSchedulesDetailsMutationVariables = {
  siteScheduleId: number,
  userId: number,
};

export type RemoveSiteSchedulesDetailsMutation = {
  removeSiteSchedulesDetails?: number | null,
};

export type UpdateScheduleStatusIdMutationVariables = {
  siteScheduleId: number,
  scheduleStatusId: number,
  userId: number,
  siteId: number,
};

export type UpdateScheduleStatusIdMutation = {
  updateScheduleStatusId?: number | null,
};

export type UpdateSiteScheduleMutationVariables = {
  input: SiteScheduleInput,
};

export type UpdateSiteScheduleMutation = {
  updateSiteSchedule?: number | null,
};

export type RemoveSiteScheduleDetailRecordMutationVariables = {
  id: number,
  userId: number,
  siteId: number,
};

export type RemoveSiteScheduleDetailRecordMutation = {
  removeSiteScheduleDetailRecord?: number | null,
};

export type RemoveSiteLocationScheduleAccessCategoryRecordMutationVariables = {
  accessCategoryId: number,
  zoneId: number,
  scheduleId: number,
  userId: number,
  siteId: number,
};

export type RemoveSiteLocationScheduleAccessCategoryRecordMutation = {
  removeSiteLocationScheduleAccessCategoryRecord?: number | null,
};

export type RemoveSiteLocationScheduleAccessPointRecordMutationVariables = {
  locationAccessPointId: number,
  zoneId: number,
  scheduleId: number,
  userId: number,
  siteId: number,
};

export type RemoveSiteLocationScheduleAccessPointRecordMutation = {
  removeSiteLocationScheduleAccessPointRecord?: number | null,
};

export type UpdateScheduleStatusMutationVariables = {
  siteScheduleId: number,
  status: string,
  userId: number,
  siteId: number,
};

export type UpdateScheduleStatusMutation = {
  updateScheduleStatus?: number | null,
};

export type SwitchMobileAppMutationVariables = {
  id: number,
  isDisable: boolean,
  updatedBy: number,
};

export type SwitchMobileAppMutation = {
  switchMobileApp?: number | null,
};

export type AddNewAccessCardHistoryMutationVariables = {
  input: AccessCardHistoryInput,
};

export type AddNewAccessCardHistoryMutation = {
  addNewAccessCardHistory?:  {
    __typename: "AddAccessCardResponse",
    existingCardsCount?: number | null,
  } | null,
};

export type DeactivateAccessCardForSiteLocationMutationVariables = {
  memberId: number,
  siteLocationId: number,
  lastModifiedBy: number,
  deactivatedDateTime: string,
};

export type DeactivateAccessCardForSiteLocationMutation = {
  deactivateAccessCardForSiteLocation?: number | null,
};

export type UpdateAccessCardHistoryMutationVariables = {
  cardId: string,
  lastModifiedBy: number,
  deactivatedDateTime: string,
};

export type UpdateAccessCardHistoryMutation = {
  updateAccessCardHistory?: number | null,
};

export type RemoveUserMutationVariables = {
  id: number,
  updatedBy: number,
};

export type RemoveUserMutation = {
  removeUser?: number | null,
};

export type ModifyMobileUserMutationVariables = {
  input: UserInput,
};

export type ModifyMobileUserMutation = {
  modifyMobileUser?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type AddWebUserMutationVariables = {
  input: WebUserInput,
};

export type AddWebUserMutation = {
  addWebUser?:  {
    __typename: "UserManagementResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    success?: boolean | null,
  } | null,
};

export type UpdateWebUserMutationVariables = {
  input: WebUserModifyInput,
};

export type UpdateWebUserMutation = {
  updateWebUser?:  {
    __typename: "UserManagementResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    success?: boolean | null,
  } | null,
};

export type DeleteWebUserMutationVariables = {
  email: string,
  lastModifiedUserId: number,
};

export type DeleteWebUserMutation = {
  deleteWebUser?:  {
    __typename: "UserManagementResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    success?: boolean | null,
  } | null,
};

export type GiveForcedAccessMutationVariables = {
  input: GiveForcedAccessInput,
};

export type GiveForcedAccessMutation = {
  giveForcedAccess?: number | null,
};

export type ExpireForcedAccessMutationVariables = {
  memberId: number,
  userId: number,
  siteLocationId: number,
};

export type ExpireForcedAccessMutation = {
  expireForcedAccess?: number | null,
};

export type PushGymVisitEntryMutationVariables = {
  input: GymVisitActivityInput,
};

export type PushGymVisitEntryMutation = {
  pushGymVisitEntry?:  {
    __typename: "GymVisitActivity",
    memberEventId?: number | null,
    memberId?: number | null,
    memberEmail?: string | null,
    eventId?: number | null,
    eventDescription?: string | null,
    eventType?: string | null,
    stageId?: number | null,
    stage?: string | null,
    createdTime?: string | null,
    isAutoAssigned?: boolean | null,
    memberEventStatusTypeId?: number | null,
    memberEventStatusType?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    siteLocationId?: number | null,
    assignedUserId?: number | null,
    assignmentHistoryId?: number | null,
    locationName?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    inquiryDescription?: string | null,
    memberLocationId?: number | null,
    informationReceivedEvent?: boolean | null,
  } | null,
};

export type RemoveMobileUserMutationVariables = {
  userId: number,
  memberId?: number | null,
};

export type RemoveMobileUserMutation = {
  removeMobileUser?: number | null,
};

export type ProvisionMindbodyStaffAccountMutationVariables = {
  input: ProvisionStaffAccountInput,
};

export type ProvisionMindbodyStaffAccountMutation = {
  provisionMindbodyStaffAccount?: number | null,
};

export type AddStaffAccountMutationVariables = {
  input: StaffAccountInput,
};

export type AddStaffAccountMutation = {
  addStaffAccount?: number | null,
};

export type RemoveStaffAccountMutationVariables = {
  userId: number,
  siteId: number,
};

export type RemoveStaffAccountMutation = {
  removeStaffAccount?: number | null,
};

export type MapMatchingRecordsMutationVariables = {
  input: memberMappingInput,
};

export type MapMatchingRecordsMutation = {
  mapMatchingRecords?:  {
    __typename: "MapMatchingRecordsResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
  } | null,
};

export type DeleteMemberLocationMembershipMutationVariables = {
  id: number,
  userId: number,
};

export type DeleteMemberLocationMembershipMutation = {
  deleteMemberLocationMembership?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type AddRequestInfoEventMutationVariables = {
  input: RequestInfoMemberEventInput,
};

export type AddRequestInfoEventMutation = {
  addRequestInfoEvent?:  {
    __typename: "MemberInquiry",
    id: number,
    userId: number,
    phoneNumber?: string | null,
    email?: string | null,
    dateOfBirth?: string | null,
    address?: string | null,
    title?: string | null,
    messageDescription?: string | null,
  } | null,
};

export type SendRequestMoreInformationEmailMutationVariables = {
  input: sendRequestMoreInformationEmailInput,
};

export type SendRequestMoreInformationEmailMutation = {
  sendRequestMoreInformationEmail?:  {
    __typename: "EmailLambdaResponse",
    error: boolean,
    errorMessage?: string | null,
  } | null,
};

export type MapMembersWithUserMutationVariables = {
  input?: MapMembersWithUserInput | null,
};

export type MapMembersWithUserMutation = {
  mapMembersWithUser?:  Array< {
    __typename: "MemberUserMapStatus",
    id: number,
    userId: number,
  } | null > | null,
};

export type UpdateAccessCategoryGroupIdMutationVariables = {
  input?: updateAccessCategoryGroupIdInput | null,
};

export type UpdateAccessCategoryGroupIdMutation = {
  updateAccessCategoryGroupId?:  Array< {
    __typename: "SiteLocationAccessCategory",
    id?: number | null,
    name?: string | null,
    arxAccessCategoryId?: string | null,
    gender?: string | null,
    age?: number | null,
    siteLocationMembershipId?: number | null,
    membershipName?: string | null,
    program?: string | null,
    scheduleType?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    siteLocationId?: number | null,
    schedulesOnly?: boolean | null,
  } | null > | null,
};

export type UpdateSiteLocationProgramAccessCategoryGroupIdMutationVariables = {
  input: UpdateSiteLocationProgramAccessCategoryGroupIdInput,
};

export type UpdateSiteLocationProgramAccessCategoryGroupIdMutation = {
  updateSiteLocationProgramAccessCategoryGroupId?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type CreateMobileUserMutationVariables = {
  input?: CreateMobileUserInput | null,
};

export type CreateMobileUserMutation = {
  createMobileUser?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type CreateOrGetGymMemberMutationVariables = {
  input?: CreateOrGetGymMemberInput | null,
};

export type CreateOrGetGymMemberMutation = {
  createOrGetGymMember?:  {
    __typename: "Member",
    memberId?: number | null,
    memberFirstName?: string | null,
    memberLastName?: string | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    isStaffMember?: boolean | null,
    validFrom?: string | null,
    validTo?: string | null,
    signedUpDate?: string | null,
    phoneNumber?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastModifiedBy?: number | null,
    expiredDate?: string | null,
    isBlocked?: boolean | null,
    membership?: string | null,
    defaultGymDetectionMethod?: string | null,
    email?: string | null,
    profilePicturePath?: string | null,
    membershipStatus?: string | null,
    forcedAccessStartTime?: string | null,
    forcedAccessEndTime?: string | null,
    lastSyncDate?: string | null,
    subscriptionDeleted?: boolean | null,
    isNew?: boolean | null,
    isTrial?: boolean | null,
    arxReferenceId?: string | null,
    userId?: number | null,
  } | null,
};

export type DeleteMobileUserMutationVariables = {
  userId: number,
};

export type DeleteMobileUserMutation = {
  deleteMobileUser?: number | null,
};

export type ReportIssueMutationVariables = {
  input: ReportIssueInput,
};

export type ReportIssueMutation = {
  reportIssue?:  {
    __typename: "MemberInquiry",
    id: number,
    userId: number,
    phoneNumber?: string | null,
    email?: string | null,
    dateOfBirth?: string | null,
    address?: string | null,
    title?: string | null,
    messageDescription?: string | null,
  } | null,
};

export type AddFreeSubscriptionToMemberMutationVariables = {
  userId: number,
  memberId: number,
  siteLocationMembershipId: number,
  isGranted?: boolean | null,
  isTrial?: boolean | null,
};

export type AddFreeSubscriptionToMemberMutation = {
  addFreeSubscriptionToMember?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type UpdateSubscriptionMinusCrBalByMembershipIdMutationVariables = {
  membershipId: number,
  hasMinusCreditBalance?: boolean | null,
};

export type UpdateSubscriptionMinusCrBalByMembershipIdMutation = {
  updateSubscriptionMinusCrBalByMembershipId?:  Array< {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } > | null,
};

export type AddAccessPointMutationVariables = {
  input: AddAccessPointInput,
};

export type AddAccessPointMutation = {
  addAccessPoint?: number | null,
};

export type ModifyAccessPointMutationVariables = {
  input: ModifyAccessPointInput,
};

export type ModifyAccessPointMutation = {
  modifyAccessPoint?: number | null,
};

export type ModifyAccessRuleMutationVariables = {
  input: AccessRuleInput,
};

export type ModifyAccessRuleMutation = {
  modifyAccessRule?: number | null,
};

export type RevertAccessRuleMutationVariables = {
  ruleId: number,
  userId: number,
};

export type RevertAccessRuleMutation = {
  revertAccessRule?: number | null,
};

export type AddMobileVisitsMutationVariables = {
  input?: Array< MobileVisitInput | null > | null,
};

export type AddMobileVisitsMutation = {
  addMobileVisits?: number | null,
};

export type RemoveScheduleRequestMutationVariables = {
  id: number,
  userId: number,
};

export type RemoveScheduleRequestMutation = {
  removeScheduleRequest?: number | null,
};

export type ResolveScheduleRequestMutationVariables = {
  id: number,
  userId: number,
  dayScheduleId: number,
};

export type ResolveScheduleRequestMutation = {
  resolveScheduleRequest?: number | null,
};

export type AddGraceAccessEntryMutationVariables = {
  subscriptionId: number,
  accessRuleId: number,
  userId: number,
};

export type AddGraceAccessEntryMutation = {
  addGraceAccessEntry?: boolean | null,
};

export type UpdateMindbodyClientVisitMutationVariables = {
  input?: Array< UpdateClientVisitInput | null > | null,
};

export type UpdateMindbodyClientVisitMutation = {
  updateMindbodyClientVisit?: number | null,
};

export type AddMindbodyArrivalMutationVariables = {
  input: AddClientArrivalInput,
};

export type AddMindbodyArrivalMutation = {
  addMindbodyArrival?:  {
    __typename: "MemberLocationMembershipType",
    id?: number | null,
    siteLocationMembershipId?: number | null,
    memberId?: number | null,
    status?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isSelected?: boolean | null,
    isNotMyGym?: boolean | null,
    isRejected?: boolean | null,
    isDeleted?: boolean | null,
    isGranted?: boolean | null,
  } | null,
};

export type SendMobileUserSignUpSuccessEmailMutationVariables = {
  input: InvitationEmailInput,
};

export type SendMobileUserSignUpSuccessEmailMutation = {
  sendMobileUserSignUpSuccessEmail?:  {
    __typename: "EmailLambdaResponse",
    error: boolean,
    errorMessage?: string | null,
  } | null,
};

export type CreateYellowboxBookingMutationVariables = {
  input?: YellowboxCreateBookingInput | null,
};

export type CreateYellowboxBookingMutation = {
  createYellowboxBooking?:  {
    __typename: "YellowboxBooking",
    lockerId?: string | null,
    location?: string | null,
    lockerNumber?: number | null,
    prefix?: string | null,
    prefixLong?: string | null,
    bookingStart?: string | null,
  } | null,
};

export type EndYellowboxBookingMutationVariables = {
  lockerId: string,
};

export type EndYellowboxBookingMutation = {
  endYellowboxBooking?: boolean | null,
};

export type UnlockYellowboxLockerMutationVariables = {
  memberId: string,
  lockerId: string,
};

export type UnlockYellowboxLockerMutation = {
  unlockYellowboxLocker?: boolean | null,
};

export type SetYellowboxMemberPinMutationVariables = {
  memberId: string,
  pin: string,
};

export type SetYellowboxMemberPinMutation = {
  setYellowboxMemberPin?: number | null,
};

export type RemoveUserAccessCardOfPersonMutationVariables = {
  input: ArxCarfOfPersonInput,
};

export type RemoveUserAccessCardOfPersonMutation = {
  removeUserAccessCardOfPerson?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type DeactivateAccessCardForUserMutationVariables = {
  userId: number,
  lastModifiedBy: number,
  deactivatedDateTime: string,
};

export type DeactivateAccessCardForUserMutation = {
  deactivateAccessCardForUser?: number | null,
};

export type AddSiteLocationUserRecordMutationVariables = {
  input: SiteLocationUserRecordInput,
};

export type AddSiteLocationUserRecordMutation = {
  addSiteLocationUserRecord?: number | null,
};

export type ActivateScheduleStatusMutationVariables = {
  siteScheduleId: number,
  scheduleStatusId: number,
  userId: number,
  siteId: number,
};

export type ActivateScheduleStatusMutation = {
  activateScheduleStatus?: number | null,
};

export type UpdateMemberFlagMutationVariables = {
  flag: number,
  memberId: number,
};

export type UpdateMemberFlagMutation = {
  updateMemberFlag?: number | null,
};

export type UpdateDefaultLocationDetectionMethodMutationVariables = {
  defaultLocationDetectionMethod: string,
  id: number,
};

export type UpdateDefaultLocationDetectionMethodMutation = {
  updateDefaultLocationDetectionMethod?: number | null,
};

export type ModifyProgramMappingMutationVariables = {
  input: ModifyProgramInput,
};

export type ModifyProgramMappingMutation = {
  modifyProgramMapping?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type ManualMemberImportMutationVariables = {
  input: ManualMemberImportParams,
};

export type ManualMemberImportMutation = {
  manualMemberImport?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type UpdateMemberSyncStatusMutationVariables = {
  memberIds?: string | null,
};

export type UpdateMemberSyncStatusMutation = {
  updateMemberSyncStatus?: number | null,
};

export type RejectMemberMutationVariables = {
  memberId: number,
  rejectedBy: number,
};

export type RejectMemberMutation = {
  rejectMember?: boolean | null,
};

export type MarkArrivalsMutationVariables = {
  input?: MarkArrivalsInput | null,
};

export type MarkArrivalsMutation = {
  markArrivals?: boolean | null,
};

export type NotifyClassPortalMutationVariables = {
  siteLocationId: number,
};

export type NotifyClassPortalMutation = {
  notifyClassPortal?:  Array< {
    __typename: "ClassPortalData",
    id: number,
    importedId: number,
    name: string,
    siteLocationId: number,
    resourceId: number,
    staffId: number,
    startDateTime: string,
    endDateTime: string,
    maxCapacity: number,
    totalBooked: number,
    resourceMindbodyId: number,
    resourceName: string,
    resourceImageUrl?: string | null,
    staffMindbodyId: number,
    staffName: string,
    staffImageUrl?: string | null,
    imageUrl?: string | null,
  } | null > | null,
};

export type NotifyEmployeeDashboardMutationVariables = {
  siteLocationId: number,
};

export type NotifyEmployeeDashboardMutation = {
  notifyEmployeeDashboard?:  Array< {
    __typename: "KisiEvent",
    id: number,
    siteId: number,
    siteLocationId: number,
    kisiDoorId: number,
    kisiDoorName?: string | null,
    doorOpenMemberEmail: string,
    doorOpenedTime: string,
    accessGranted: boolean,
    accessFailureCode?: string | null,
    accessFailureMessage?: string | null,
    memberId?: number | null,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
    businessName?: string | null,
    memberName?: string | null,
    memberUniqueId?: string | null,
    memberClientId?: string | null,
    memberStatus?: string | null,
    memberAccountBalance?: number | null,
    memberNote?: string | null,
    memberWaiverStatus?: string | null,
    memberWaiverAgreementDateTime?: string | null,
    memberWaiverGraceUntil?: string | null,
    memberWaiverPolicyEnforced?: boolean | null,
  } | null > | null,
};

export type NotifyGymKeyEmployeeDashboardMutationVariables = {
  siteLocationId: number,
  memberEventId: number,
};

export type NotifyGymKeyEmployeeDashboardMutation = {
  notifyGymKeyEmployeeDashboard?:  Array< {
    __typename: "EmployeeDashboardEvent",
    id: number,
    providerEventId?: string | null,
    accessProvider: string,
    siteId: number,
    siteLocationId: number,
    doorId: number,
    doorName?: string | null,
    memberEmail: string,
    doorOpenedTime: string,
    doorOpenedTimeUtc: string,
    accessGranted: boolean,
    accessFailureCode?: string | null,
    accessFailureMessage?: string | null,
    memberId?: number | null,
    memberName?: string | null,
    memberUniqueId?: string | null,
    memberClientId?: string | null,
    memberStatus?: string | null,
    memberAccountBalance?: number | null,
    memberNote?: string | null,
    memberWaiverStatus?: string | null,
    memberWaiverAgreementDateTime?: string | null,
    memberWaiverGraceUntil?: string | null,
    memberWaiverPolicyEnforced?: boolean | null,
  } | null > | null,
};

export type GetClassPortalDataQueryVariables = {
  siteLocationId: number,
};

export type GetClassPortalDataQuery = {
  getClassPortalData?:  Array< {
    __typename: "ClassPortalData",
    id: number,
    importedId: number,
    name: string,
    siteLocationId: number,
    resourceId: number,
    staffId: number,
    startDateTime: string,
    endDateTime: string,
    maxCapacity: number,
    totalBooked: number,
    resourceMindbodyId: number,
    resourceName: string,
    resourceImageUrl?: string | null,
    staffMindbodyId: number,
    staffName: string,
    staffImageUrl?: string | null,
    imageUrl?: string | null,
  } | null > | null,
};

export type GetClassPortalSnapshotQueryVariables = {
  siteLocationId: number,
};

export type GetClassPortalSnapshotQuery = {
  getClassPortalSnapshot:  {
    __typename: "ClassPortalSnapshot",
    generatedAt: string,
    location:  {
      __typename: "ClassPortalSnapshotLocation",
      id: number,
      gymChainId: number,
      name: string,
      logo?:  {
        __typename: "ClassPortalSnapshotImage",
        kind: string,
        url: string,
        alt: string,
      } | null,
    },
    classes:  Array< {
      __typename: "ClassPortalSnapshotClass",
      id: string,
      name: string,
      startsAt: string,
      endsAt: string,
      availability:  {
        __typename: "ClassPortalSnapshotAvailability",
        available: number,
        capacity: number,
      },
      instructor:  {
        __typename: "ClassPortalSnapshotInstructor",
        name: string,
        image?:  {
          __typename: "ClassPortalSnapshotImage",
          kind: string,
          url: string,
          alt: string,
        } | null,
      },
    } >,
  },
};

export type GetMembershipTypesQuery = {
  getMembershipTypes?:  Array< {
    __typename: "MembershipType",
    id?: number | null,
    name?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetMembershipsQueryVariables = {
  siteId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
  isMindbody: boolean,
};

export type GetMembershipsQuery = {
  getMemberships?:  {
    __typename: "MembershipSiteResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "MembershipSite",
      id?: number | null,
      siteId?: number | null,
      membershipName?: string | null,
      membershipTypeId?: number | null,
      membershipType?: string | null,
      importedId?: number | null,
      isImported?: boolean | null,
      validityPeriod?: number | null,
      isMinusCreditBalanceApplied?: boolean | null,
      status?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      isDeleted?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      program?: string | null,
      siteLocations?: string | null,
      programAccessLocations?: string | null,
      hasRelatedAccessCategory?: boolean | null,
      hasRelatedProgramAccessCategory?: boolean | null,
      scheduleType?: string | null,
      isContractOnly?: boolean | null,
    } | null > | null,
  } | null,
};

export type GetSiteLocationMembershipsQueryVariables = {
  membershipId?: number | null,
};

export type GetSiteLocationMembershipsQuery = {
  getSiteLocationMemberships?:  Array< {
    __typename: "SiteLocationMembershipSite",
    siteLocationMembershipId?: number | null,
    siteLocationId?: number | null,
    siteLocationName?: string | null,
    siteLocationStatus?: string | null,
    siteLocationMembershipStatus?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetSiteLocationAccessCategoriesQueryVariables = {
  accessCategoryId?: number | null,
};

export type GetSiteLocationAccessCategoriesQuery = {
  getSiteLocationAccessCategories?:  Array< {
    __typename: "SiteLocationAccessCategorySite",
    siteLocationAccessCategoryId?: number | null,
    siteLocationMembershipId?: number | null,
    siteLocationId?: number | null,
    siteLocationName?: string | null,
    siteLocationStatus?: string | null,
    siteLocationAccessCategoryStatus?: string | null,
    membershipId?: number | null,
    membershipImportedId?: number | null,
    membershipName?: string | null,
  } | null > | null,
};

export type GetProgramAccessCategoriesQueryVariables = {
  accessCategoryId?: number | null,
};

export type GetProgramAccessCategoriesQuery = {
  getProgramAccessCategories?:  Array< {
    __typename: "ProgramAccessCategorySite",
    programAccessCategoryId?: number | null,
    programArxAccessCategoryId?: string | null,
    programId?: number | null,
    programName?: string | null,
    programScheduleType?: string | null,
    programImportedId?: number | null,
    programAccessCategoryStatus?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetSitesQuery = {
  getSites?:  Array< {
    __typename: "Site",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    membershipsImported?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetSiteQueryVariables = {
  id?: string | null,
};

export type GetSiteQuery = {
  getSite?:  {
    __typename: "Site",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    membershipsImported?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type GetSiteLocationsQuery = {
  getSiteLocations?:  Array< {
    __typename: "SiteLocation",
    id: number,
    siteId: number,
    siteLocationIdApi: number,
    locationName: string,
    locationContactPerson?: string | null,
    locationPhone?: string | null,
    locationEmail?: string | null,
    locationAddress?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    freePassId?: number | null,
    trailMembershipId?: number | null,
    staffAccessMembershipId?: string | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    isLockerEnabled?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
  } | null > | null,
};

export type GetSiteLocationQueryVariables = {
  id?: string | null,
};

export type GetSiteLocationQuery = {
  getSiteLocation?:  {
    __typename: "SiteLocation",
    id: number,
    siteId: number,
    siteLocationIdApi: number,
    locationName: string,
    locationContactPerson?: string | null,
    locationPhone?: string | null,
    locationEmail?: string | null,
    locationAddress?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    freePassId?: number | null,
    trailMembershipId?: number | null,
    staffAccessMembershipId?: string | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    isLockerEnabled?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
  } | null,
};

export type GetGymChainsQueryVariables = {
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
  userId: number,
};

export type GetGymChainsQuery = {
  getGymChains?:  {
    __typename: "WebGymChainReponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "WebGymChain",
      id?: number | null,
      providerId?: number | null,
      customerSiteId?: string | null,
      customerName?: string | null,
      customerContactPerson?: string | null,
      customerPhone?: string | null,
      supportPhone?: string | null,
      maximumNegativeBalance?: number | null,
      customerEmail?: string | null,
      customerAddress?: string | null,
      status?: string | null,
      membershipsImported?: boolean | null,
      createdBy?: number | null,
      lastModifiedBy?: number | null,
      createdDate?: string | null,
      lastModifiedDate?: string | null,
      lastImportedDate?: string | null,
      imageUrl?: string | null,
      isDeleted?: boolean | null,
      arxReferenceId?: string | null,
      providerConnected?: boolean | null,
      isSodvinCompany?: boolean | null,
      gymCount?: number | null,
      allowConvertingAccessCards?: boolean | null,
      createMindbodyClientAccessCards?: boolean | null,
      processBookings?: boolean | null,
      processSales?: boolean | null,
      processAppointments?: boolean | null,
      fetchAccountBalance?: boolean | null,
      kisiApiKey?: string | null,
      kisiNightlySyncApiKey?: string | null,
      gymKeyChainId?: string | null,
      hardwareProvider?: HardwareProvider | null,
    } | null > | null,
  } | null,
};

export type GetGymsQueryVariables = {
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
  userId: number,
};

export type GetGymsQuery = {
  getGyms?:  {
    __typename: "WebGymResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "Gym",
      gymChainName?: string | null,
      gymChainId: number,
      gymId: number,
      gymIdApi?: number | null,
      gymName?: string | null,
      contactPerson?: string | null,
      phoneNumber?: string | null,
      email?: string | null,
      address?: string | null,
      status?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastImportedDate?: string | null,
      lastModifiedBy?: number | null,
      imageUrl?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      trialMembershipId?: number | null,
      staffMembershipId?: number | null,
      freePassId?: number | null,
      handbackTime?: number | null,
      defaultLocationDetectionMethod?: string | null,
      primaryAccessMethod?: string | null,
      externalBookingsLink?: string | null,
      facebookLink?: string | null,
      twitterLink?: string | null,
      instagramLink?: string | null,
      gracePeriodWhenDeclined?: number | null,
      accessPerDayWhenDeclined?: number | null,
      gracePeriodWhenExpired?: number | null,
      accessPerDayWhenExpired?: number | null,
      gracePeriodWhenSuspended?: number | null,
      accessPerDayWhenSuspended?: number | null,
      isMobileCredentialAllowed?: boolean | null,
      websiteLink?: string | null,
      city?: string | null,
      membershipOnSignup?: number | null,
      membershipForVisits?: number | null,
      syncAllVisitsWithGenericSubscription?: boolean | null,
      isDeleted?: boolean | null,
      signUpUrl?: string | null,
      arxReferenceId?: string | null,
      sodvinCompanyId?: string | null,
      providerId?: number | null,
      allowConvertingAccessCards?: boolean | null,
      cardType?: string | null,
      addArrivalAuto?: boolean | null,
      addVisitAuto?: boolean | null,
      sessionCheckTimeLimit?: number | null,
      sessionCheckTimeLimitUpper?: number | null,
      excludeBookingTime?: boolean | null,
      timeZone?: string | null,
      prioratizeClasses?: boolean | null,
      blockTime?: number | null,
      markArrivalFirst?: boolean | null,
      openWithoutArrivalMarked?: boolean | null,
      markMultipleAttendanceAuto?: boolean | null,
      markArrivalsWhenThereAreVisits?: boolean | null,
      allowAppointmentCompletion?: boolean | null,
      isClassPortalEnabled?: boolean | null,
      isEmployeeDashboardEnabled?: boolean | null,
    } | null > | null,
  } | null,
};

export type GetWebUsersQueryVariables = {
  userId: number,
};

export type GetWebUsersQuery = {
  getWebUsers?:  {
    __typename: "WebUserResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "WebUser",
      userId?: number | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastModifiedBy?: number | null,
      isActive?: boolean | null,
      memberId?: number | null,
      roleId?: number | null,
      profilePicturePath?: string | null,
      roleName?: string | null,
      siteId?: number | null,
      siteName?: string | null,
      siteLocationId?: number | null,
      siteLocationName?: string | null,
      language?: string | null,
      memberArxReferenceId?: string | null,
    } | null > | null,
  } | null,
};

export type GetMobileUsersQueryVariables = {
  userId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
};

export type GetMobileUsersQuery = {
  getMobileUsers?:  {
    __typename: "MobileUserResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "MobileUser",
      id?: number | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      address?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      status?: boolean | null,
      isMobileAppDisabled?: boolean | null,
      isJustTapRevoked?: boolean | null,
      isMoreInfoRequested?: boolean | null,
      imageUrl?: string | null,
      language?: string | null,
      defaultLocationDetectionMethod?: string | null,
      memberId?: string | null,
      memberName?: string | null,
    } | null > | null,
  } | null,
};

export type GetUserByPhoneQueryVariables = {
  phone: string,
};

export type GetUserByPhoneQuery = {
  getUserByPhone?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type GetActiveDeviceQueryVariables = {
  userId: number,
};

export type GetActiveDeviceQuery = {
  getActiveDevice?:  {
    __typename: "DeviceHistory",
    id: number,
    userId: number,
    appVersion: string,
    macAddress: string,
    uniqueId: string,
    model?: string | null,
    manufacturer?: string | null,
    isActive?: boolean | null,
    isCameraPresent?: boolean | null,
    locale?: string | null,
    type?: string | null,
    timeZone?: string | null,
    signedUpStatus?: boolean | null,
    country?: string | null,
    baseOs?: string | null,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null,
};

export type ImportSiteQueryVariables = {
  siteId: number,
  provider: string,
  checkWithDB?: boolean | null,
};

export type ImportSiteQuery = {
  importSite?:  {
    __typename: "ImportSiteResponse",
    PaginationResponse?:  {
      __typename: "MindbodyPaginationResponseType",
      RequestedLimit?: number | null,
      RequestedOffset?: number | null,
      PageSize?: number | null,
      TotalResults?: number | null,
    } | null,
    Sites?:  Array< {
      __typename: "MindbodyImportedSite",
      AcceptsAmericanExpress?: boolean | null,
      AcceptsDiscover?: boolean | null,
      AcceptsMasterCard?: boolean | null,
      AcceptsVisa?: boolean | null,
      AllowsDashboardAccess?: boolean | null,
      ContactEmail?: string | null,
      Description?: string | null,
      Id?: number | null,
      LogoUrl?: string | null,
      Name?: string | null,
      PageColor1?: string | null,
      PageColor2?: string | null,
      PageColor3?: string | null,
      PageColor4?: string | null,
      PricingLevel?: string | null,
      SmsPackageEnabled?: boolean | null,
      TaxInclusivePrices?: boolean | null,
      CurrencyIsoCode?: string | null,
      CountryCode?: string | null,
      TimeZone?: string | null,
      AcceptsDirectDebit?: boolean | null,
    } | null > | null,
    error?: boolean | null,
    errorMsg?: string | null,
  } | null,
};

export type GetGymsOfGymChainQueryVariables = {
  id: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
  userId: number,
};

export type GetGymsOfGymChainQuery = {
  getGymsOfGymChain?:  {
    __typename: "GymResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "Gym",
      gymChainName?: string | null,
      gymChainId: number,
      gymId: number,
      gymIdApi?: number | null,
      gymName?: string | null,
      contactPerson?: string | null,
      phoneNumber?: string | null,
      email?: string | null,
      address?: string | null,
      status?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastImportedDate?: string | null,
      lastModifiedBy?: number | null,
      imageUrl?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      trialMembershipId?: number | null,
      staffMembershipId?: number | null,
      freePassId?: number | null,
      handbackTime?: number | null,
      defaultLocationDetectionMethod?: string | null,
      primaryAccessMethod?: string | null,
      externalBookingsLink?: string | null,
      facebookLink?: string | null,
      twitterLink?: string | null,
      instagramLink?: string | null,
      gracePeriodWhenDeclined?: number | null,
      accessPerDayWhenDeclined?: number | null,
      gracePeriodWhenExpired?: number | null,
      accessPerDayWhenExpired?: number | null,
      gracePeriodWhenSuspended?: number | null,
      accessPerDayWhenSuspended?: number | null,
      isMobileCredentialAllowed?: boolean | null,
      websiteLink?: string | null,
      city?: string | null,
      membershipOnSignup?: number | null,
      membershipForVisits?: number | null,
      syncAllVisitsWithGenericSubscription?: boolean | null,
      isDeleted?: boolean | null,
      signUpUrl?: string | null,
      arxReferenceId?: string | null,
      sodvinCompanyId?: string | null,
      providerId?: number | null,
      allowConvertingAccessCards?: boolean | null,
      cardType?: string | null,
      addArrivalAuto?: boolean | null,
      addVisitAuto?: boolean | null,
      sessionCheckTimeLimit?: number | null,
      sessionCheckTimeLimitUpper?: number | null,
      excludeBookingTime?: boolean | null,
      timeZone?: string | null,
      prioratizeClasses?: boolean | null,
      blockTime?: number | null,
      markArrivalFirst?: boolean | null,
      openWithoutArrivalMarked?: boolean | null,
      markMultipleAttendanceAuto?: boolean | null,
      markArrivalsWhenThereAreVisits?: boolean | null,
      allowAppointmentCompletion?: boolean | null,
      isClassPortalEnabled?: boolean | null,
      isEmployeeDashboardEnabled?: boolean | null,
    } | null > | null,
  } | null,
};

export type UploadImageUrlResolverQueryVariables = {
  imageName: string,
};

export type UploadImageUrlResolverQuery = {
  uploadImageUrlResolver?:  {
    __typename: "UploadImageResponse",
    url?: string | null,
    uploadUrl?: string | null,
  } | null,
};

export type GetDefaultLocationDetectionMethodsQueryVariables = {
  userId: number,
};

export type GetDefaultLocationDetectionMethodsQuery = {
  getDefaultLocationDetectionMethods?:  Array< {
    __typename: "LocationDetectionMethod",
    gymId?: number | null,
    gymDefined?: string | null,
    userDefined?: string | null,
  } | null > | null,
};

export type GetPlatformSettingsQuery = {
  getPlatformSettings?:  Array< {
    __typename: "PlatformSetting",
    id?: number | null,
    setting?: string | null,
    value?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type ImportLocationQueryVariables = {
  locationId: number,
  provider: string,
  siteId: number,
};

export type ImportLocationQuery = {
  importLocation?:  {
    __typename: "MindbodyImportedLocation",
    AdditionalImageURLs?: Array< string | null > | null,
    Address?: string | null,
    Address2?: string | null,
    BusinessDescription?: string | null,
    City?: string | null,
    Description?: string | null,
    HasClasses?: boolean | null,
    Id?: number | null,
    Latitude?: number | null,
    Longitude?: number | null,
    Name?: string | null,
    Phone?: string | null,
    PhoneExtension?: string | null,
    PostalCode?: string | null,
    SiteID?: number | null,
    StateProvCode?: string | null,
  } | null,
};

export type ImportKisiDoorQueryVariables = {
  siteId: number,
  doorId: number,
};

export type ImportKisiDoorQuery = {
  importKisiDoor?:  {
    __typename: "KisiImportedDoor",
    id?: number | null,
    name?: string | null,
    placeId?: number | null,
    placeName?: string | null,
  } | null,
};

export type GetGymByApiIdQueryVariables = {
  gymChainId: number,
  gymApiId: number,
};

export type GetGymByApiIdQuery = {
  getGymByApiId?:  Array< {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null > | null,
};

export type IsGymDeletableQueryVariables = {
  siteLocationId: number,
};

export type IsGymDeletableQuery = {
  isGymDeletable?:  Array< {
    __typename: "DeletableResponse",
    id?: number | null,
    rowCount?: number | null,
    tableName?: string | null,
  } | null > | null,
};

export type IsGymChainDeletableQueryVariables = {
  siteId: number,
};

export type IsGymChainDeletableQuery = {
  isGymChainDeletable?:  Array< {
    __typename: "DeletableResponse",
    id?: number | null,
    rowCount?: number | null,
    tableName?: string | null,
  } | null > | null,
};

export type IsMemberLinkedQueryVariables = {
  memberId: number,
};

export type IsMemberLinkedQuery = {
  isMemberLinked?:  Array< {
    __typename: "isMemberLinkedResponse",
    rowCount?: number | null,
  } | null > | null,
};

export type GetMemberUserLinkQueryVariables = {
  memberId: number,
};

export type GetMemberUserLinkQuery = {
  getMemberUserLink?:  {
    __typename: "getMemberUserLinkResponse",
    totalRecords?: number | null,
  } | null,
};

export type GetAvailableHolidaysQueryVariables = {
  locationId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
};

export type GetAvailableHolidaysQuery = {
  getAvailableHolidays?:  {
    __typename: "LocationOpeningHourReponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "LocationOpeningHourWithDay",
      id: number,
      locationId: number,
      name: string,
      isHoliday?: boolean | null,
      isGeneral?: boolean | null,
      validFromDateTime: string,
      validToDateTime: string,
      createdBy: number,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      status: string,
      dayOfWeek?: string | null,
      isDeleted?: boolean | null,
      hourDetailId?: number | null,
      validFromDate?: string | null,
      validToDate?: string | null,
    } | null > | null,
  } | null,
};

export type ImportMembershipsQueryVariables = {
  siteId: number,
};

export type ImportMembershipsQuery = {
  importMemberships?:  {
    __typename: "MembershipImport",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    memberships?:  Array< {
      __typename: "Membership",
      id?: number | null,
      siteId?: number | null,
      importedId?: number | null,
      membershipName?: string | null,
      membershipTypeId?: number | null,
      isImported?: boolean | null,
      validityPeriod?: number | null,
      isMinusCreditBalanceApplied?: boolean | null,
      status?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      isDeleted?: boolean | null,
    } | null > | null,
  } | null,
};

export type GetAllMembershipsForSiteLocationQueryVariables = {
  siteLocationId: number,
  filterMemberships: boolean,
};

export type GetAllMembershipsForSiteLocationQuery = {
  getAllMembershipsForSiteLocation?:  Array< {
    __typename: "MembershipInfo",
    siteLocationMembershipId?: number | null,
    siteLocationId?: number | null,
    siteLocationImportedId?: number | null,
    siteLocationName?: string | null,
    membershipId?: number | null,
    membershipName?: string | null,
    membershipTypeName?: string | null,
    validityPeriod?: number | null,
    isImported?: boolean | null,
    importedId?: number | null,
    status?: string | null,
    createdDate?: string | null,
    program?: string | null,
    scheduleType?: string | null,
  } | null > | null,
};

export type GetAllMembershipsForAccessCategoriesQueryVariables = {
  siteLocationId: string,
  filterMemberships: boolean,
  accessCategoryId: number,
};

export type GetAllMembershipsForAccessCategoriesQuery = {
  getAllMembershipsForAccessCategories?:  Array< {
    __typename: "AccessCategoryMembershipInfo",
    membershipId?: number | null,
    membershipName?: string | null,
    membershipTypeName?: string | null,
    validityPeriod?: number | null,
    isImported?: boolean | null,
    importedId?: number | null,
    status?: string | null,
    createdDate?: string | null,
    program?: string | null,
    scheduleType?: string | null,
  } | null > | null,
};

export type GetMembershipsForSiteLocationQueryVariables = {
  siteLocationId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
};

export type GetMembershipsForSiteLocationQuery = {
  getMembershipsForSiteLocation?:  {
    __typename: "MembershipSiteLocationResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "MembershipInfo",
      siteLocationMembershipId?: number | null,
      siteLocationId?: number | null,
      siteLocationImportedId?: number | null,
      siteLocationName?: string | null,
      membershipId?: number | null,
      membershipName?: string | null,
      membershipTypeName?: string | null,
      validityPeriod?: number | null,
      isImported?: boolean | null,
      importedId?: number | null,
      status?: string | null,
      createdDate?: string | null,
      program?: string | null,
      scheduleType?: string | null,
    } | null > | null,
  } | null,
};

export type GetAllAvailableHolidaysQueryVariables = {
  locationId: number,
};

export type GetAllAvailableHolidaysQuery = {
  getAllAvailableHolidays?:  {
    __typename: "LocationOpeningHourReponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "LocationOpeningHourWithDay",
      id: number,
      locationId: number,
      name: string,
      isHoliday?: boolean | null,
      isGeneral?: boolean | null,
      validFromDateTime: string,
      validToDateTime: string,
      createdBy: number,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      status: string,
      dayOfWeek?: string | null,
      isDeleted?: boolean | null,
      hourDetailId?: number | null,
      validFromDate?: string | null,
      validToDate?: string | null,
    } | null > | null,
  } | null,
};

export type GetAvailableLocationOpeningHoursQueryVariables = {
  locationId: number,
};

export type GetAvailableLocationOpeningHoursQuery = {
  getAvailableLocationOpeningHours?:  {
    __typename: "LocationOpeningHoursJoinedResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "LocationOpeningHoursJoined",
      id?: number | null,
      locationId?: number | null,
      openingHourId?: number | null,
      startDateTime?: string | null,
      endDateTime?: string | null,
      dayOfWeek?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      isHoliday?: boolean | null,
      name?: string | null,
      status?: string | null,
      validFromDate?: string | null,
      validToDate?: string | null,
    } | null > | null,
  } | null,
};

export type GymSearchQueryVariables = {
  searchQuery: string,
  pageIndex: number,
  pageSize: number,
};

export type GymSearchQuery = {
  gymSearch?:  Array< {
    __typename: "GymSearchResult",
    gymId: number,
    gymName: string,
    gymLogo?: string | null,
    gymAddress?: string | null,
    gymCity?: string | null,
    freePassId?: number | null,
    trialMembershipId?: number | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    providerId?: number | null,
  } | null > | null,
};

export type GetGymsInUserVicinityQueryVariables = {
  latitude: number,
  longitude: number,
  radius: number,
};

export type GetGymsInUserVicinityQuery = {
  getGymsInUserVicinity?:  Array< {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null > | null,
};

export type GetGymChainByIdQueryVariables = {
  id: number,
};

export type GetGymChainByIdQuery = {
  getGymChainById?:  Array< {
    __typename: "WebGymChain",
    id?: number | null,
    providerId?: number | null,
    customerSiteId?: string | null,
    customerName?: string | null,
    customerContactPerson?: string | null,
    customerPhone?: string | null,
    supportPhone?: string | null,
    maximumNegativeBalance?: number | null,
    customerEmail?: string | null,
    customerAddress?: string | null,
    status?: string | null,
    membershipsImported?: boolean | null,
    createdBy?: number | null,
    lastModifiedBy?: number | null,
    createdDate?: string | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    imageUrl?: string | null,
    isDeleted?: boolean | null,
    arxReferenceId?: string | null,
    providerConnected?: boolean | null,
    isSodvinCompany?: boolean | null,
    gymCount?: number | null,
    allowConvertingAccessCards?: boolean | null,
    createMindbodyClientAccessCards?: boolean | null,
    processBookings?: boolean | null,
    processSales?: boolean | null,
    processAppointments?: boolean | null,
    fetchAccountBalance?: boolean | null,
    kisiApiKey?: string | null,
    kisiNightlySyncApiKey?: string | null,
    gymKeyChainId?: string | null,
    hardwareProvider?: HardwareProvider | null,
  } | null > | null,
};

export type GetGymByIdQueryVariables = {
  id: number,
};

export type GetGymByIdQuery = {
  getGymById?:  Array< {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null > | null,
};

export type GetLocationMembershipOpeningHourQueryVariables = {
  openingHourId: number,
  isHoliday: boolean,
};

export type GetLocationMembershipOpeningHourQuery = {
  getLocationMembershipOpeningHour?:  Array< {
    __typename: "LocationMembershipOpeningHour",
    id?: number | null,
    openingHourId?: number | null,
    membershipId?: number | null,
    name?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetMembersForSiteLocationQueryVariables = {
  siteLocationId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
};

export type GetMembersForSiteLocationQuery = {
  getMembersForSiteLocation?:  {
    __typename: "SiteLocationMembersReponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "SiteLocationMember",
      memberId?: number | null,
      uniqueId?: string | null,
      clientId?: string | null,
      externalId?: string | null,
      accountBalance?: number | null,
      businessName?: string | null,
      memberWaiverStatus?: string | null,
      memberWaiverAgreementDateTime?: string | null,
      memberWaiverGraceUntil?: string | null,
      memberFirstName?: string | null,
      memberLastName?: string | null,
      isMobileAppDisabled?: boolean | null,
      isJustTapRevoked?: boolean | null,
      isStaffMember?: boolean | null,
      signedUpDate?: string | null,
      phoneNumber?: string | null,
      status?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastModifiedBy?: number | null,
      expiredDate?: string | null,
      isBlocked?: boolean | null,
      defaultGymDetectionMethod?: string | null,
      email?: string | null,
      profilePicturePath?: string | null,
      lastSyncDate?: string | null,
      isTrial?: boolean | null,
      arxReferenceId?: string | null,
      userId?: number | null,
      linkedPhoneNumber?: string | null,
      language?: string | null,
      hasAccessCard?: boolean | null,
      hasActiveWalletPass?: boolean | null,
      hasForcedAccess?: boolean | null,
      hasLocationOverride?: boolean | null,
      hasManualAccess?: boolean | null,
      isFreepassMember?: boolean | null,
      memberLocationId?: number | null,
      flag?: number | null,
    } | null > | null,
  } | null,
};

export type GetMemberByMemberIdQueryVariables = {
  siteLocationId: number,
  memberId: number,
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
};

export type GetMemberByMemberIdQuery = {
  getMemberByMemberId?:  {
    __typename: "GetMemberByMemberIdResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "SiteLocationMember",
      memberId?: number | null,
      uniqueId?: string | null,
      clientId?: string | null,
      externalId?: string | null,
      accountBalance?: number | null,
      businessName?: string | null,
      memberWaiverStatus?: string | null,
      memberWaiverAgreementDateTime?: string | null,
      memberWaiverGraceUntil?: string | null,
      memberFirstName?: string | null,
      memberLastName?: string | null,
      isMobileAppDisabled?: boolean | null,
      isJustTapRevoked?: boolean | null,
      isStaffMember?: boolean | null,
      signedUpDate?: string | null,
      phoneNumber?: string | null,
      status?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastModifiedBy?: number | null,
      expiredDate?: string | null,
      isBlocked?: boolean | null,
      defaultGymDetectionMethod?: string | null,
      email?: string | null,
      profilePicturePath?: string | null,
      lastSyncDate?: string | null,
      isTrial?: boolean | null,
      arxReferenceId?: string | null,
      userId?: number | null,
      linkedPhoneNumber?: string | null,
      language?: string | null,
      hasAccessCard?: boolean | null,
      hasActiveWalletPass?: boolean | null,
      hasForcedAccess?: boolean | null,
      hasLocationOverride?: boolean | null,
      hasManualAccess?: boolean | null,
      isFreepassMember?: boolean | null,
      memberLocationId?: number | null,
      flag?: number | null,
    } | null > | null,
  } | null,
};

export type GetMemberDetailsQueryVariables = {
  memberId: number,
};

export type GetMemberDetailsQuery = {
  getMemberDetails?:  Array< {
    __typename: "SiteLocationMemberDetails",
    membership?: string | null,
    memberLocationMembershipId?: number | null,
    subscriptionDeleted?: boolean | null,
    validFrom?: string | null,
    validTo?: string | null,
    subscriptionCreatedDate?: string | null,
    subscriptionModifiedDate?: string | null,
    subscriptionIsSelected?: boolean | null,
    subscriptionStatus?: string | null,
    scheduleType?: string | null,
    remainingSessions?: number | null,
    siteLocationMembershipStatus?: string | null,
  } | null > | null,
};

export type GetMemberBookingDetailsQueryVariables = {
  memberId: number,
  memberEventId?: number | null,
};

export type GetMemberBookingDetailsQuery = {
  getMemberBookingDetails?:  Array< {
    __typename: "MemberBookingDetails",
    booking?: string | null,
    importedId?: number | null,
    appointmentId?: number | null,
    isVisited?: boolean | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    createdDate?: string | null,
    lastModifiedDate?: string | null,
    membershipName?: string | null,
    siteLocation?: string | null,
    isDeleted?: boolean | null,
    grantsAccess?: boolean | null,
  } | null > | null,
};

export type IsMembershipLinkedToGymQueryVariables = {
  membershipId: number,
};

export type IsMembershipLinkedToGymQuery = {
  isMembershipLinkedToGym?:  Array< {
    __typename: "DeletableResponse",
    id?: number | null,
    rowCount?: number | null,
    tableName?: string | null,
  } | null > | null,
};

export type IsSiteLocationMembershipLinkedQueryVariables = {
  id: number,
  membershipId: number,
};

export type IsSiteLocationMembershipLinkedQuery = {
  isSiteLocationMembershipLinked?:  Array< {
    __typename: "DeletableResponse",
    id?: number | null,
    rowCount?: number | null,
    tableName?: string | null,
  } | null > | null,
};

export type IsSiteLocationAccessCategoryLinkedQueryVariables = {
  id: number,
};

export type IsSiteLocationAccessCategoryLinkedQuery = {
  isSiteLocationAccessCategoryLinked?:  Array< {
    __typename: "DeletableResponse",
    id?: number | null,
    rowCount?: number | null,
    tableName?: string | null,
  } | null > | null,
};

export type GetZonesForSiteLocationQueryVariables = {
  siteLocationId: number,
};

export type GetZonesForSiteLocationQuery = {
  getZonesForSiteLocation?:  {
    __typename: "LocationZoneResponse",
    items?:  Array< {
      __typename: "LocationZone",
      id?: number | null,
      siteLocationId?: number | null,
      zoneName?: string | null,
      zoneDescription?: string | null,
      arxReferenceId?: string | null,
      status?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      accessCategoryId?: number | null,
      accessCategoryName?: string | null,
      accessCategoryGender?: string | null,
      accessCategoryAge?: number | null,
      accessCategorySchedulesOnly?: boolean | null,
      accessCategoryStatus?: string | null,
      locationAccessCategoryZoneId?: number | null,
      locationAccessCategoryId?: number | null,
      siteAccessCategoryId?: number | null,
      locationAccessCategoryName?: string | null,
      locationAccessCategoryGender?: string | null,
      locationAccessCategoryArxRefId?: string | null,
      locationProgramAccessCategoryZoneId?: number | null,
      locationProgramAccessCategoryId?: number | null,
      siteProgramAccessCategoryId?: number | null,
      locationProgramAccessCategoryName?: string | null,
      locationProgramAccessCategoryGender?: string | null,
      locationProgramAccessCategoryArxRefId?: string | null,
      programId?: number | null,
      programName?: string | null,
      programImportedId?: number | null,
      programScheduleType?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetMembershipsForZoneQueryVariables = {
  locationZoneId: number,
};

export type GetMembershipsForZoneQuery = {
  getMembershipsForZone?:  Array< {
    __typename: "LocationZoneMembership",
    id?: number | null,
    locationZoneId?: number | null,
    membershipId?: number | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null > | null,
};

export type GetMemberAndSubscriptionsByIdQueryVariables = {
  memberId: number,
  siteLocationId: number,
};

export type GetMemberAndSubscriptionsByIdQuery = {
  getMemberAndSubscriptionsById?:  Array< {
    __typename: "MemberAndSubscriptionsResponse",
    memberId?: number | null,
    uniqueId?: string | null,
    memberFirstName?: string | null,
    memberLastName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    profilePicturePath?: string | null,
    status?: string | null,
    membershipId?: number | null,
    membershipName?: string | null,
    membershipImportedId?: number | null,
    validFrom?: string | null,
    validTo?: string | null,
    memberStatus?: string | null,
    arxReferenceId?: string | null,
  } | null > | null,
};

export type IsZoneLinkedQueryVariables = {
  locationZoneId: number,
};

export type IsZoneLinkedQuery = {
  isZoneLinked?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetDataUpdateStatusQueryVariables = {
  phone?: string | null,
  dialingPhone?: string | null,
};

export type GetDataUpdateStatusQuery = {
  getDataUpdateStatus?:  {
    __typename: "DataUpdateStatus",
    memberId?: string | null,
    lastSyncDate?: string | null,
    memberPhone?: string | null,
  } | null,
};

export type GetMemberStatusTypesQuery = {
  getMemberStatusTypes?:  Array< {
    __typename: "MemberStatus",
    id?: number | null,
    status?: string | null,
  } | null > | null,
};

export type GetAccessPointsForSiteLocationQueryVariables = {
  siteLocationId: number,
};

export type GetAccessPointsForSiteLocationQuery = {
  getAccessPointsForSiteLocation?:  {
    __typename: "LocationAccessPointResponse",
    items?:  Array< {
      __typename: "LocationAccessPoint",
      id?: number | null,
      siteLocationId?: number | null,
      locationZoneId?: number | null,
      locationZoneName?: string | null,
      zoneAccessPointId?: number | null,
      accessPointType?: string | null,
      uniqueId?: string | null,
      beaconUUID?: string | null,
      beaconMajor?: string | null,
      beaconMinor?: string | null,
      doorARXId?: string | null,
      classId?: string | null,
      doorName?: string | null,
      doorDescription?: string | null,
      handbackTime?: number | null,
      doorCaption?: string | null,
      priority?: string | null,
      status?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      isDeleted?: boolean | null,
      batteryLevel?: number | null,
      sodvinDoorId?: string | null,
      sodvinDoorSecret?: string | null,
      fromZoneId?: number | null,
      toZoneId?: number | null,
      fromZoneName?: string | null,
      toZoneName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetKisiDoorsForSiteLocationQueryVariables = {
  siteLocationId: number,
};

export type GetKisiDoorsForSiteLocationQuery = {
  getKisiDoorsForSiteLocation?:  {
    __typename: "KisiDoorResponse",
    items?:  Array< {
      __typename: "KisiDoor",
      id: number,
      siteId: number,
      siteLocationId: number,
      kisiDoorId: number,
      kisiDoorName: string,
      kisiPlaceId: number,
      kisiPlaceName: string,
      createdBy: number,
      createdDate?: string | null,
      lastModifiedBy: number,
      lastModifiedDate?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetKisiEventsForSiteLocationQueryVariables = {
  siteLocationId: number,
};

export type GetKisiEventsForSiteLocationQuery = {
  getKisiEventsForSiteLocation?:  {
    __typename: "KisiEventResponse",
    items?:  Array< {
      __typename: "KisiEvent",
      id: number,
      siteId: number,
      siteLocationId: number,
      kisiDoorId: number,
      kisiDoorName?: string | null,
      doorOpenMemberEmail: string,
      doorOpenedTime: string,
      accessGranted: boolean,
      accessFailureCode?: string | null,
      accessFailureMessage?: string | null,
      memberId?: number | null,
      createdBy: number,
      createdDate?: string | null,
      lastModifiedBy: number,
      lastModifiedDate?: string | null,
      businessName?: string | null,
      memberName?: string | null,
      memberUniqueId?: string | null,
      memberClientId?: string | null,
      memberStatus?: string | null,
      memberAccountBalance?: number | null,
      memberNote?: string | null,
      memberWaiverStatus?: string | null,
      memberWaiverAgreementDateTime?: string | null,
      memberWaiverGraceUntil?: string | null,
      memberWaiverPolicyEnforced?: boolean | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetEmployeeDashboardEventHistoryQueryVariables = {
  input: EmployeeDashboardEventHistoryInput,
};

export type GetEmployeeDashboardEventHistoryQuery = {
  getEmployeeDashboardEventHistory?:  {
    __typename: "EmployeeDashboardEventHistoryResponse",
    items?:  Array< {
      __typename: "EmployeeDashboardEvent",
      id: number,
      providerEventId?: string | null,
      accessProvider: string,
      siteId: number,
      siteLocationId: number,
      doorId: number,
      doorName?: string | null,
      memberEmail: string,
      doorOpenedTime: string,
      doorOpenedTimeUtc: string,
      accessGranted: boolean,
      accessFailureCode?: string | null,
      accessFailureMessage?: string | null,
      memberId?: number | null,
      memberName?: string | null,
      memberUniqueId?: string | null,
      memberClientId?: string | null,
      memberStatus?: string | null,
      memberAccountBalance?: number | null,
      memberNote?: string | null,
      memberWaiverStatus?: string | null,
      memberWaiverAgreementDateTime?: string | null,
      memberWaiverGraceUntil?: string | null,
      memberWaiverPolicyEnforced?: boolean | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetEmployeeDashboardMembershipsQueryVariables = {
  memberId: number,
  eventId?: number | null,
  memberEventId?: number | null,
};

export type GetEmployeeDashboardMembershipsQuery = {
  getEmployeeDashboardMemberships?:  Array< {
    __typename: "EmployeeDashboardMembership",
    membership?: string | null,
    memberLocationMembershipId?: number | null,
    validFrom?: string | null,
    validTo?: string | null,
    subscriptionStatus?: string | null,
    scheduleType?: string | null,
    remainingSessions?: number | null,
    remainingVisits?: number | null,
    siteLocationMembershipStatus?: string | null,
    siteLocationId?: number | null,
    siteLocationName?: string | null,
    isProbableAccess: boolean,
    accessProvider?: string | null,
  } | null > | null,
};

export type GetMembersForKisiEventQueryVariables = {
  memberEmail: string,
};

export type GetMembersForKisiEventQuery = {
  getMembersForKisiEvent?:  {
    __typename: "KisiEventMemberResponse",
    items?:  Array< {
      __typename: "KisiEventMember",
      id: number,
      uniqueId?: string | null,
      clientId?: string | null,
      memberStatusId?: number | null,
      userId?: number | null,
      username?: string | null,
      name: string,
      address?: string | null,
      phone?: string | null,
      email?: string | null,
      createdBy: number,
      createdDate?: string | null,
      lastModifiedBy: number,
      lastModifiedDate?: string | null,
      note?: string | null,
      accountBalance: number,
      accountBalanceChangeDate?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetAllZonesForSiteLocationQueryVariables = {
  siteLocationId: number,
};

export type GetAllZonesForSiteLocationQuery = {
  getAllZonesForSiteLocation?:  {
    __typename: "LocationZoneResponse",
    items?:  Array< {
      __typename: "LocationZone",
      id?: number | null,
      siteLocationId?: number | null,
      zoneName?: string | null,
      zoneDescription?: string | null,
      arxReferenceId?: string | null,
      status?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      accessCategoryId?: number | null,
      accessCategoryName?: string | null,
      accessCategoryGender?: string | null,
      accessCategoryAge?: number | null,
      accessCategorySchedulesOnly?: boolean | null,
      accessCategoryStatus?: string | null,
      locationAccessCategoryZoneId?: number | null,
      locationAccessCategoryId?: number | null,
      siteAccessCategoryId?: number | null,
      locationAccessCategoryName?: string | null,
      locationAccessCategoryGender?: string | null,
      locationAccessCategoryArxRefId?: string | null,
      locationProgramAccessCategoryZoneId?: number | null,
      locationProgramAccessCategoryId?: number | null,
      siteProgramAccessCategoryId?: number | null,
      locationProgramAccessCategoryName?: string | null,
      locationProgramAccessCategoryGender?: string | null,
      locationProgramAccessCategoryArxRefId?: string | null,
      programId?: number | null,
      programName?: string | null,
      programImportedId?: number | null,
      programScheduleType?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetGymsForSubscriptionsQueryVariables = {
  subscriptionIds?: string | null,
  userId?: number | null,
};

export type GetGymsForSubscriptionsQuery = {
  getGymsForSubscriptions:  Array< {
    __typename: "SubscribedGym",
    providerId: number,
    providerName?: string | null,
    gymChainId: number,
    gymChainName?: string | null,
    locationId: number,
    accessPointId?: number | null,
    locationName?: string | null,
    locationCity?: string | null,
    gymInquiriesByUser?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    membershipName?: string | null,
    defaultLocationDetectionMethod?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    status?: string | null,
    doorARXId?: string | null,
    locationAddress?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionId?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    sodvinCompanyId?: string | null,
    siteLocationArxReferenceId?: string | null,
    memberUniqueId?: string | null,
    memberArxReferenceId?: string | null,
    siteLocationHandbackTime?: number | null,
    accessPointHandbackTime?: number | null,
    isGranted?: boolean | null,
    isTrial?: boolean | null,
    accessPointType?: string | null,
    siteLocationPhone?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    websiteLink?: string | null,
    gymStatus?: string | null,
    forcedAccessStartTime?: string | null,
    forcedAccessEndTime?: string | null,
    forcedAccessIsIndefinite?: boolean | null,
    overrideLocationDetection?: boolean | null,
    overrideClientStatuses?: boolean | null,
    isMemberBlocked?: boolean | null,
    isSodvinCompany?: boolean | null,
    customerSiteId?: string | null,
    memberId?: number | null,
    memberPhone?: string | null,
    isDeclined?: boolean | null,
    isSuspended?: boolean | null,
    notAvailable?: boolean | null,
    scheduleType?: string | null,
    programId?: number | null,
    serviceId?: number | null,
    totalVisits?: number | null,
    remainingVisits?: number | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    serviceCategory?: string | null,
    siteLocationIdApi?: number | null,
    subscriptionStatus?: string | null,
    remainingSessions?: number | null,
    isLockerEnabled?: boolean | null,
    allowDoorOpenOnNoVisit?: boolean | null,
    locationAccessCategoryId?: number | null,
    locationZoneId?: number | null,
    addVisitAuto?: boolean | null,
    addArrivalAuto?: boolean | null,
    arrivalId?: number | null,
    arrivalACId?: number | null,
    arrivalStartDateTime?: string | null,
    arrivalEndDateTime?: string | null,
    siteLocationMembershipId?: number | null,
    yellowboxId?: string | null,
    blockTime?: number | null,
  } >,
};

export type GetPriorityInfoQueryVariables = {
  siteLocationId: number,
};

export type GetPriorityInfoQuery = {
  getPriorityInfo?:  Array< {
    __typename: "PriorityInfo",
    id?: number | null,
    doorARXId?: string | null,
    priority?: string | null,
  } | null > | null,
};

export type GetMembershipsForUserQueryVariables = {
  userId: number,
};

export type GetMembershipsForUserQuery = {
  getMembershipsForUser?:  Array< {
    __typename: "MembershipsForUser",
    mlmId?: number | null,
    memberId?: number | null,
    memberName?: string | null,
    gymId?: number | null,
    gymName?: string | null,
    gymChainId?: number | null,
    gymChainName?: string | null,
    subscriptionValidFrom?: string | null,
    subscriptionValidTo?: string | null,
    status?: string | null,
    expiryDate?: string | null,
    profilePicturePath?: string | null,
    membershipName?: string | null,
  } | null > | null,
};

export type ImportBeaconDataQueryVariables = {
  siteLocationId?: number | null,
};

export type ImportBeaconDataQuery = {
  importBeaconData?:  Array< {
    __typename: "BeaconStatus",
    id?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    accessPointType?: string | null,
    uniqueId?: string | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    doorARXId?: string | null,
    classId?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    handbackTime?: number | null,
    doorCaption?: string | null,
    priority?: string | null,
    status?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isDeleted?: boolean | null,
    batteryLevel?: number | null,
  } | null > | null,
};

export type GetAccessCardQueryVariables = {
  doorId: string,
  startTime: string,
  endTime: string,
  siteLocationId: number,
};

export type GetAccessCardQuery = {
  getAccessCard?:  {
    __typename: "AccessCard",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    cardId?: string | null,
    cardType?: string | null,
  } | null,
};

export type ArxForceOpenQueryVariables = {
  doorId: string,
  state: string,
};

export type ArxForceOpenQuery = {
  arxForceOpen?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type ArxForceBlockQueryVariables = {
  doorId: string,
  state: string,
};

export type ArxForceBlockQuery = {
  arxForceBlock?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type OpenArxDoorQueryVariables = {
  doorId: string,
  personId?: string | null,
};

export type OpenArxDoorQuery = {
  openArxDoor?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type OpenArxDoorDashboardQueryVariables = {
  doorId: string,
  userId: number,
  siteLocationId: number,
  comment: string,
};

export type OpenArxDoorDashboardQuery = {
  openArxDoorDashboard?:  {
    __typename: "ArxAccessResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    statusCode?: string | null,
    statusMessage?: string | null,
  } | null,
};

export type ImportBeaconIdByUniqueIdQueryVariables = {
  uniqueId?: string | null,
};

export type ImportBeaconIdByUniqueIdQuery = {
  importBeaconIdByUniqueId?:  {
    __typename: "BeaconIdImport",
    error?: boolean | null,
    errorMsg?: string | null,
    BeaconId?:  {
      __typename: "BeaconId",
      uuid?: string | null,
      major?: string | null,
      minor?: string | null,
    } | null,
  } | null,
};

export type FetchArxAllAccessCategoriesQueryVariables = {
  id?: string | null,
};

export type FetchArxAllAccessCategoriesQuery = {
  fetchArxAllAccessCategories?:  {
    __typename: "ArxAccessCategoryResponse",
    items?:  Array< {
      __typename: "ArxAccessCategory",
      id?: string | null,
      categoryName?: string | null,
    } | null > | null,
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
  } | null,
};

export type FindARXPersonByIdQueryVariables = {
  id: string,
};

export type FindARXPersonByIdQuery = {
  findARXPersonById?:  {
    __typename: "ArxExportPersonResponse",
    id?: string | null,
    name?: string | null,
    accessCategories?:  Array< {
      __typename: "ArxPersonAccessCategory",
      id?: string | null,
      name?: string | null,
      startDate?: string | null,
      endDate?: string | null,
    } | null > | null,
    accessCards?:  Array< {
      __typename: "ArxPersonAccessCard",
      cardNumber?: string | null,
      formatName?: string | null,
      cardDescription?: string | null,
    } | null > | null,
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
  } | null,
};

export type GetActivityForSiteLocationQueryVariables = {
  userId: number,
  siteLocationId: number,
  offset: number,
  pageSize: number,
  dateFrom: string,
  dateTo: string,
  stageId: number,
  eventType: string,
  platformAdmin: boolean,
};

export type GetActivityForSiteLocationQuery = {
  getActivityForSiteLocation?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityMyTasksForSiteLocationQueryVariables = {
  userId: number,
  roleId: number,
  siteLocationId: number,
  offset: number,
  pageSize: number,
  closedInquiries: boolean,
  platformAdmin: boolean,
};

export type GetActivityMyTasksForSiteLocationQuery = {
  getActivityMyTasksForSiteLocation?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityVisitsForSiteLocationQueryVariables = {
  userId: number,
  siteLocationId: number,
  offset: number,
  pageSize: number,
  platformAdmin: boolean,
};

export type GetActivityVisitsForSiteLocationQuery = {
  getActivityVisitsForSiteLocation?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type OpenSodvinDoorQueryVariables = {
  gymxsGymId: number,
  mobileNumber: string,
  sodvinCustomerId: string,
  gymxsDoorId: number,
};

export type OpenSodvinDoorQuery = {
  openSodvinDoor?:  {
    __typename: "SodvinOpenDoorResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    message?: string | null,
    success?: boolean | null,
  } | null,
};

export type OpenSodvinDoorAnonymousQueryVariables = {
  name: string,
  sodvinDoorId: string,
  sodvinDoorSecret: string,
  userId: number,
  siteLocationId: number,
  comment: string,
};

export type OpenSodvinDoorAnonymousQuery = {
  openSodvinDoorAnonymous?:  {
    __typename: "SodvinOpenDoorResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    message?: string | null,
    success?: boolean | null,
  } | null,
};

export type AccessPreCheckSodvinQueryVariables = {
  sodvinCompanyId: string,
  gymxsGymId: number,
  mobileNumber: string,
  sodvinCustomerId: string,
  gymxsDoorId: number,
};

export type AccessPreCheckSodvinQuery = {
  accessPreCheckSodvin?:  {
    __typename: "SodvinPreCheckResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    message?: string | null,
    accessAllowed?: boolean | null,
    customerId?: number | null,
    authMessageValue?: number | null,
    authMessageText?: string | null,
  } | null,
};

export type GetMemberEventStatusTypesQuery = {
  getMemberEventStatusTypes?:  Array< {
    __typename: "MemberEventStatus",
    id?: number | null,
    description?: string | null,
    isDeleted?: boolean | null,
  } | null > | null,
};

export type GetActivityMyTasksCountQueryVariables = {
  userId: number,
  roleId: number,
  siteLocationId: number,
  platformAdmin: boolean,
};

export type GetActivityMyTasksCountQuery = {
  getActivityMyTasksCount?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetAllUsersQuery = {
  getAllUsers?:  Array< {
    __typename: "GetAllUsersResponse",
    id: number,
    firstName: string,
    lastName: string,
    isPlatformUser?: boolean | null,
  } | null > | null,
};

export type GetGymsByUniqueIdQueryVariables = {
  uniqueIds: string,
};

export type GetGymsByUniqueIdQuery = {
  getGymsByUniqueId?:  Array< {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null > | null,
};

export type GetAvailableEventsQuery = {
  getAvailableEvents?:  Array< {
    __typename: "EventJoined",
    eventId: number,
    eventDescription?: string | null,
    eventTypeId: number,
    eventType?: string | null,
    stageId?: number | null,
    stage?: string | null,
  } | null > | null,
};

export type GetUserByEmailQueryVariables = {
  email: string,
};

export type GetUserByEmailQuery = {
  getUserByEmail?:  {
    __typename: "User",
    id: number,
    username: string,
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    isActive?: boolean | null,
    language?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    appVersion?: string | null,
    profilePicturePath?: string | null,
    isProfilePicVerified?: boolean | null,
    isMobileAppUser?: boolean | null,
    isAdministrator?: boolean | null,
    isDeleted?: boolean | null,
    isSystemUser?: boolean | null,
    isMobileAppDisabled?: boolean | null,
    isJustTapRevoked?: boolean | null,
    defaultLocationDetectionMethod: string,
    isMoreInfoRequested?: boolean | null,
    memberId?: number | null,
  } | null,
};

export type ImportSodvinLocationQueryVariables = {
  sodvinCompanyId: string,
};

export type ImportSodvinLocationQuery = {
  importSodvinLocation?:  {
    __typename: "SodvinImportedLocation",
    name?: string | null,
    organizationNumber?: string | null,
    webAddress?: string | null,
    logo?: string | null,
    address1?: string | null,
    address2?: string | null,
    zip?: string | null,
    postOffice?: string | null,
    telephone?: string | null,
    email?: string | null,
    error?: boolean | null,
    errorMsg?: string | null,
  } | null,
};

export type ImportSodvinDepartmentQueryVariables = {
  sodvinCompanyId: string,
  sodvinDepartmentId: string,
};

export type ImportSodvinDepartmentQuery = {
  importSodvinDepartment?:  {
    __typename: "SodvinImportedLocation",
    name?: string | null,
    organizationNumber?: string | null,
    webAddress?: string | null,
    logo?: string | null,
    address1?: string | null,
    address2?: string | null,
    zip?: string | null,
    postOffice?: string | null,
    telephone?: string | null,
    email?: string | null,
    error?: boolean | null,
    errorMsg?: string | null,
  } | null,
};

export type GetGymByCompanyIdQueryVariables = {
  gymChainId: number,
  gymCompanyId: string,
};

export type GetGymByCompanyIdQuery = {
  getGymByCompanyId?:  Array< {
    __typename: "Gym",
    gymChainName?: string | null,
    gymChainId: number,
    gymId: number,
    gymIdApi?: number | null,
    gymName?: string | null,
    contactPerson?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    address?: string | null,
    status?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastImportedDate?: string | null,
    lastModifiedBy?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    trialMembershipId?: number | null,
    staffMembershipId?: number | null,
    freePassId?: number | null,
    handbackTime?: number | null,
    defaultLocationDetectionMethod?: string | null,
    primaryAccessMethod?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    gracePeriodWhenDeclined?: number | null,
    accessPerDayWhenDeclined?: number | null,
    gracePeriodWhenExpired?: number | null,
    accessPerDayWhenExpired?: number | null,
    gracePeriodWhenSuspended?: number | null,
    accessPerDayWhenSuspended?: number | null,
    isMobileCredentialAllowed?: boolean | null,
    websiteLink?: string | null,
    city?: string | null,
    membershipOnSignup?: number | null,
    membershipForVisits?: number | null,
    syncAllVisitsWithGenericSubscription?: boolean | null,
    isDeleted?: boolean | null,
    signUpUrl?: string | null,
    arxReferenceId?: string | null,
    sodvinCompanyId?: string | null,
    providerId?: number | null,
    allowConvertingAccessCards?: boolean | null,
    cardType?: string | null,
    addArrivalAuto?: boolean | null,
    addVisitAuto?: boolean | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    timeZone?: string | null,
    prioratizeClasses?: boolean | null,
    blockTime?: number | null,
    markArrivalFirst?: boolean | null,
    openWithoutArrivalMarked?: boolean | null,
    markMultipleAttendanceAuto?: boolean | null,
    markArrivalsWhenThereAreVisits?: boolean | null,
    allowAppointmentCompletion?: boolean | null,
    isClassPortalEnabled?: boolean | null,
    isEmployeeDashboardEnabled?: boolean | null,
  } | null > | null,
};

export type GetAccessCategoriesQueryVariables = {
  siteLocationId: number,
};

export type GetAccessCategoriesQuery = {
  getAccessCategories?:  {
    __typename: "GymAccessCategoriesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "GymChainAccessCategories",
      id?: number | null,
      siteId?: number | null,
      name?: string | null,
      gender?: string | null,
      age?: number | null,
      schedulesOnly?: boolean | null,
      status?: string | null,
      accessCategoryId?: number | null,
      siteLocationAccessCategoryId?: number | null,
      siteLocationId?: number | null,
      siteLocationMembershipId?: number | null,
      locationName?: string | null,
      arxAccessCategoryId?: string | null,
      importedId?: string | null,
      membershipId?: number | null,
      membershipName?: string | null,
      program?: string | null,
      scheduleType?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
    } | null > | null,
  } | null,
};

export type GetSiteLocationProgramAccessCategoriesQueryVariables = {
  siteLocationId: number,
};

export type GetSiteLocationProgramAccessCategoriesQuery = {
  getSiteLocationProgramAccessCategories?:  {
    __typename: "SiteLocationProgramAccessCategoriesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "SiteLocationProgramAccessCategory",
      id?: number | null,
      siteId?: number | null,
      siteLocationId?: number | null,
      locationName?: string | null,
      accessCategoryId?: number | null,
      siteLocationProgramAccessCategoryId?: number | null,
      name?: string | null,
      gender?: string | null,
      age?: number | null,
      schedulesOnly?: boolean | null,
      status?: string | null,
      arxAccessCategoryId?: string | null,
      programId?: number | null,
      programName?: string | null,
      programImportedId?: number | null,
      scheduleType?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
    } | null > | null,
  } | null,
};

export type GetDaySchedulesQueryVariables = {
  offset: number,
  pageSize: number,
  sortField: string,
  sortOrder: string,
  search?: SearchInput | null,
};

export type GetDaySchedulesQuery = {
  getDaySchedules?:  {
    __typename: "DaySchedulesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "DaySchedule",
      id?: number | null,
      name?: string | null,
      arxReferenceId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      status?: string | null,
      weekdayId?: number | null,
      weekdayName?: string | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
    } | null > | null,
  } | null,
};

export type IsAccessCategoryLinkedQueryVariables = {
  locationAccessCategoryId: number,
};

export type IsAccessCategoryLinkedQuery = {
  isAccessCategoryLinked?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetAllWeekDaysQuery = {
  getAllWeekDays?:  Array< {
    __typename: "getAllWeekDaysResponse",
    id: number,
    name: string,
  } | null > | null,
};

export type GetGymSchedulesQueryVariables = {
  siteId: number,
};

export type GetGymSchedulesQuery = {
  getGymSchedules?:  {
    __typename: "GymSchedulesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "GymSchedule",
      siteId?: number | null,
      siteName?: string | null,
      siteScheduleId?: number | null,
      siteScheduleName?: string | null,
      siteScheduleType?: string | null,
      validFrom?: string | null,
      validTo?: string | null,
      scheduleStatusId?: number | null,
      scheduleStatusName?: string | null,
      siteScheduleStatus?: string | null,
      siteScheduleCreatedBy?: number | null,
      siteScheduleCreatedDate?: string | null,
      siteScheduleLastModifiedBy?: number | null,
      siteScheduleLastModifiedDate?: string | null,
      siteScheduleDetailId?: number | null,
      weekdayId?: number | null,
      weekdayName?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      dayScheduleId?: number | null,
      siteScheduleDetailStatus?: string | null,
      siteScheduleDetailCreatedBy?: number | null,
      siteLocationScheduleId?: number | null,
      siteLocationId?: number | null,
      siteLocationName?: string | null,
      imageUrl?: string | null,
      zoneId?: number | null,
      zoneName?: string | null,
      accessCategoryId?: number | null,
      siteLocationAccessCategoryId?: number | null,
      siteLocationProgramAccessCategoryId?: number | null,
      accessCategoryName?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
      siteLocationScheduleCreatedBy?: number | null,
    } | null > | null,
  } | null,
};

export type GetGymChainAccessCategoriesQueryVariables = {
  siteId: number,
};

export type GetGymChainAccessCategoriesQuery = {
  getGymChainAccessCategories?:  {
    __typename: "GymChainAccessCategoriesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "GymChainAccessCategories",
      id?: number | null,
      siteId?: number | null,
      name?: string | null,
      gender?: string | null,
      age?: number | null,
      schedulesOnly?: boolean | null,
      status?: string | null,
      accessCategoryId?: number | null,
      siteLocationAccessCategoryId?: number | null,
      siteLocationId?: number | null,
      siteLocationMembershipId?: number | null,
      locationName?: string | null,
      arxAccessCategoryId?: string | null,
      importedId?: string | null,
      membershipId?: number | null,
      membershipName?: string | null,
      program?: string | null,
      scheduleType?: string | null,
      createdBy?: number | null,
      createdDate?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
    } | null > | null,
  } | null,
};

export type GetGymChainProgramAccessCategoriesQueryVariables = {
  siteId: number,
};

export type GetGymChainProgramAccessCategoriesQuery = {
  getGymChainProgramAccessCategories?:  {
    __typename: "GymChainProgramAccessCategoriesResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "GymChainProgramAccessCategories",
      id?: number | null,
      siteId?: number | null,
      name?: string | null,
      gender?: string | null,
      age?: number | null,
      schedulesOnly?: boolean | null,
      status?: string | null,
      accessCategoryId?: number | null,
      arxAccessCategoryId?: string | null,
      programAccessCategoryId?: number | null,
      programId?: number | null,
      importedId?: number | null,
      programName?: string | null,
      scheduleType?: string | null,
    } | null > | null,
  } | null,
};

export type ImportSodvinMembershipsQueryVariables = {
  siteId: number,
};

export type ImportSodvinMembershipsQuery = {
  importSodvinMemberships?:  {
    __typename: "SodvinMembershipImport",
    error?: boolean | null,
    errorMsg?: string | null,
  } | null,
};

export type GetZoneAccessCategoryMappingForGymSchedulesQueryVariables = {
  siteId: number,
};

export type GetZoneAccessCategoryMappingForGymSchedulesQuery = {
  getZoneAccessCategoryMappingForGymSchedules?:  Array< {
    __typename: "ZoneAccessCategoryMapping",
    siteLocationMembershipId?: number | null,
    siteLocationId?: number | null,
    locationName?: string | null,
    locationAccessCategoryId?: number | null,
    locationAccessCategoryName?: string | null,
    locationArxAccessCategoryId?: string | null,
    locationAccessCategoryZoneId?: number | null,
    accessCategoryId?: number | null,
    locationProgramAccessCategoryId?: number | null,
    locationProgramAccessCategoryName?: string | null,
    locationProgramArxAccessCategoryId?: string | null,
    locationProgramAccessCategoryZoneId?: number | null,
    programId?: number | null,
    programName?: string | null,
    programImportedId?: number | null,
    programScheduleType?: string | null,
    locationZoneId?: number | null,
    zoneName?: string | null,
    zoneDescription?: string | null,
    siteId?: number | null,
    membershipId?: number | null,
    membershipName?: string | null,
  } | null > | null,
};

export type GetAccessPointsForSiteQueryVariables = {
  siteId: number,
};

export type GetAccessPointsForSiteQuery = {
  getAccessPointsForSite?:  Array< {
    __typename: "SiteAccessPoint",
    locationAccessPointId?: number | null,
    siteId?: number | null,
    siteLocationId?: number | null,
    locationZoneId?: number | null,
    locationZoneName?: string | null,
    zoneAccessPointId?: number | null,
    doorARXId?: string | null,
    doorName?: string | null,
    status?: string | null,
  } | null > | null,
};

export type GetAllScheduleStatusesQuery = {
  getAllScheduleStatuses?:  Array< {
    __typename: "ScheduleStatuses",
    id: number,
    name: string,
  } | null > | null,
};

export type CheckDoorAccessQueryVariables = {
  accessPointId: number,
  userDateTime: string,
  memberIds: string,
};

export type CheckDoorAccessQuery = {
  checkDoorAccess?:  {
    __typename: "DoorScheduleStatus",
    success?: boolean | null,
  } | null,
};

export type GetPendingIssuesReportedByUserQueryVariables = {
  userId: number,
};

export type GetPendingIssuesReportedByUserQuery = {
  getPendingIssuesReportedByUser?:  Array< {
    __typename: "UserIssue",
    issueId?: number | null,
    issueTitle?: string | null,
    issueDescription?: string | null,
    lastModifiedDate?: string | null,
    issueStatus?: string | null,
  } | null > | null,
};

export type CheckDoorExpiryQueryVariables = {
  accessPointId: number,
  memberId: number,
  userDateTime: string,
};

export type CheckDoorExpiryQuery = {
  checkDoorExpiry?:  {
    __typename: "DoorExpiryStatus",
    success?: boolean | null,
    statusMessage?: string | null,
  } | null,
};

export type GetAllRolesQuery = {
  getAllRoles?:  Array< {
    __typename: "Role",
    roleId?: number | null,
    roleName?: string | null,
    roleDescription?: string | null,
  } | null > | null,
};

export type GetActivityForUserQueryVariables = {
  userId: number,
  offset: number,
  pageSize: number,
  dateFrom: string,
  dateTo: string,
  stageId: number,
  eventType: string,
  platformAdmin: boolean,
};

export type GetActivityForUserQuery = {
  getActivityForUser?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityMyTasksForUserQueryVariables = {
  userId: number,
  roleId: number,
  offset: number,
  pageSize: number,
  closedInquiries: boolean,
  platformAdmin: boolean,
};

export type GetActivityMyTasksForUserQuery = {
  getActivityMyTasksForUser?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityMyTasksCountForUserQueryVariables = {
  userId: number,
  roleId: number,
  platformAdmin: boolean,
};

export type GetActivityMyTasksCountForUserQuery = {
  getActivityMyTasksCountForUser?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetActivityForSiteQueryVariables = {
  userId: number,
  siteId: number,
  offset: number,
  pageSize: number,
  dateFrom: string,
  dateTo: string,
  stageId: number,
  eventType: string,
  platformAdmin: boolean,
};

export type GetActivityForSiteQuery = {
  getActivityForSite?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityMyTasksForSiteQueryVariables = {
  userId: number,
  roleId: number,
  siteId: number,
  offset: number,
  pageSize: number,
  closedInquiries: boolean,
  platformAdmin: boolean,
};

export type GetActivityMyTasksForSiteQuery = {
  getActivityMyTasksForSite?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetActivityMyTasksCountForSiteQueryVariables = {
  userId: number,
  roleId: number,
  siteId: number,
  platformAdmin: boolean,
};

export type GetActivityMyTasksCountForSiteQuery = {
  getActivityMyTasksCountForSite?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetAccessCardHistoryQueryVariables = {
  memberId: number,
  siteLocationId: number,
};

export type GetAccessCardHistoryQuery = {
  getAccessCardHistory?:  Array< {
    __typename: "AccessCardHistoryResponse",
    id?: number | null,
    accessCardUID?: string | null,
    userId?: number | null,
    isActive?: boolean | null,
    deactivatedDateTime?: string | null,
    accessCardFormatName?: string | null,
    memberId?: number | null,
    integrationCardId?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    siteLocationId?: number | null,
    lastModifiedDate?: string | null,
    lastModifiedBy?: string | null,
  } | null > | null,
};

export type GetWalletPassesForMemberQueryVariables = {
  memberId: number,
};

export type GetWalletPassesForMemberQuery = {
  getWalletPassesForMember?:  Array< {
    __typename: "WalletPassHistoryResponse",
    id?: number | null,
    memberId?: number | null,
    walletPassType?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    revokedDate?: string | null,
  } | null > | null,
};

export type GetForcedAccessQueryVariables = {
  memberId: number,
  siteLocationId: number,
};

export type GetForcedAccessQuery = {
  getForcedAccess?:  {
    __typename: "ForcedAccessResponse",
    id?: number | null,
    memberLocationId?: number | null,
    startingTime?: string | null,
    endingTime?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    isActive?: boolean | null,
    isIndefinite?: boolean | null,
    overrideLocationDetection?: boolean | null,
    overrideClientStatuses?: boolean | null,
  } | null,
};

export type GetSearchedMembersForSiteLocationQueryVariables = {
  searchTerm: string,
  siteLocationId: number,
};

export type GetSearchedMembersForSiteLocationQuery = {
  getSearchedMembersForSiteLocation?:  Array< {
    __typename: "MemberAccessCard",
    userId?: number | null,
    memberId?: number | null,
    firstName?: string | null,
    lastName?: string | null,
    arxReferenceId?: string | null,
    imageUrl?: string | null,
    hasAccessCard?: boolean | null,
  } | null > | null,
};

export type GetSiteLocationUserQueryVariables = {
  userId: number,
};

export type GetSiteLocationUserQuery = {
  getSiteLocationUser?:  Array< {
    __typename: "SiteLocationUser",
    id: number,
    siteId: number,
    locationId: number,
    userId: number,
  } | null > | null,
};

export type GetMemberLocationQueryVariables = {
  memberId: number,
};

export type GetMemberLocationQuery = {
  getMemberLocation?:  Array< {
    __typename: "MemberLocation",
    id?: number | null,
    siteLocationId?: number | null,
    memberId?: number | null,
    status?: string | null,
    isBlocked?: boolean | null,
    contractExpiryDate?: string | null,
  } | null > | null,
};

export type GetAccessMethodsForMemberQueryVariables = {
  userId: number,
  memberId: number,
  siteLocationId: number,
};

export type GetAccessMethodsForMemberQuery = {
  getAccessMethodsForMember?:  {
    __typename: "MemberAccessMethodsResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "AccessMethod",
      accessCardUID?: number | null,
      mobileAppId?: number | null,
      createdDate?: string | null,
      createdBy?: number | null,
      lastModifiedDate?: string | null,
      lastModifiedBy?: number | null,
      isMobileAppDisabled?: boolean | null,
      isActive?: boolean | null,
      type?: string | null,
    } | null > | null,
  } | null,
};

export type GetReceivedInformationQueryVariables = {
  userId: number,
};

export type GetReceivedInformationQuery = {
  getReceivedInformation?:  Array< {
    __typename: "ReceivedInformation",
    id?: number | null,
    userPhone?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    birthDate?: string | null,
    inquiryMemberId?: number | null,
    siteId?: number | null,
    siteLocationId?: number | null,
  } | null > | null,
};

export type GetMatchingRecordsQueryVariables = {
  email: string,
  phoneNumber: string,
  birthDate: string,
  siteId: string,
};

export type GetMatchingRecordsQuery = {
  getMatchingRecords?:  {
    __typename: "MatchingRecordsResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "MatchingRecords",
      id?: number | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      birthDate?: string | null,
      providerId?: number | null,
      uniqueId?: number | null,
      userId?: number | null,
      address?: string | null,
    } | null > | null,
  } | null,
};

export type GetMembersForUserQueryVariables = {
  userId: number,
};

export type GetMembersForUserQuery = {
  getMembersForUser?:  Array< {
    __typename: "MemberResponse",
    id?: number | null,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    createdDate?: string | null,
    createdBy?: number | null,
    lastModifiedDate?: string | null,
    lastModifiedBy?: number | null,
    email?: string | null,
    lastSyncDate?: string | null,
    isNew?: boolean | null,
    providerId?: string | null,
    arxReferenceId?: string | null,
    userId?: number | null,
    dateOfBirth?: string | null,
  } | null > | null,
};

export type GetActivityForMemberQueryVariables = {
  userId: number,
  offset: number,
  pageSize: number,
  dateFrom: string,
  dateTo: string,
  stageId: number,
  eventType: string,
  platformAdmin: boolean,
};

export type GetActivityForMemberQuery = {
  getActivityForMember?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type FilterSchedulesByDateQueryVariables = {
  subscriptions?: string | null,
  rangeStart?: string | null,
  rangeEnd?: string | null,
};

export type FilterSchedulesByDateQuery = {
  filterSchedulesByDate?:  Array< {
    __typename: "SchedulesFilterResponse",
    date?: string | null,
    schedules?:  Array< {
      __typename: "DateSchedule",
      name?: string | null,
      startTime?: string | null,
      endTime?: string | null,
    } | null > | null,
  } | null > | null,
};

export type FilterGymOpeningHoursByDateQueryVariables = {
  subscriptions?: string | null,
  rangeStart?: string | null,
  rangeEnd?: string | null,
};

export type FilterGymOpeningHoursByDateQuery = {
  filterGymOpeningHoursByDate?:  Array< {
    __typename: "OpeningHoursFilterResponse",
    date?: string | null,
    openingHours?:  Array< {
      __typename: "GymOpeningHour",
      name?: string | null,
      startTime?: string | null,
      endTime?: string | null,
    } | null > | null,
  } | null > | null,
};

export type GetDayScheduleLinkCountQueryVariables = {
  dayScheduleId: number,
};

export type GetDayScheduleLinkCountQuery = {
  getDayScheduleLinkCount?:  {
    __typename: "CountResponse",
    count?: number | null,
  } | null,
};

export type GetAccessRulesQueryVariables = {
  siteId: number,
};

export type GetAccessRulesQuery = {
  getAccessRules?:  Array< {
    __typename: "AccessRule",
    id?: number | null,
    level?: string | null,
    type?: string | null,
    defaultRef?: number | null,
    serviceResponse?: string | null,
    accessStatus?: string | null,
    maxLimit?: number | null,
    allowAccess?: string | null,
    gracePeriod?: string | null,
    graceAccessCount?: number | null,
    isCustom?: boolean | null,
    noOfDays?: number | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
  } | null > | null,
};

export type GetLoggedInUserWebQueryVariables = {
  email: string,
};

export type GetLoggedInUserWebQuery = {
  getLoggedInUserWeb?:  {
    __typename: "LoggedInUser",
    userId?: number | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    roleId?: number | null,
    roleName?: string | null,
    language?: string | null,
    siteCount?: number | null,
    locationCount?: number | null,
  } | null,
};

export type GetLastMemberAssignmentHistoryQueryVariables = {
  userId: number,
  eventId: number,
};

export type GetLastMemberAssignmentHistoryQuery = {
  getLastMemberAssignmentHistory?:  {
    __typename: "MemberAssignmentHistoryResponse",
    id?: number | null,
    memberEventId?: number | null,
    createdDate?: string | null,
    assignedBy?: number | null,
    createdBy?: number | null,
    isDeleted?: boolean | null,
    assignedUserId?: number | null,
    assignedRoleId?: number | null,
    assignedDateTime?: string | null,
    currentlyAssigned?: boolean | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    resolvedDescription?: string | null,
    closedDescription?: string | null,
  } | null,
};

export type GetReceivedInformationForMemberQueryVariables = {
  memberId: number,
};

export type GetReceivedInformationForMemberQuery = {
  getReceivedInformationForMember?:  {
    __typename: "ReceivedInformationForMemberResponse",
    id?: number | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    imageUrl?: string | null,
  } | null,
};

export type GetEventByDescriptionQueryVariables = {
  description: string,
};

export type GetEventByDescriptionQuery = {
  getEventByDescription?:  {
    __typename: "EventJoined",
    eventId: number,
    eventDescription?: string | null,
    eventTypeId: number,
    eventType?: string | null,
    stageId?: number | null,
    stage?: string | null,
  } | null,
};

export type GetSodvinBookingForCustomerQueryVariables = {
  sodvinCompanyId: string,
  customerId: number,
  customerMobile: string,
  customerBirthdate?: string | null,
  fromDate: string,
  toDate: string,
  siteLocationId: number,
};

export type GetSodvinBookingForCustomerQuery = {
  getSodvinBookingForCustomer?:  {
    __typename: "SodvinBookingsResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    customerBookings?:  Array< {
      __typename: "CustomerBooking",
      groupSessionCustomerId?: number | null,
      customerId?: number | null,
      reservationDate?: string | null,
      cancelationDate?: string | null,
      movedFromWaitingListDate?: string | null,
      groupSessionId?: number | null,
      groupSessionDepartmentId?: number | null,
      groupSessionDepartmentName?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      subject?: string | null,
      reservationStatus?: number | null,
      nrOnWaitingList?: number | null,
      attended?: boolean | null,
      reservationGUID?: string | null,
      isInCancelInterval?: boolean | null,
      isInRegistrateAttendencyInterval?: boolean | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      bookingCustomerName?: string | null,
      extendedInfo?:  {
        __typename: "CustomerBookingExtendedInfo",
        groupSessionCustomerExtendedInfoId?: number | null,
        groupSessionCustomerId?: number | null,
        name?: string | null,
        email?: string | null,
        mobile?: string | null,
        confirmOnMail?: boolean | null,
        confirmOnSMS?: boolean | null,
      } | null,
    } | null > | null,
    success?: boolean | null,
  } | null,
};

export type GetSubscriptionsForSiteLinkedMembersQueryVariables = {
  userId?: number | null,
};

export type GetSubscriptionsForSiteLinkedMembersQuery = {
  getSubscriptionsForSiteLinkedMembers?:  Array< {
    __typename: "GymSubscription",
    subscriptionId: number,
    gymDefLocationDetectionMethod?: string | null,
    gymName: string,
    membershipName: string,
    gymChainName: string,
    gymChainLogo?: string | null,
    userDefLocationDetectionMethod?: string | null,
    memberId?: number | null,
    memberFirstName?: string | null,
    memberLastName?: string | null,
    memberPhone?: string | null,
    userId?: number | null,
    gymLogo?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    isGranted?: boolean | null,
    isTrial?: boolean | null,
    isDeleted?: boolean | null,
    isMemberBlocked?: boolean | null,
    gymStatus?: string | null,
    gymId: number,
    siteLocationMembershipId?: string | null,
    scheduleType?: string | null,
    programId?: number | null,
    serviceId?: number | null,
    totalVisits?: number | null,
    remainingVisits?: number | null,
    providerId?: number | null,
    subscriptionStatus?: string | null,
    yellowboxId?: string | null,
  } | null > | null,
};

export type GetNewNumberFlowQueryVariables = {
  siteLocationId: number,
  phone: string,
};

export type GetNewNumberFlowQuery = {
  getNewNumberFlow?:  {
    __typename: "NewNumberResponse",
    error?: boolean | null,
    errorType?: string | null,
    errorMsg?: string | null,
    memberIds?: Array< number | null > | null,
    success?: boolean | null,
  } | null,
};

export type GetActivityForSiteLocationMemberQueryVariables = {
  userId: number,
  siteLocationId: number,
  offset: number,
  pageSize: number,
  dateFrom: string,
  dateTo: string,
  stageId: number,
  eventType: string,
  platformAdmin: boolean,
  memberId: number,
};

export type GetActivityForSiteLocationMemberQuery = {
  getActivityForSiteLocationMember?:  {
    __typename: "GymActivityResponse",
    items?:  Array< {
      __typename: "GymActivity",
      memberEventId?: number | null,
      memberId?: number | null,
      memberEmail?: string | null,
      eventId?: number | null,
      accessCardUID?: string | null,
      eventDescription?: string | null,
      eventType?: string | null,
      stageId?: number | null,
      stage?: string | null,
      createdTime?: string | null,
      isAutoAssigned?: boolean | null,
      memberEventStatusTypeId?: number | null,
      memberEventStatusType?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      siteLocationId?: number | null,
      assignedUserId?: number | null,
      assignmentHistoryId?: number | null,
      locationName?: string | null,
      lastModifiedBy?: number | null,
      lastModifiedDate?: string | null,
      inquiryDescription?: string | null,
      memberLocationId?: number | null,
      informationReceivedEvent?: boolean | null,
      language?: string | null,
      userId?: number | null,
      en?: string | null,
      nor?: string | null,
      nl?: string | null,
      locationAccessPointId?: number | null,
      locationAccessPointName?: string | null,
    } | null > | null,
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
  } | null,
};

export type GetProviderForGymQueryVariables = {
  siteLocationId: number,
};

export type GetProviderForGymQuery = {
  getProviderForGym?:  {
    __typename: "ProviderResponse",
    siteLocationId?: number | null,
    providerId?: number | null,
    providerName?: string | null,
  } | null,
};

export type GetAllAccessCardTypesQuery = {
  getAllAccessCardTypes?:  Array< {
    __typename: "GetAllAccessCardTypesResponse",
    id?: number | null,
    accessCard?: string | null,
    value?: string | null,
  } | null > | null,
};

export type GetScheduleRequestsQuery = {
  getScheduleRequests?:  {
    __typename: "ScheduleRequestsResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "ScheduleRequest",
      scheduleId?: number | null,
      gymName?: string | null,
      gymChainName?: string | null,
      scheduleName?: string | null,
      status?: string | null,
      createdDate?: string | null,
      weekdayId?: number | null,
      startTime?: string | null,
      endTime?: string | null,
      gymChainId?: number | null,
      weekdayName?: string | null,
      gymId?: number | null,
    } | null > | null,
  } | null,
};

export type GetScheduleRequestsBySiteQueryVariables = {
  siteId: number,
};

export type GetScheduleRequestsBySiteQuery = {
  getScheduleRequestsBySite?:  {
    __typename: "ScheduleRequestsResponse",
    totalRecords?:  {
      __typename: "PageCount",
      totalRecords: number,
    } | null,
    items?:  Array< {
      __typename: "ScheduleRequest",
      scheduleId?: number | null,
      gymName?: string | null,
      gymChainName?: string | null,
      scheduleName?: string | null,
      status?: string | null,
      createdDate?: string | null,
      weekdayId?: number | null,
      startTime?: string | null,
      endTime?: string | null,
      gymChainId?: number | null,
      weekdayName?: string | null,
      gymId?: number | null,
    } | null > | null,
  } | null,
};

export type GetAllGymChainsQuery = {
  getAllGymChains?:  Array< {
    __typename: "GymChainDropdownItem",
    gymChainId?: number | null,
    gymChainName?: string | null,
  } | null > | null,
};

export type ValidateAccessQueryVariables = {
  accessPointId: number,
  userId: number,
  userTime: string,
  lowerBound?: number | null,
  upperBound?: number | null,
};

export type ValidateAccessQuery = {
  validateAccess?:  {
    __typename: "AccessValidation",
    accessStatus?: string | null,
    accessGranted?: boolean | null,
    isGraceAccess?: boolean | null,
    gracePeriod?: string | null,
    remainingGraceAccessCount?: number | null,
    accessRuleId?: number | null,
    isGranted?: boolean | null,
    isTrial?: boolean | null,
    activeSubscriptionIds?: Array< number | null > | null,
    validatedSubscriptionId?: number | null,
    subscriptionData?:  Array< {
      __typename: "AccessValidationSubscriptionData",
      subscriptionId?: number | null,
      programId?: number | null,
      scheduleType?: string | null,
    } | null > | null,
  } | null,
};

export type ValidateForcedAccessOverrideQueryVariables = {
  accessPointId: number,
  userId: number,
  userTime: string,
};

export type ValidateForcedAccessOverrideQuery = {
  validateForcedAccessOverride?:  {
    __typename: "AccessValidation",
    accessStatus?: string | null,
    accessGranted?: boolean | null,
    isGraceAccess?: boolean | null,
    gracePeriod?: string | null,
    remainingGraceAccessCount?: number | null,
    accessRuleId?: number | null,
    isGranted?: boolean | null,
    isTrial?: boolean | null,
    activeSubscriptionIds?: Array< number | null > | null,
    validatedSubscriptionId?: number | null,
    subscriptionData?:  Array< {
      __typename: "AccessValidationSubscriptionData",
      subscriptionId?: number | null,
      programId?: number | null,
      scheduleType?: string | null,
    } | null > | null,
  } | null,
};

export type GetMindbodyAppointmentsQueryVariables = {
  subscriptionIds: string,
  rangeStart?: string | null,
  rangeEnd?: string | null,
};

export type GetMindbodyAppointmentsQuery = {
  getMindbodyAppointments?:  Array< {
    __typename: "MindbodyAppointmentRecord",
    id: number,
    memberLocationMembershipId?: number | null,
    importedId?: number | null,
    name?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    isVisited?: boolean | null,
    isDeleted?: boolean | null,
    serviceCategory?: string | null,
    remainingVisits?: number | null,
    siteId?: number | null,
    customerSiteId?: string | null,
    locationId?: number | null,
    insideBlockTime?: boolean | null,
  } | null > | null,
};

export type GetYellowboxBookingsOrAvailabilityQueryVariables = {
  memberId: number,
  locationId: string,
};

export type GetYellowboxBookingsOrAvailabilityQuery = {
  getYellowboxBookingsOrAvailability?:  {
    __typename: "YellowboxBookingsOrAvailabilityResponse",
    availability?:  Array< {
      __typename: "YellowboxAvailability",
      prefix?: string | null,
      prefixLong?: string | null,
      availabilityBySize?:  Array< {
        __typename: "YellowboxAvailabilityBySize",
        size?: string | null,
        countAvailable?: number | null,
      } | null > | null,
    } | null > | null,
    bookings?:  Array< {
      __typename: "YellowboxBooking",
      lockerId?: string | null,
      location?: string | null,
      lockerNumber?: number | null,
      prefix?: string | null,
      prefixLong?: string | null,
      bookingStart?: string | null,
    } | null > | null,
  } | null,
};

export type GetSiteScheduleDetailsByIdQueryVariables = {
  id: number,
};

export type GetSiteScheduleDetailsByIdQuery = {
  getSiteScheduleDetailsById?:  Array< {
    __typename: "SiteScheduleDetails",
    id?: number | null,
    siteScheduleId?: number | null,
    isRequested?: boolean | null,
    siteId?: number | null,
  } | null > | null,
};

export type GetActiveAccessCardForUserQueryVariables = {
  userId: number,
};

export type GetActiveAccessCardForUserQuery = {
  getActiveAccessCardForUser?:  Array< {
    __typename: "ActiveAccessCardForUserResponse",
    accessCardUID?: string | null,
    accessCardFormatName?: string | null,
    memberArxReferenceId?: string | null,
  } | null > | null,
};

export type ImportProgramsQueryVariables = {
  siteId: number,
  customerSiteId: string,
};

export type ImportProgramsQuery = {
  importPrograms?:  {
    __typename: "LambdaResponse",
    error: boolean,
    errorType?: string | null,
    errorMsg?: string | null,
    rollbackStatus?: string | null,
  } | null,
};

export type GetAllProgramsQueryVariables = {
  siteId: number,
};

export type GetAllProgramsQuery = {
  getAllPrograms?:  Array< {
    __typename: "RelatedProgram",
    id?: number | null,
    siteId?: number | null,
    importedId?: number | null,
    programName?: string | null,
    scheduleType?: string | null,
    createdBy?: number | null,
    createdDate?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    linkedProgramId?: number | null,
    linkCreatedBy?: number | null,
    linkCreatedDate?: string | null,
    linkLastModifiedBy?: number | null,
    linkLastModifiedDate?: string | null,
  } | null > | null,
};

export type GetGymClustersQueryVariables = {
  memberIds?: string | null,
};

export type GetGymClustersQuery = {
  getGymClusters:  Array< {
    __typename: "SubscribedGym",
    providerId: number,
    providerName?: string | null,
    gymChainId: number,
    gymChainName?: string | null,
    locationId: number,
    accessPointId?: number | null,
    locationName?: string | null,
    locationCity?: string | null,
    gymInquiriesByUser?: number | null,
    imageUrl?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    beaconUUID?: string | null,
    beaconMajor?: string | null,
    beaconMinor?: string | null,
    membershipName?: string | null,
    defaultLocationDetectionMethod?: string | null,
    doorName?: string | null,
    doorDescription?: string | null,
    status?: string | null,
    doorARXId?: string | null,
    locationAddress?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionId?: number | null,
    sodvinDoorId?: string | null,
    sodvinDoorSecret?: string | null,
    sodvinCompanyId?: string | null,
    siteLocationArxReferenceId?: string | null,
    memberUniqueId?: string | null,
    memberArxReferenceId?: string | null,
    siteLocationHandbackTime?: number | null,
    accessPointHandbackTime?: number | null,
    isGranted?: boolean | null,
    isTrial?: boolean | null,
    accessPointType?: string | null,
    siteLocationPhone?: string | null,
    externalBookingsLink?: string | null,
    facebookLink?: string | null,
    twitterLink?: string | null,
    instagramLink?: string | null,
    websiteLink?: string | null,
    gymStatus?: string | null,
    forcedAccessStartTime?: string | null,
    forcedAccessEndTime?: string | null,
    forcedAccessIsIndefinite?: boolean | null,
    overrideLocationDetection?: boolean | null,
    overrideClientStatuses?: boolean | null,
    isMemberBlocked?: boolean | null,
    isSodvinCompany?: boolean | null,
    customerSiteId?: string | null,
    memberId?: number | null,
    memberPhone?: string | null,
    isDeclined?: boolean | null,
    isSuspended?: boolean | null,
    notAvailable?: boolean | null,
    scheduleType?: string | null,
    programId?: number | null,
    serviceId?: number | null,
    totalVisits?: number | null,
    remainingVisits?: number | null,
    sessionCheckTimeLimit?: number | null,
    sessionCheckTimeLimitUpper?: number | null,
    excludeBookingTime?: boolean | null,
    serviceCategory?: string | null,
    siteLocationIdApi?: number | null,
    subscriptionStatus?: string | null,
    remainingSessions?: number | null,
    isLockerEnabled?: boolean | null,
    allowDoorOpenOnNoVisit?: boolean | null,
    locationAccessCategoryId?: number | null,
    locationZoneId?: number | null,
    addVisitAuto?: boolean | null,
    addArrivalAuto?: boolean | null,
    arrivalId?: number | null,
    arrivalACId?: number | null,
    arrivalStartDateTime?: string | null,
    arrivalEndDateTime?: string | null,
    siteLocationMembershipId?: number | null,
    yellowboxId?: string | null,
    blockTime?: number | null,
  } >,
};

export type GetMemberSyncStatusQueryVariables = {
  userId?: string | null,
  memberIds?: string | null,
};

export type GetMemberSyncStatusQuery = {
  getMemberSyncStatus?:  Array< {
    __typename: "MemberSyncStatus",
    id?: number | null,
  } | null > | null,
};

export type ValidateArrivalsQueryVariables = {
  subscriptionData: string,
  userTime: string,
  prioratizedSubscription: string,
};

export type ValidateArrivalsQuery = {
  validateArrivals?:  {
    __typename: "ArrivalValidation",
    marked?: Array< number | null > | null,
    unmarked?: Array< number | null > | null,
  } | null,
};

export type ValidateVisitsQueryVariables = {
  subscriptionData: string,
  userTime: string,
  blockTime?: number | null,
  lowerBound?: number | null,
  upperBound?: number | null,
};

export type ValidateVisitsQuery = {
  validateVisits?:  Array< {
    __typename: "MindbodyAppointmentRecord",
    id: number,
    memberLocationMembershipId?: number | null,
    importedId?: number | null,
    name?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    isVisited?: boolean | null,
    isDeleted?: boolean | null,
    serviceCategory?: string | null,
    remainingVisits?: number | null,
    siteId?: number | null,
    customerSiteId?: string | null,
    locationId?: number | null,
    insideBlockTime?: boolean | null,
  } | null > | null,
};

export type PullBookingsQueryVariables = {
  gymId: number,
  memberId: number,
  filterStart: string,
  filterEnd: string,
  userTime: string,
  blockTime?: number | null,
  lowerBound?: number | null,
  upperBound?: number | null,
};

export type PullBookingsQuery = {
  pullBookings?:  Array< {
    __typename: "MindbodyAppointmentRecord",
    id: number,
    memberLocationMembershipId?: number | null,
    importedId?: number | null,
    name?: string | null,
    startDateTime?: string | null,
    endDateTime?: string | null,
    isVisited?: boolean | null,
    isDeleted?: boolean | null,
    serviceCategory?: string | null,
    remainingVisits?: number | null,
    siteId?: number | null,
    customerSiteId?: string | null,
    locationId?: number | null,
    insideBlockTime?: boolean | null,
  } | null > | null,
};

export type GetMembersByPhoneNumberQueryVariables = {
  phone: string,
  dialingPhone: string,
};

export type GetMembersByPhoneNumberQuery = {
  getMembersByPhoneNumber?:  Array< {
    __typename: "MemberForPhoneNumber",
    id: number,
    userId?: number | null,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
  } | null > | null,
};

export type GetNewMembersForUserQueryVariables = {
  phone: string,
};

export type GetNewMembersForUserQuery = {
  getNewMembersForUser?:  Array< {
    __typename: "MobileMember",
    id: number,
    firstName?: string | null,
    lastName?: string | null,
    phone?: string | null,
    email?: string | null,
    arxReferenceId?: string | null,
    userId?: number | null,
  } | null > | null,
};

export type OnClassPortalUpdateSubscriptionVariables = {
  siteLocationId?: number | null,
};

export type OnClassPortalUpdateSubscription = {
  onClassPortalUpdate?:  Array< {
    __typename: "ClassPortalData",
    id: number,
    importedId: number,
    name: string,
    siteLocationId: number,
    resourceId: number,
    staffId: number,
    startDateTime: string,
    endDateTime: string,
    maxCapacity: number,
    totalBooked: number,
    resourceMindbodyId: number,
    resourceName: string,
    resourceImageUrl?: string | null,
    staffMindbodyId: number,
    staffName: string,
    staffImageUrl?: string | null,
    imageUrl?: string | null,
  } | null > | null,
};

export type OnEmployeeDashboardUpdateSubscriptionVariables = {
  siteLocationId?: number | null,
};

export type OnEmployeeDashboardUpdateSubscription = {
  onEmployeeDashboardUpdate?:  Array< {
    __typename: "KisiEvent",
    id: number,
    siteId: number,
    siteLocationId: number,
    kisiDoorId: number,
    kisiDoorName?: string | null,
    doorOpenMemberEmail: string,
    doorOpenedTime: string,
    accessGranted: boolean,
    accessFailureCode?: string | null,
    accessFailureMessage?: string | null,
    memberId?: number | null,
    createdBy: number,
    createdDate?: string | null,
    lastModifiedBy: number,
    lastModifiedDate?: string | null,
    businessName?: string | null,
    memberName?: string | null,
    memberUniqueId?: string | null,
    memberClientId?: string | null,
    memberStatus?: string | null,
    memberAccountBalance?: number | null,
    memberNote?: string | null,
    memberWaiverStatus?: string | null,
    memberWaiverAgreementDateTime?: string | null,
    memberWaiverGraceUntil?: string | null,
    memberWaiverPolicyEnforced?: boolean | null,
  } | null > | null,
};

export type OnGymKeyEmployeeDashboardUpdateSubscriptionVariables = {
  siteLocationId?: number | null,
};

export type OnGymKeyEmployeeDashboardUpdateSubscription = {
  onGymKeyEmployeeDashboardUpdate?:  Array< {
    __typename: "EmployeeDashboardEvent",
    id: number,
    providerEventId?: string | null,
    accessProvider: string,
    siteId: number,
    siteLocationId: number,
    doorId: number,
    doorName?: string | null,
    memberEmail: string,
    doorOpenedTime: string,
    doorOpenedTimeUtc: string,
    accessGranted: boolean,
    accessFailureCode?: string | null,
    accessFailureMessage?: string | null,
    memberId?: number | null,
    memberName?: string | null,
    memberUniqueId?: string | null,
    memberClientId?: string | null,
    memberStatus?: string | null,
    memberAccountBalance?: number | null,
    memberNote?: string | null,
    memberWaiverStatus?: string | null,
    memberWaiverAgreementDateTime?: string | null,
    memberWaiverGraceUntil?: string | null,
    memberWaiverPolicyEnforced?: boolean | null,
  } | null > | null,
};

export type OnItemAddedSubscription = {
  onItemAdded?:  {
    __typename: "Item",
    id: string,
    type: string,
    price?: number | null,
  } | null,
};

export type OnItemDeletedSubscription = {
  onItemDeleted?:  {
    __typename: "Item",
    id: string,
    type: string,
    price?: number | null,
  } | null,
};

export type OnPushGymVisitEntrySubscriptionVariables = {
  siteLocationId: number,
};

export type OnPushGymVisitEntrySubscription = {
  onPushGymVisitEntry?:  {
    __typename: "GymVisitActivity",
    memberEventId?: number | null,
    memberId?: number | null,
    memberEmail?: string | null,
    eventId?: number | null,
    eventDescription?: string | null,
    eventType?: string | null,
    stageId?: number | null,
    stage?: string | null,
    createdTime?: string | null,
    isAutoAssigned?: boolean | null,
    memberEventStatusTypeId?: number | null,
    memberEventStatusType?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    siteLocationId?: number | null,
    assignedUserId?: number | null,
    assignmentHistoryId?: number | null,
    locationName?: string | null,
    lastModifiedBy?: number | null,
    lastModifiedDate?: string | null,
    inquiryDescription?: string | null,
    memberLocationId?: number | null,
    informationReceivedEvent?: boolean | null,
  } | null,
};
